const AllGeneListMatch = {
    "AAAS": [
        "AAAS_495S"
    ],
    "AAK1": [
        "AAK1_605T"
    ],
    "AATF": [
        "AATF_316S",
        "AATF_320S",
        "AATF_321S"
    ],
    "ABCC1": [
        "ABCC1_930S"
    ],
    "ABCF1": [
        "ABCF1_105S",
        "ABCF1_108T",
        "ABCF1_109S",
        "ABCF1_228S",
        "ABCF1_22S"
    ],
    "ABI1": [
        "ABI1_183S",
        "ABI1_187S",
        "ABI1_225S"
    ],
    "ABLIM1": [
        "ABLIM1_587S",
        "ABLIM1_655S"
    ],
    "ACAD9": [
        "ACAD9_474S"
    ],
    "ACAP2": [
        "ACAP2_186S",
        "ACAP2_379S",
        "ACAP2_382T",
        "ACAP2_521S"
    ],
    "ACBD3": [
        "ACBD3_43S"
    ],
    "ACD": [
        "ACD_24S"
    ],
    "ACIN1": [
        "ACIN1_1004S",
        "ACIN1_1332T",
        "ACIN1_216S",
        "ACIN1_363T",
        "ACIN1_365S",
        "ACIN1_386S",
        "ACIN1_388S",
        "ACIN1_410S",
        "ACIN1_414T",
        "ACIN1_490S",
        "ACIN1_561S",
        "ACIN1_655S",
        "ACIN1_657S",
        "ACIN1_682T",
        "ACIN1_710S",
        "ACIN1_838S",
        "ACIN1_898S"
    ],
    "ACLY": [
        "ACLY_455S",
        "ACLY_481S"
    ],
    "ACSS2": [
        "ACSS2_267S",
        "ACSS2_28S",
        "ACSS2_30S"
    ],
    "ACTG1": [
        "ACTG1_199S",
        "ACTG1_323S",
        "ACTG1_324T",
        "ACTG1_33S",
        "ACTG1_53Y"
    ],
    "ACTN4": [
        "ACTN4_367S"
    ],
    "ACTR8": [
        "ACTR8_132S"
    ],
    "ADAM17": [
        "ADAM17_791S"
    ],
    "ADAM9": [
        "ADAM9_758S",
        "ADAM9_761T"
    ],
    "ADAR": [
        "ADAR_601T",
        "ADAR_614S",
        "ADAR_825S"
    ],
    "ADARB1": [
        "ADARB1_26S"
    ],
    "ADAT1": [
        "ADAT1_191S"
    ],
    "ADCY6": [
        "ADCY6_54S"
    ],
    "ADD1": [
        "ADD1_355S",
        "ADD1_358S",
        "ADD1_366S"
    ],
    "ADD3": [
        "ADD3_677S",
        "ADD3_681S"
    ],
    "ADGRA2": [
        "ADGRA2_1107S"
    ],
    "ADGRL3": [
        "ADGRL3_1419S"
    ],
    "ADNP": [
        "ADNP_608S",
        "ADNP_921S",
        "ADNP_953S",
        "ADNP_955S"
    ],
    "AFAP1": [
        "AFAP1_264S",
        "AFAP1_265S",
        "AFAP1_283S",
        "AFAP1_342S",
        "AFAP1_343S",
        "AFAP1_548S",
        "AFAP1_668S",
        "AFAP1_710S"
    ],
    "AFAP1L2": [
        "AFAP1L2_640S"
    ],
    "AFDN": [
        "AFDN_1083S",
        "AFDN_1172S",
        "AFDN_1173S",
        "AFDN_1182S",
        "AFDN_1275S",
        "AFDN_1721S",
        "AFDN_1779S"
    ],
    "AFF4": [
        "AFF4_1058S",
        "AFF4_703S",
        "AFF4_706S",
        "AFF4_814S",
        "AFF4_836S"
    ],
    "AFTPH": [
        "AFTPH_382S"
    ],
    "AGAP1": [
        "AGAP1_521S"
    ],
    "AGAP3": [
        "AGAP3_538S"
    ],
    "AGO2": [
        "AGO2_387S",
        "AGO2_824S",
        "AGO2_828S",
        "AGO2_831S"
    ],
    "AHCTF1": [
        "AHCTF1_1160S",
        "AHCTF1_1218S",
        "AHCTF1_1222S",
        "AHCTF1_1232S",
        "AHCTF1_1513S",
        "AHCTF1_1533S"
    ],
    "AHDC1": [
        "AHDC1_1064S",
        "AHDC1_1507S",
        "AHDC1_46S"
    ],
    "AHNAK": [
        "AHNAK_1298S",
        "AHNAK_135S",
        "AHNAK_1414S",
        "AHNAK_177S",
        "AHNAK_210S",
        "AHNAK_2138S",
        "AHNAK_216S",
        "AHNAK_2397S",
        "AHNAK_2580S",
        "AHNAK_3054S",
        "AHNAK_3112S",
        "AHNAK_3220S",
        "AHNAK_3412S",
        "AHNAK_3426S",
        "AHNAK_4908S",
        "AHNAK_490T",
        "AHNAK_5031S",
        "AHNAK_5077S",
        "AHNAK_5099S",
        "AHNAK_5110S",
        "AHNAK_511S",
        "AHNAK_5448S",
        "AHNAK_5593S",
        "AHNAK_5731S",
        "AHNAK_5739S",
        "AHNAK_5780S",
        "AHNAK_5782S",
        "AHNAK_5784S",
        "AHNAK_5841S",
        "AHNAK_819S",
        "AHNAK_845S",
        "AHNAK_93S"
    ],
    "AHNAK2": [
        "AHNAK2_1172S",
        "AHNAK2_1253S",
        "AHNAK2_228T",
        "AHNAK2_260S",
        "AHNAK2_294S",
        "AHNAK2_5175S",
        "AHNAK2_5707S",
        "AHNAK2_5714S",
        "AHNAK2_593S",
        "AHNAK2_765S",
        "AHNAK2_842S"
    ],
    "AJUBA": [
        "AJUBA_119S",
        "AJUBA_137S",
        "AJUBA_230S",
        "AJUBA_263S",
        "AJUBA_79S"
    ],
    "AKAP1": [
        "AKAP1_151S",
        "AKAP1_429S",
        "AKAP1_445S",
        "AKAP1_533T"
    ],
    "AKAP11": [
        "AKAP11_1100T",
        "AKAP11_1242S",
        "AKAP11_1485T",
        "AKAP11_1580S",
        "AKAP11_18S"
    ],
    "AKAP13": [
        "AKAP13_1411S",
        "AKAP13_1565S",
        "AKAP13_1602S",
        "AKAP13_2345S",
        "AKAP13_2398S",
        "AKAP13_2498S",
        "AKAP13_2709S",
        "AKAP13_2728S",
        "AKAP13_650S",
        "AKAP13_953T"
    ],
    "AKAP17A": [
        "AKAP17A_537S",
        "AKAP17A_633S"
    ],
    "AKAP2": [
        "AKAP2_135S",
        "AKAP2_152S",
        "AKAP2_393S",
        "AKAP2_630S",
        "AKAP2_748S",
        "AKAP2_778S",
        "AKAP2_780T"
    ],
    "AKAP6": [
        "AKAP6_1073S"
    ],
    "AKAP8": [
        "AKAP8_339S"
    ],
    "AKT1S1": [
        "AKT1S1_183S",
        "AKT1S1_202S",
        "AKT1S1_203S",
        "AKT1S1_212S",
        "AKT1S1_246T",
        "AKT1S1_88S",
        "AKT1S1_90T",
        "AKT1S1_92S"
    ],
    "ALAD": [
        "ALAD_214S"
    ],
    "ALDH3A2": [
        "ALDH3A2_293S"
    ],
    "ALDOA": [
        "ALDOA_100S",
        "ALDOA_36S",
        "ALDOA_39S",
        "ALDOA_46S"
    ],
    "ALG3": [
        "ALG3_11S",
        "ALG3_13S"
    ],
    "ALKBH5": [
        "ALKBH5_64S"
    ],
    "ALS2": [
        "ALS2_1335S",
        "ALS2_353S",
        "ALS2_466S",
        "ALS2_483S",
        "ALS2_492S"
    ],
    "AMFR": [
        "AMFR_542S"
    ],
    "AMPD2": [
        "AMPD2_100S",
        "AMPD2_190S"
    ],
    "ANAPC1": [
        "ANAPC1_688S",
        "ANAPC1_731S"
    ],
    "ANAPC2": [
        "ANAPC2_314S"
    ],
    "ANK2": [
        "ANK2_2718Y",
        "ANK2_2719T",
        "ANK2_2726T",
        "ANK2_31S",
        "ANK2_3793S"
    ],
    "ANK3": [
        "ANK3_1405S",
        "ANK3_4342S"
    ],
    "ANKHD1": [
        "ANKHD1_1679S"
    ],
    "ANKIB1": [
        "ANKIB1_737S"
    ],
    "ANKLE2": [
        "ANKLE2_528S"
    ],
    "ANKRD11": [
        "ANKRD11_1990S",
        "ANKRD11_2374S",
        "ANKRD11_276S",
        "ANKRD11_834S"
    ],
    "ANKRD13D": [
        "ANKRD13D_465S",
        "ANKRD13D_469T"
    ],
    "ANKRD54": [
        "ANKRD54_63S"
    ],
    "ANKS1A": [
        "ANKS1A_318T",
        "ANKS1A_620S",
        "ANKS1A_626S",
        "ANKS1A_628S",
        "ANKS1A_647S"
    ],
    "ANKZF1": [
        "ANKZF1_361S",
        "ANKZF1_56S",
        "ANKZF1_607T"
    ],
    "ANLN": [
        "ANLN_182S",
        "ANLN_323S",
        "ANLN_485S",
        "ANLN_658S",
        "ANLN_792S"
    ],
    "ANO6": [
        "ANO6_256S",
        "ANO6_909S"
    ],
    "ANP32A": [
        "ANP32A_15T"
    ],
    "ANP32B": [
        "ANP32B_15T",
        "ANP32B_244T"
    ],
    "ANTXR1": [
        "ANTXR1_362S",
        "ANTXR1_563S"
    ],
    "ANXA2": [
        "ANXA2_112S",
        "ANXA2_127S",
        "ANXA2_12S",
        "ANXA2_184S",
        "ANXA2_18S",
        "ANXA2_19T",
        "ANXA2_2S",
        "ANXA2_3T",
        "ANXA2_85S"
    ],
    "AP1AR": [
        "AP1AR_228T"
    ],
    "AP1M1": [
        "AP1M1_223T"
    ],
    "AP3B1": [
        "AP3B1_276S",
        "AP3B1_750S",
        "AP3B1_752S"
    ],
    "AP3D1": [
        "AP3D1_829S"
    ],
    "APBA1": [
        "APBA1_242S",
        "APBA1_568S"
    ],
    "APBA3": [
        "APBA3_9S"
    ],
    "APC": [
        "APC_1438T",
        "APC_2674S"
    ],
    "APEH": [
        "APEH_185S"
    ],
    "API5": [
        "API5_464S"
    ],
    "APIP": [
        "APIP_87S",
        "APIP_89S"
    ],
    "APTX": [
        "APTX_132S"
    ],
    "AR": [
        "AR_96S"
    ],
    "ARAP1": [
        "ARAP1_229S"
    ],
    "ARAP3": [
        "ARAP3_1444S"
    ],
    "ARFGAP1": [
        "ARFGAP1_135T",
        "ARFGAP1_189T"
    ],
    "ARFGEF1": [
        "ARFGEF1_52S"
    ],
    "ARFGEF2": [
        "ARFGEF2_227S",
        "ARFGEF2_277S",
        "ARFGEF2_349S"
    ],
    "ARHGAP1": [
        "ARHGAP1_27S",
        "ARHGAP1_35S",
        "ARHGAP1_50S",
        "ARHGAP1_51S"
    ],
    "ARHGAP17": [
        "ARHGAP17_162S",
        "ARHGAP17_575S"
    ],
    "ARHGAP21": [
        "ARHGAP21_1096S",
        "ARHGAP21_1099S",
        "ARHGAP21_1432S",
        "ARHGAP21_1433S",
        "ARHGAP21_1514S",
        "ARHGAP21_1605S",
        "ARHGAP21_1669S",
        "ARHGAP21_881S"
    ],
    "ARHGAP24": [
        "ARHGAP24_415S"
    ],
    "ARHGAP26": [
        "ARHGAP26_588S"
    ],
    "ARHGAP31": [
        "ARHGAP31_954S"
    ],
    "ARHGAP32": [
        "ARHGAP32_871S",
        "ARHGAP32_952S"
    ],
    "ARHGAP35": [
        "ARHGAP35_1179S",
        "ARHGAP35_770S"
    ],
    "ARHGAP5": [
        "ARHGAP5_1171T",
        "ARHGAP5_1195S",
        "ARHGAP5_1217T",
        "ARHGAP5_289T"
    ],
    "ARHGEF1": [
        "ARHGEF1_10S",
        "ARHGEF1_631S",
        "ARHGEF1_776S",
        "ARHGEF1_798S"
    ],
    "ARHGEF10": [
        "ARHGEF10_379S"
    ],
    "ARHGEF11": [
        "ARHGEF11_1295S",
        "ARHGEF11_1413S",
        "ARHGEF11_1480S",
        "ARHGEF11_254T",
        "ARHGEF11_255S",
        "ARHGEF11_592S",
        "ARHGEF11_663S",
        "ARHGEF11_668T"
    ],
    "ARHGEF12": [
        "ARHGEF12_1288S",
        "ARHGEF12_1389S",
        "ARHGEF12_309S",
        "ARHGEF12_341S",
        "ARHGEF12_736T"
    ],
    "ARHGEF16": [
        "ARHGEF16_107S",
        "ARHGEF16_230S"
    ],
    "ARHGEF17": [
        "ARHGEF17_170T",
        "ARHGEF17_81S",
        "ARHGEF17_862S"
    ],
    "ARHGEF18": [
        "ARHGEF18_1202S",
        "ARHGEF18_1289S",
        "ARHGEF18_1291S",
        "ARHGEF18_948S"
    ],
    "ARHGEF2": [
        "ARHGEF2_645S",
        "ARHGEF2_696S",
        "ARHGEF2_932S",
        "ARHGEF2_956S",
        "ARHGEF2_960S"
    ],
    "ARHGEF28": [
        "ARHGEF28_1538S"
    ],
    "ARHGEF35": [
        "ARHGEF35_445S"
    ],
    "ARHGEF5": [
        "ARHGEF5_1003S",
        "ARHGEF5_1004S",
        "ARHGEF5_1125S",
        "ARHGEF5_11S",
        "ARHGEF5_450S"
    ],
    "ARHGEF6": [
        "ARHGEF6_225S",
        "ARHGEF6_684S"
    ],
    "ARHGEF7": [
        "ARHGEF7_249S",
        "ARHGEF7_694S"
    ],
    "ARID1A": [
        "ARID1A_1751S",
        "ARID1A_1754S",
        "ARID1A_1755S"
    ],
    "ARID4A": [
        "ARID4A_1109S",
        "ARID4A_538S",
        "ARID4A_542S",
        "ARID4A_863S",
        "ARID4A_864S"
    ],
    "ARID5B": [
        "ARID5B_1002S",
        "ARID5B_1032S",
        "ARID5B_264S",
        "ARID5B_539T"
    ],
    "ARL6IP4": [
        "ARL6IP4_332S"
    ],
    "ARL6IP6": [
        "ARL6IP6_80S"
    ],
    "ARMCX3": [
        "ARMCX3_110S",
        "ARMCX3_61S"
    ],
    "ARNT": [
        "ARNT_77S"
    ],
    "ARRB1": [
        "ARRB1_412S"
    ],
    "ARVCF": [
        "ARVCF_343S",
        "ARVCF_642T"
    ],
    "ASAP1": [
        "ASAP1_717S",
        "ASAP1_839S",
        "ASAP1_843S",
        "ASAP1_910S"
    ],
    "ASAP2": [
        "ASAP2_701S",
        "ASAP2_822S"
    ],
    "ASCC2": [
        "ASCC2_233T"
    ],
    "ASF1A": [
        "ASF1A_166S"
    ],
    "ASMTL": [
        "ASMTL_21S"
    ],
    "ASPH": [
        "ASPH_29S"
    ],
    "ASPSCR1": [
        "ASPSCR1_275S",
        "ASPSCR1_500S",
        "ASPSCR1_502S"
    ],
    "ASS1": [
        "ASS1_174T",
        "ASS1_219T"
    ],
    "ASXL2": [
        "ASXL2_524S"
    ],
    "ATAD5": [
        "ATAD5_1222S"
    ],
    "ATE1": [
        "ATE1_169S"
    ],
    "ATF7IP": [
        "ATF7IP_113S",
        "ATF7IP_445S",
        "ATF7IP_477S",
        "ATF7IP_557S",
        "ATF7IP_559S",
        "ATF7IP_673S"
    ],
    "ATG13": [
        "ATG13_361S"
    ],
    "ATG2B": [
        "ATG2B_1743S",
        "ATG2B_239S",
        "ATG2B_240S",
        "ATG2B_255S"
    ],
    "ATG9A": [
        "ATG9A_656S",
        "ATG9A_735S",
        "ATG9A_738S",
        "ATG9A_761S",
        "ATG9A_828S"
    ],
    "ATL3": [
        "ATL3_535S"
    ],
    "ATN1": [
        "ATN1_630T",
        "ATN1_645S",
        "ATN1_653T",
        "ATN1_661S",
        "ATN1_676T"
    ],
    "ATP10D": [
        "ATP10D_613S"
    ],
    "ATP11C": [
        "ATP11C_1108S",
        "ATP11C_1124T"
    ],
    "ATP13A3": [
        "ATP13A3_817S"
    ],
    "ATP13A5": [
        "ATP13A5_342Y"
    ],
    "ATP8A1": [
        "ATP8A1_25S",
        "ATP8A1_28T",
        "ATP8A1_29S"
    ],
    "ATR": [
        "ATR_1989T",
        "ATR_435S",
        "ATR_436S"
    ],
    "ATRIP": [
        "ATRIP_224S"
    ],
    "ATRX": [
        "ATRX_1061S",
        "ATRX_1348S",
        "ATRX_1352S",
        "ATRX_1992S",
        "ATRX_1996S",
        "ATRX_598S",
        "ATRX_675S",
        "ATRX_677S",
        "ATRX_729S",
        "ATRX_731S",
        "ATRX_849S",
        "ATRX_850S",
        "ATRX_875S"
    ],
    "ATXN2": [
        "ATXN2_741T",
        "ATXN2_772S"
    ],
    "ATXN2L": [
        "ATXN2L_111S",
        "ATXN2L_168S",
        "ATXN2L_31T",
        "ATXN2L_339S",
        "ATXN2L_559S",
        "ATXN2L_594S",
        "ATXN2L_634S",
        "ATXN2L_684S"
    ],
    "AUP1": [
        "AUP1_288S"
    ],
    "AZI2": [
        "AZI2_343S"
    ],
    "BABAM1": [
        "BABAM1_29S",
        "BABAM1_49S"
    ],
    "BACH1": [
        "BACH1_387S"
    ],
    "BAD": [
        "BAD_118S",
        "BAD_134S",
        "BAD_99S"
    ],
    "BAG3": [
        "BAG3_377S",
        "BAG3_381S",
        "BAG3_385S",
        "BAG3_386S",
        "BAG3_406T"
    ],
    "BAG6": [
        "BAG6_1080T",
        "BAG6_1081S",
        "BAG6_1117S",
        "BAG6_964S",
        "BAG6_973S"
    ],
    "BAIAP2L1": [
        "BAIAP2L1_351T"
    ],
    "BAP1": [
        "BAP1_597S"
    ],
    "BASP1": [
        "BASP1_36T"
    ],
    "BAZ1A": [
        "BAZ1A_1413S",
        "BAZ1A_731T"
    ],
    "BAZ1B": [
        "BAZ1B_1342S",
        "BAZ1B_1468S",
        "BAZ1B_158S",
        "BAZ1B_160S",
        "BAZ1B_161S"
    ],
    "BAZ2A": [
        "BAZ2A_1770S"
    ],
    "BBS10": [
        "BBS10_719S"
    ],
    "BCAR1": [
        "BCAR1_428S",
        "BCAR1_639S"
    ],
    "BCAS3": [
        "BCAS3_570S"
    ],
    "BCKDK": [
        "BCKDK_31S"
    ],
    "BCL10": [
        "BCL10_138S"
    ],
    "BCL11A": [
        "BCL11A_328S",
        "BCL11A_608S",
        "BCL11A_630S",
        "BCL11A_701T",
        "BCL11A_86S"
    ],
    "BCL2L12": [
        "BCL2L12_242S",
        "BCL2L12_273S"
    ],
    "BCL2L13": [
        "BCL2L13_426S"
    ],
    "BCL3": [
        "BCL3_374S",
        "BCL3_382S",
        "BCL3_41S"
    ],
    "BCL7C": [
        "BCL7C_114S",
        "BCL7C_126S"
    ],
    "BCL9L": [
        "BCL9L_116S",
        "BCL9L_118S",
        "BCL9L_21S",
        "BCL9L_25S",
        "BCL9L_88S",
        "BCL9L_947S"
    ],
    "BCLAF1": [
        "BCLAF1_177S",
        "BCLAF1_222S",
        "BCLAF1_264S",
        "BCLAF1_268S",
        "BCLAF1_285S",
        "BCLAF1_290S",
        "BCLAF1_297S",
        "BCLAF1_385S",
        "BCLAF1_397S",
        "BCLAF1_496S",
        "BCLAF1_512S",
        "BCLAF1_531S",
        "BCLAF1_648S",
        "BCLAF1_658S",
        "BCLAF1_690S",
        "BCLAF1_760S"
    ],
    "BCLAF3": [
        "BCLAF3_139S"
    ],
    "BCOR": [
        "BCOR_423S"
    ],
    "BDKRB2": [
        "BDKRB2_375S"
    ],
    "BICC1": [
        "BICC1_637S",
        "BICC1_766S"
    ],
    "BICD2": [
        "BICD2_582S",
        "BICD2_615S"
    ],
    "BICRA": [
        "BICRA_919S"
    ],
    "BICRAL": [
        "BICRAL_934S"
    ],
    "BIN1": [
        "BIN1_296S",
        "BIN1_298S",
        "BIN1_303S"
    ],
    "BIRC6": [
        "BIRC6_473S",
        "BIRC6_480S",
        "BIRC6_482S",
        "BIRC6_590S"
    ],
    "BLNK": [
        "BLNK_129S"
    ],
    "BLOC1S3": [
        "BLOC1S3_63T",
        "BLOC1S3_65S"
    ],
    "BLZF1": [
        "BLZF1_15S"
    ],
    "BMP2K": [
        "BMP2K_1014T"
    ],
    "BNIP2": [
        "BNIP2_114S"
    ],
    "BNIP3": [
        "BNIP3_151S"
    ],
    "BOD1L1": [
        "BOD1L1_1531S",
        "BOD1L1_2203S",
        "BOD1L1_3019S",
        "BOD1L1_3029S",
        "BOD1L1_482S",
        "BOD1L1_537S",
        "BOD1L1_538S"
    ],
    "BOP1": [
        "BOP1_126S",
        "BOP1_127S"
    ],
    "BPTF": [
        "BPTF_1300S",
        "BPTF_216S",
        "BPTF_572S"
    ],
    "BRAF": [
        "BRAF_151S",
        "BRAF_401T",
        "BRAF_729S"
    ],
    "BRAP": [
        "BRAP_117S",
        "BRAP_97S"
    ],
    "BRD1": [
        "BRD1_1052S",
        "BRD1_1055S",
        "BRD1_128S",
        "BRD1_814S",
        "BRD1_885T"
    ],
    "BRD3": [
        "BRD3_263S",
        "BRD3_455S"
    ],
    "BRD4": [
        "BRD4_1045S",
        "BRD4_1117S",
        "BRD4_470S",
        "BRD4_601S"
    ],
    "BRD8": [
        "BRD8_387S"
    ],
    "BRD9": [
        "BRD9_566S"
    ],
    "BRF2": [
        "BRF2_353S"
    ],
    "BRI3BP": [
        "BRI3BP_248S"
    ],
    "BRMS1": [
        "BRMS1_237S"
    ],
    "BRMS1L": [
        "BRMS1L_197S"
    ],
    "BRPF1": [
        "BRPF1_460S",
        "BRPF1_462S",
        "BRPF1_75S"
    ],
    "BRWD1": [
        "BRWD1_1678S"
    ],
    "BSG": [
        "BSG_362S",
        "BSG_367S"
    ],
    "BUB1B": [
        "BUB1B_1043S",
        "BUB1B_670S"
    ],
    "BUB3": [
        "BUB3_211S",
        "BUB3_328T"
    ],
    "BUD13": [
        "BUD13_197S",
        "BUD13_201S",
        "BUD13_248S"
    ],
    "BYSL": [
        "BYSL_98S"
    ],
    "BZW2": [
        "BZW2_412S",
        "BZW2_414S"
    ],
    "C11orf68": [
        "C11orf68_53S"
    ],
    "C12orf45": [
        "C12orf45_14S"
    ],
    "C17orf102": [
        "C17orf102_64S"
    ],
    "C19orf44": [
        "C19orf44_336S"
    ],
    "C1orf131": [
        "C1orf131_142T"
    ],
    "C1orf21": [
        "C1orf21_115S"
    ],
    "C5orf30": [
        "C5orf30_167S"
    ],
    "C7orf50": [
        "C7orf50_175S",
        "C7orf50_59S"
    ],
    "C9orf40": [
        "C9orf40_76S"
    ],
    "C9orf78": [
        "C9orf78_15S",
        "C9orf78_17S",
        "C9orf78_261S"
    ],
    "CAAP1": [
        "CAAP1_203S",
        "CAAP1_312S"
    ],
    "CABIN1": [
        "CABIN1_2151T",
        "CABIN1_2154T"
    ],
    "CACTIN": [
        "CACTIN_489S"
    ],
    "CAD": [
        "CAD_1037T",
        "CAD_1038S",
        "CAD_1406S",
        "CAD_1833T",
        "CAD_1859S"
    ],
    "CADPS2": [
        "CADPS2_58S"
    ],
    "CALCOCO2": [
        "CALCOCO2_445S"
    ],
    "CALD1": [
        "CALD1_789S"
    ],
    "CAMK4": [
        "CAMK4_200T",
        "CAMK4_356S",
        "CAMK4_360S"
    ],
    "CAMKK2": [
        "CAMKK2_511S"
    ],
    "CAMSAP1": [
        "CAMSAP1_1080S"
    ],
    "CAMSAP2": [
        "CAMSAP2_1019S",
        "CAMSAP2_1148S",
        "CAMSAP2_1319S",
        "CAMSAP2_599S",
        "CAMSAP2_844S"
    ],
    "CANT1": [
        "CANT1_21S"
    ],
    "CANX": [
        "CANX_554S",
        "CANX_562T",
        "CANX_564S",
        "CANX_583S"
    ],
    "CAP1": [
        "CAP1_308S",
        "CAP1_310S",
        "CAP1_34S"
    ],
    "CAP2": [
        "CAP2_309S",
        "CAP2_311T"
    ],
    "CAPN2": [
        "CAPN2_464T"
    ],
    "CARHSP1": [
        "CARHSP1_30S"
    ],
    "CARMIL1": [
        "CARMIL1_122S",
        "CARMIL1_916T"
    ],
    "CARS": [
        "CARS_19S",
        "CARS_36T"
    ],
    "CASC3": [
        "CASC3_148S",
        "CASC3_265S",
        "CASC3_45S"
    ],
    "CAST": [
        "CAST_243S",
        "CAST_364S",
        "CAST_366S",
        "CAST_561S"
    ],
    "CAV1": [
        "CAV1_37S"
    ],
    "CAV2": [
        "CAV2_36S"
    ],
    "CAVIN1": [
        "CAVIN1_167S",
        "CAVIN1_40S"
    ],
    "CAVIN2": [
        "CAVIN2_288S",
        "CAVIN2_293S"
    ],
    "CAVIN3": [
        "CAVIN3_165S",
        "CAVIN3_166S"
    ],
    "CBL": [
        "CBL_483S",
        "CBL_486S",
        "CBL_619S",
        "CBL_669S"
    ],
    "CBX3": [
        "CBX3_176S",
        "CBX3_93S",
        "CBX3_95S",
        "CBX3_97S",
        "CBX3_99S"
    ],
    "CBX4": [
        "CBX4_415S",
        "CBX4_442S"
    ],
    "CC2D1A": [
        "CC2D1A_120T",
        "CC2D1A_455S",
        "CC2D1A_460T"
    ],
    "CCAR2": [
        "CCAR2_627S",
        "CCAR2_678S"
    ],
    "CCDC14": [
        "CCDC14_798S"
    ],
    "CCDC167": [
        "CCDC167_42S"
    ],
    "CCDC25": [
        "CCDC25_204S"
    ],
    "CCDC82": [
        "CCDC82_131S"
    ],
    "CCDC86": [
        "CCDC86_113S",
        "CCDC86_18S",
        "CCDC86_47S",
        "CCDC86_91S"
    ],
    "CCDC88A": [
        "CCDC88A_1387S",
        "CCDC88A_1652S",
        "CCDC88A_1653S",
        "CCDC88A_1820S"
    ],
    "CCDC9": [
        "CCDC9_80S"
    ],
    "CCDC97": [
        "CCDC97_212S"
    ],
    "CCDC9B": [
        "CCDC9B_55S"
    ],
    "CCM2": [
        "CCM2_384S"
    ],
    "CCNK": [
        "CCNK_324S",
        "CCNK_328S",
        "CCNK_329S",
        "CCNK_340S"
    ],
    "CCNL1": [
        "CCNL1_335S",
        "CCNL1_338S",
        "CCNL1_341S",
        "CCNL1_342S",
        "CCNL1_352S"
    ],
    "CCNL2": [
        "CCNL2_338S",
        "CCNL2_348S",
        "CCNL2_369S"
    ],
    "CCNY": [
        "CCNY_100S",
        "CCNY_326S",
        "CCNY_336S"
    ],
    "CCNYL1": [
        "CCNYL1_344S"
    ],
    "CCP110": [
        "CCP110_372S",
        "CCP110_641S"
    ],
    "CCPG1": [
        "CCPG1_186S"
    ],
    "CCT4": [
        "CCT4_381S"
    ],
    "CCT8": [
        "CCT8_537S"
    ],
    "CCZ1": [
        "CCZ1_266S"
    ],
    "CD248": [
        "CD248_746S"
    ],
    "CD274": [
        "CD274_283S",
        "CD274_290T"
    ],
    "CD276": [
        "CD276_523S",
        "CD276_525S"
    ],
    "CD2AP": [
        "CD2AP_510S",
        "CD2AP_512T",
        "CD2AP_514S",
        "CD2AP_582S"
    ],
    "CD2BP2": [
        "CD2BP2_195S",
        "CD2BP2_49S"
    ],
    "CD3EAP": [
        "CD3EAP_136S"
    ],
    "CD44": [
        "CD44_183S",
        "CD44_686S",
        "CD44_697S",
        "CD44_706S",
        "CD44_717S"
    ],
    "CD97": [
        "CD97_831S"
    ],
    "CDC25B": [
        "CDC25B_160S",
        "CDC25B_249S",
        "CDC25B_321S",
        "CDC25B_353S"
    ],
    "CDC26": [
        "CDC26_82S"
    ],
    "CDC40": [
        "CDC40_43S"
    ],
    "CDC42EP1": [
        "CDC42EP1_192S"
    ],
    "CDC5L": [
        "CDC5L_424T"
    ],
    "CDCA3": [
        "CDCA3_68S",
        "CDCA3_87S"
    ],
    "CDH10": [
        "CDH10_646S"
    ],
    "CDK11A": [
        "CDK11A_271S",
        "CDK11A_47S",
        "CDK11A_577S",
        "CDK11A_739T",
        "CDK11A_740S"
    ],
    "CDK12": [
        "CDK12_1083S",
        "CDK12_1244T",
        "CDK12_1246T",
        "CDK12_332S",
        "CDK12_334S",
        "CDK12_383S",
        "CDK12_385S",
        "CDK12_423S",
        "CDK12_681S",
        "CDK12_685S",
        "CDK12_692T",
        "CDK12_893T"
    ],
    "CDK13": [
        "CDK13_1246T",
        "CDK13_397S",
        "CDK13_662S",
        "CDK13_664S",
        "CDK13_871T"
    ],
    "CDK14": [
        "CDK14_119S",
        "CDK14_95S"
    ],
    "CDK18": [
        "CDK18_132S",
        "CDK18_89S",
        "CDK18_98S"
    ],
    "CDR2L": [
        "CDR2L_154T",
        "CDR2L_157T",
        "CDR2L_179S"
    ],
    "CDS2": [
        "CDS2_21S",
        "CDS2_33S"
    ],
    "CDT1": [
        "CDT1_318S"
    ],
    "CEBPZ": [
        "CEBPZ_629S"
    ],
    "CELF1": [
        "CELF1_28S"
    ],
    "CENPA": [
        "CENPA_17S",
        "CENPA_19S"
    ],
    "CEP112": [
        "CEP112_171S",
        "CEP112_173S"
    ],
    "CEP164": [
        "CEP164_472S"
    ],
    "CEP170": [
        "CEP170_356S",
        "CEP170_359S",
        "CEP170_379S"
    ],
    "CEP170B": [
        "CEP170B_1545S",
        "CEP170B_1548S",
        "CEP170B_360S",
        "CEP170B_597S",
        "CEP170B_853S"
    ],
    "CEP192": [
        "CEP192_1755S",
        "CEP192_565S"
    ],
    "CEP72": [
        "CEP72_404S"
    ],
    "CEP76": [
        "CEP76_83S"
    ],
    "CEP89": [
        "CEP89_40S",
        "CEP89_44S"
    ],
    "CEP97": [
        "CEP97_500S"
    ],
    "CERS2": [
        "CERS2_341S",
        "CERS2_348S",
        "CERS2_349S"
    ],
    "CERT": [
        "CERT_123S",
        "CERT_126S"
    ],
    "CETN2": [
        "CETN2_20S"
    ],
    "CFL1": [
        "CFL1_156S",
        "CFL1_24S",
        "CFL1_25T"
    ],
    "CGNL1": [
        "CGNL1_283S"
    ],
    "CHAF1A": [
        "CHAF1A_772S",
        "CHAF1A_951S"
    ],
    "CHAF1B": [
        "CHAF1B_410S",
        "CHAF1B_429S",
        "CHAF1B_432T"
    ],
    "CHAMP1": [
        "CHAMP1_108S",
        "CHAMP1_204S",
        "CHAMP1_214S",
        "CHAMP1_275S",
        "CHAMP1_282S",
        "CHAMP1_284S",
        "CHAMP1_286S",
        "CHAMP1_308S",
        "CHAMP1_319S",
        "CHAMP1_386S",
        "CHAMP1_405S",
        "CHAMP1_416S",
        "CHAMP1_427S",
        "CHAMP1_432S",
        "CHAMP1_436S",
        "CHAMP1_445S",
        "CHAMP1_476S",
        "CHAMP1_507S",
        "CHAMP1_542S",
        "CHAMP1_626S",
        "CHAMP1_87S"
    ],
    "CHCHD3": [
        "CHCHD3_50S"
    ],
    "CHD1": [
        "CHD1_215S",
        "CHD1_216S"
    ],
    "CHD2": [
        "CHD2_1108S",
        "CHD2_1364S",
        "CHD2_207S",
        "CHD2_208S"
    ],
    "CHD3": [
        "CHD3_1541T",
        "CHD3_1549S",
        "CHD3_1601S",
        "CHD3_597S",
        "CHD3_713S",
        "CHD3_73S"
    ],
    "CHD4": [
        "CHD4_103S",
        "CHD4_105S",
        "CHD4_108S",
        "CHD4_1531S",
        "CHD4_1535S",
        "CHD4_1537S",
        "CHD4_1540T",
        "CHD4_1542T",
        "CHD4_1545T",
        "CHD4_1553T",
        "CHD4_1570S",
        "CHD4_1602S",
        "CHD4_1653T",
        "CHD4_515S",
        "CHD4_517T",
        "CHD4_529T",
        "CHD4_703T"
    ],
    "CHD8": [
        "CHD8_1995S",
        "CHD8_2046S"
    ],
    "CHERP": [
        "CHERP_813S",
        "CHERP_815S",
        "CHERP_817S",
        "CHERP_819T"
    ],
    "CHIC2": [
        "CHIC2_159T"
    ],
    "CHL1": [
        "CHL1_1137S",
        "CHL1_1147S"
    ],
    "CHMP2B": [
        "CHMP2B_190S",
        "CHMP2B_199S"
    ],
    "CHP1": [
        "CHP1_6S",
        "CHP1_7T"
    ],
    "CHPF2": [
        "CHPF2_64S"
    ],
    "CHTF18": [
        "CHTF18_871S"
    ],
    "CIAPIN1": [
        "CIAPIN1_183S"
    ],
    "CIC": [
        "CIC_1245S",
        "CIC_1246S"
    ],
    "CIT": [
        "CIT_440S"
    ],
    "CLASP1": [
        "CLASP1_1223S",
        "CLASP1_598S",
        "CLASP1_600S"
    ],
    "CLCC1": [
        "CLCC1_438S"
    ],
    "CLDN1": [
        "CLDN1_205S",
        "CLDN1_206S"
    ],
    "CLINT1": [
        "CLINT1_227S",
        "CLINT1_232S",
        "CLINT1_234S"
    ],
    "CLIP1": [
        "CLIP1_1009S",
        "CLIP1_182T",
        "CLIP1_204S"
    ],
    "CLIP2": [
        "CLIP2_207S",
        "CLIP2_294S",
        "CLIP2_352S",
        "CLIP2_354T",
        "CLIP2_923S"
    ],
    "CLK3": [
        "CLK3_215S"
    ],
    "CLK4": [
        "CLK4_136S",
        "CLK4_138S"
    ],
    "CLMP": [
        "CLMP_358T",
        "CLMP_359T"
    ],
    "CLN3": [
        "CLN3_12S"
    ],
    "CLN6": [
        "CLN6_31S",
        "CLN6_33S"
    ],
    "CLNS1A": [
        "CLNS1A_102S"
    ],
    "CLOCK": [
        "CLOCK_461T"
    ],
    "CLPP": [
        "CLPP_276S",
        "CLPP_277T"
    ],
    "CLVS1": [
        "CLVS1_10Y",
        "CLVS1_15T"
    ],
    "CMTR1": [
        "CMTR1_53S"
    ],
    "CNOT2": [
        "CNOT2_165S",
        "CNOT2_170S"
    ],
    "COASY": [
        "COASY_178S",
        "COASY_183S"
    ],
    "COBLL1": [
        "COBLL1_326S",
        "COBLL1_947S"
    ],
    "COG1": [
        "COG1_459S"
    ],
    "COG3": [
        "COG3_533S"
    ],
    "COG4": [
        "COG4_6S"
    ],
    "COG5": [
        "COG5_197S",
        "COG5_49S"
    ],
    "COG7": [
        "COG7_506S"
    ],
    "COIL": [
        "COIL_122T",
        "COIL_566S"
    ],
    "COL19A1": [
        "COL19A1_81S"
    ],
    "COL6A3": [
        "COL6A3_1783S"
    ],
    "COPB2": [
        "COPB2_859S"
    ],
    "COPE": [
        "COPE_13S",
        "COPE_99S"
    ],
    "COPRS": [
        "COPRS_66S"
    ],
    "COPS3": [
        "COPS3_421S"
    ],
    "CORO7": [
        "CORO7_21S",
        "CORO7_462S"
    ],
    "CPNE3": [
        "CPNE3_242S",
        "CPNE3_243S"
    ],
    "CROCC": [
        "CROCC_1460S"
    ],
    "CRY2": [
        "CRY2_558S"
    ],
    "CRYBG1": [
        "CRYBG1_525T"
    ],
    "CRYBG3": [
        "CRYBG3_1934S"
    ],
    "CSNK1E": [
        "CSNK1E_363S"
    ],
    "CSTF2": [
        "CSTF2_524S"
    ],
    "CTDP1": [
        "CTDP1_869S",
        "CTDP1_872S"
    ],
    "CTIF": [
        "CTIF_18S",
        "CTIF_299S"
    ],
    "CTNNA1": [
        "CTNNA1_641S",
        "CTNNA1_652S",
        "CTNNA1_654T",
        "CTNNA1_655S",
        "CTNNA1_658T"
    ],
    "CTNND1": [
        "CTNND1_346S",
        "CTNND1_349S",
        "CTNND1_352S",
        "CTNND1_47S",
        "CTNND1_861S",
        "CTNND1_864S",
        "CTNND1_920S"
    ],
    "CTPS2": [
        "CTPS2_568S",
        "CTPS2_571S"
    ],
    "CTR9": [
        "CTR9_1021S",
        "CTR9_1085S",
        "CTR9_1097S",
        "CTR9_970S"
    ],
    "CTTN": [
        "CTTN_113S",
        "CTTN_401T",
        "CTTN_405S",
        "CTTN_418S"
    ],
    "CTU2": [
        "CTU2_508S"
    ],
    "CUL4A": [
        "CUL4A_10S"
    ],
    "CUL4B": [
        "CUL4B_49T"
    ],
    "CUSTOS": [
        "CUSTOS_138S"
    ],
    "CUX1": [
        "CUX1_1270S"
    ],
    "CWC22": [
        "CWC22_28S",
        "CWC22_39S"
    ],
    "CWC25": [
        "CWC25_217S"
    ],
    "CWF19L2": [
        "CWF19L2_479S"
    ],
    "CXorf38": [
        "CXorf38_314T"
    ],
    "DAB2IP": [
        "DAB2IP_702S",
        "DAB2IP_747S",
        "DAB2IP_978S"
    ],
    "DARS2": [
        "DARS2_441T"
    ],
    "DAXX": [
        "DAXX_495S",
        "DAXX_668S",
        "DAXX_671S"
    ],
    "DBN1": [
        "DBN1_141S",
        "DBN1_142S",
        "DBN1_337S",
        "DBN1_339S",
        "DBN1_381S"
    ],
    "DBNL": [
        "DBNL_232S",
        "DBNL_283S",
        "DBNL_291T"
    ],
    "DCAF10": [
        "DCAF10_63S"
    ],
    "DCAF5": [
        "DCAF5_794S"
    ],
    "DCAF6": [
        "DCAF6_336S",
        "DCAF6_654T",
        "DCAF6_657S",
        "DCAF6_850S"
    ],
    "DCAF8": [
        "DCAF8_129S",
        "DCAF8_130S",
        "DCAF8_99S"
    ],
    "DCLK1": [
        "DCLK1_307S",
        "DCLK1_337S"
    ],
    "DCP1A": [
        "DCP1A_525S",
        "DCP1A_539S"
    ],
    "DCP1B": [
        "DCP1B_283S"
    ],
    "DCTN2": [
        "DCTN2_320S"
    ],
    "DCUN1D4": [
        "DCUN1D4_71S"
    ],
    "DDA1": [
        "DDA1_33S",
        "DDA1_95S"
    ],
    "DDB2": [
        "DDB2_24S",
        "DDB2_26S"
    ],
    "DDX1": [
        "DDX1_481S"
    ],
    "DDX10": [
        "DDX10_10S"
    ],
    "DDX20": [
        "DDX20_677S",
        "DDX20_703S"
    ],
    "DDX21": [
        "DDX21_121S",
        "DDX21_13S",
        "DDX21_71S",
        "DDX21_89S"
    ],
    "DDX23": [
        "DDX23_107S",
        "DDX23_109S",
        "DDX23_14S",
        "DDX23_16S"
    ],
    "DDX24": [
        "DDX24_82S",
        "DDX24_94S"
    ],
    "DDX42": [
        "DDX42_185S"
    ],
    "DDX50": [
        "DDX50_41S"
    ],
    "DDX51": [
        "DDX51_83S"
    ],
    "DDX54": [
        "DDX54_75S",
        "DDX54_782S"
    ],
    "DEAF1": [
        "DEAF1_176S"
    ],
    "DEK": [
        "DEK_231S",
        "DEK_232S",
        "DEK_243S",
        "DEK_244S",
        "DEK_251S",
        "DEK_301S",
        "DEK_303S",
        "DEK_306S",
        "DEK_307S",
        "DEK_32S"
    ],
    "DENND1A": [
        "DENND1A_707T"
    ],
    "DENND4A": [
        "DENND4A_1015S",
        "DENND4A_1223T",
        "DENND4A_1240S",
        "DENND4A_1589S"
    ],
    "DENND4B": [
        "DENND4B_736S"
    ],
    "DENND4C": [
        "DENND4C_1640S",
        "DENND4C_741S"
    ],
    "DENND5A": [
        "DENND5A_1079T",
        "DENND5A_1085S"
    ],
    "DENND5B": [
        "DENND5B_833S"
    ],
    "DENND6A": [
        "DENND6A_127S"
    ],
    "DENR": [
        "DENR_73S"
    ],
    "DEPTOR": [
        "DEPTOR_265S"
    ],
    "DFFA": [
        "DFFA_315S"
    ],
    "DGCR8": [
        "DGCR8_373S",
        "DGCR8_377S"
    ],
    "DGKH": [
        "DGKH_318S"
    ],
    "DHCR7": [
        "DHCR7_14S"
    ],
    "DHX16": [
        "DHX16_103S",
        "DHX16_106S",
        "DHX16_160S"
    ],
    "DHX29": [
        "DHX29_200S"
    ],
    "DHX30": [
        "DHX30_226S"
    ],
    "DHX34": [
        "DHX34_749S",
        "DHX34_750S"
    ],
    "DHX8": [
        "DHX8_460S"
    ],
    "DIAPH1": [
        "DIAPH1_22S"
    ],
    "DIDO1": [
        "DIDO1_1040S",
        "DIDO1_1255T",
        "DIDO1_1256T",
        "DIDO1_1260S",
        "DIDO1_1456S",
        "DIDO1_151T",
        "DIDO1_152S",
        "DIDO1_154S",
        "DIDO1_1714S",
        "DIDO1_805S"
    ],
    "DIS3L2": [
        "DIS3L2_875S"
    ],
    "DISP2": [
        "DISP2_1175S",
        "DISP2_1252S"
    ],
    "DKC1": [
        "DKC1_451S",
        "DKC1_453S",
        "DKC1_455S",
        "DKC1_458T",
        "DKC1_494S",
        "DKC1_513S"
    ],
    "DLC1": [
        "DLC1_523S",
        "DLC1_526S"
    ],
    "DLG5": [
        "DLG5_1011T",
        "DLG5_1232S",
        "DLG5_1666S",
        "DLG5_295S"
    ],
    "DLGAP4": [
        "DLGAP4_665S",
        "DLGAP4_915T"
    ],
    "DLGAP5": [
        "DLGAP5_689S",
        "DLGAP5_690S"
    ],
    "DMAP1": [
        "DMAP1_445T"
    ],
    "DMXL1": [
        "DMXL1_1908S"
    ],
    "DNAH9": [
        "DNAH9_2855Y",
        "DNAH9_2866S"
    ],
    "DNAJB14": [
        "DNAJB14_234S"
    ],
    "DNAJB2": [
        "DNAJB2_313S"
    ],
    "DNAJB6": [
        "DNAJB6_15S",
        "DNAJB6_277S"
    ],
    "DNAJC1": [
        "DNAJC1_430S"
    ],
    "DNAJC17": [
        "DNAJC17_112S"
    ],
    "DNAJC2": [
        "DNAJC2_47S",
        "DNAJC2_49S",
        "DNAJC2_60S",
        "DNAJC2_63S"
    ],
    "DNAJC5": [
        "DNAJC5_10S",
        "DNAJC5_12S",
        "DNAJC5_15S"
    ],
    "DNM1": [
        "DNM1_774S",
        "DNM1_777S",
        "DNM1_778S"
    ],
    "DNM1L": [
        "DNM1L_616S"
    ],
    "DNMT1": [
        "DNMT1_143S",
        "DNMT1_714S"
    ],
    "DNPH1": [
        "DNPH1_169S"
    ],
    "DNTTIP2": [
        "DNTTIP2_117S"
    ],
    "DOCK1": [
        "DOCK1_1681S"
    ],
    "DOCK10": [
        "DOCK10_1292S",
        "DOCK10_1295S"
    ],
    "DOCK11": [
        "DOCK11_1352T",
        "DOCK11_158S"
    ],
    "DOCK4": [
        "DOCK4_1620S",
        "DOCK4_1700S"
    ],
    "DOCK5": [
        "DOCK5_1834S"
    ],
    "DOCK6": [
        "DOCK6_159S",
        "DOCK6_176S"
    ],
    "DOCK9": [
        "DOCK9_21S",
        "DOCK9_308S",
        "DOCK9_443S",
        "DOCK9_927S"
    ],
    "DOP1B": [
        "DOP1B_720S"
    ],
    "DOT1L": [
        "DOT1L_374S"
    ],
    "DPCD": [
        "DPCD_141S"
    ],
    "DPF2": [
        "DPF2_142S"
    ],
    "DPM1": [
        "DPM1_9S"
    ],
    "DPYD": [
        "DPYD_905S"
    ],
    "DPYSL2": [
        "DPYSL2_509T",
        "DPYSL2_512T",
        "DPYSL2_514T"
    ],
    "DSG2": [
        "DSG2_680S",
        "DSG2_700S",
        "DSG2_784T"
    ],
    "DSN1": [
        "DSN1_57S"
    ],
    "DSP": [
        "DSP_176S"
    ],
    "DST": [
        "DST_1382S",
        "DST_3968S"
    ],
    "DTNA": [
        "DTNA_564S",
        "DTNA_662S"
    ],
    "DTNB": [
        "DTNB_531S"
    ],
    "DTNBP1": [
        "DTNBP1_351S"
    ],
    "DTX2": [
        "DTX2_360S"
    ],
    "DTX3L": [
        "DTX3L_202S",
        "DTX3L_539S",
        "DTX3L_9S"
    ],
    "DUS3L": [
        "DUS3L_273T",
        "DUS3L_276S"
    ],
    "DUSP16": [
        "DUSP16_612S"
    ],
    "DUSP7": [
        "DUSP7_217S"
    ],
    "DUSP9": [
        "DUSP9_16S"
    ],
    "DYNC1LI1": [
        "DYNC1LI1_207S",
        "DYNC1LI1_405S",
        "DYNC1LI1_421S",
        "DYNC1LI1_510S"
    ],
    "DYNC1LI2": [
        "DYNC1LI2_194S",
        "DYNC1LI2_407S"
    ],
    "DYRK4": [
        "DYRK4_264Y"
    ],
    "ECM2": [
        "ECM2_304S"
    ],
    "EDC3": [
        "EDC3_131S"
    ],
    "EDC4": [
        "EDC4_844S"
    ],
    "EEF1AKMT2": [
        "EEF1AKMT2_21S"
    ],
    "EEF1B2": [
        "EEF1B2_106S"
    ],
    "EEF1D": [
        "EEF1D_133S",
        "EEF1D_147T",
        "EEF1D_162S"
    ],
    "EEF2K": [
        "EEF2K_18S",
        "EEF2K_364T",
        "EEF2K_470S",
        "EEF2K_474S"
    ],
    "EFR3A": [
        "EFR3A_694S"
    ],
    "EFS": [
        "EFS_287S"
    ],
    "EGFR": [
        "EGFR_1166S",
        "EGFR_693T"
    ],
    "EGLN1": [
        "EGLN1_125S"
    ],
    "EHBP1": [
        "EHBP1_1058S",
        "EHBP1_171S",
        "EHBP1_174S",
        "EHBP1_428S",
        "EHBP1_432S",
        "EHBP1_436S",
        "EHBP1_747S",
        "EHBP1_759S",
        "EHBP1_787S"
    ],
    "EHBP1L1": [
        "EHBP1L1_1017S",
        "EHBP1L1_1168S",
        "EHBP1L1_1273S",
        "EHBP1L1_170S",
        "EHBP1L1_191S",
        "EHBP1L1_284T",
        "EHBP1L1_285S",
        "EHBP1L1_310S",
        "EHBP1L1_964S"
    ],
    "EHD2": [
        "EHD2_438S",
        "EHD2_468S"
    ],
    "EHD4": [
        "EHD4_459S"
    ],
    "EHMT2": [
        "EHMT2_555T"
    ],
    "EIF2A": [
        "EIF2A_506S"
    ],
    "EIF2AK3": [
        "EIF2AK3_555S",
        "EIF2AK3_715S"
    ],
    "EIF2AK4": [
        "EIF2AK4_667T"
    ],
    "EIF2B5": [
        "EIF2B5_544S"
    ],
    "EIF3B": [
        "EIF3B_125S"
    ],
    "EIF3C": [
        "EIF3C_13S",
        "EIF3C_15S",
        "EIF3C_166S",
        "EIF3C_16S",
        "EIF3C_18S",
        "EIF3C_39S",
        "EIF3C_524T",
        "EIF3C_909S",
        "EIF3C_9S"
    ],
    "EIF3F": [
        "EIF3F_258S"
    ],
    "EIF3G": [
        "EIF3G_41T",
        "EIF3G_42S"
    ],
    "EIF3J": [
        "EIF3J_109T"
    ],
    "EIF4B": [
        "EIF4B_422S"
    ],
    "EIF4EBP1": [
        "EIF4EBP1_37T",
        "EIF4EBP1_46T",
        "EIF4EBP1_65S",
        "EIF4EBP1_70T"
    ],
    "EIF4ENIF1": [
        "EIF4ENIF1_564S",
        "EIF4ENIF1_587S",
        "EIF4ENIF1_77S",
        "EIF4ENIF1_951S"
    ],
    "EIF4G1": [
        "EIF4G1_1187S",
        "EIF4G1_1209S",
        "EIF4G1_1211T",
        "EIF4G1_1231S",
        "EIF4G1_1238S",
        "EIF4G1_1596S"
    ],
    "EIF4G3": [
        "EIF4G3_1409S",
        "EIF4G3_168T",
        "EIF4G3_230S",
        "EIF4G3_495S"
    ],
    "EIF5A2": [
        "EIF5A2_44S",
        "EIF5A2_46S"
    ],
    "EIF5B": [
        "EIF5B_107S",
        "EIF5B_113S",
        "EIF5B_1168S",
        "EIF5B_135S",
        "EIF5B_137S",
        "EIF5B_164S",
        "EIF5B_182S",
        "EIF5B_183S",
        "EIF5B_190S",
        "EIF5B_214S",
        "EIF5B_589S"
    ],
    "EIF6": [
        "EIF6_243S",
        "EIF6_245T"
    ],
    "ELF1": [
        "ELF1_187S"
    ],
    "ELF4": [
        "ELF4_188S"
    ],
    "ELL": [
        "ELL_309S"
    ],
    "ELMO1": [
        "ELMO1_344S"
    ],
    "ELMSAN1": [
        "ELMSAN1_461S",
        "ELMSAN1_655T",
        "ELMSAN1_661S",
        "ELMSAN1_704T",
        "ELMSAN1_923S"
    ],
    "EMB": [
        "EMB_309S"
    ],
    "EMD": [
        "EMD_142S",
        "EMD_143S",
        "EMD_49S"
    ],
    "EME1": [
        "EME1_15S"
    ],
    "EML1": [
        "EML1_113S"
    ],
    "EML3": [
        "EML3_176S",
        "EML3_177S"
    ],
    "EML4": [
        "EML4_176S"
    ],
    "ENAH": [
        "ENAH_488S",
        "ENAH_502T",
        "ENAH_506S",
        "ENAH_508S"
    ],
    "ENO1": [
        "ENO1_141S",
        "ENO1_263S",
        "ENO1_419S",
        "ENO1_79S"
    ],
    "EP300": [
        "EP300_1038S",
        "EP300_887T"
    ],
    "EP400": [
        "EP400_1010T",
        "EP400_1011S"
    ],
    "EPB41L2": [
        "EPB41L2_550S",
        "EPB41L2_718S"
    ],
    "EPB41L3": [
        "EPB41L3_2T",
        "EPB41L3_3T",
        "EPB41L3_420S",
        "EPB41L3_460S",
        "EPB41L3_467T",
        "EPB41L3_469T",
        "EPB41L3_5S",
        "EPB41L3_760S",
        "EPB41L3_761T",
        "EPB41L3_7S",
        "EPB41L3_88S",
        "EPB41L3_91S",
        "EPB41L3_962S"
    ],
    "EPN1": [
        "EPN1_419S",
        "EPN1_420S",
        "EPN1_435S",
        "EPN1_470T"
    ],
    "EPN3": [
        "EPN3_192S"
    ],
    "EPRS": [
        "EPRS_1417S",
        "EPRS_882S",
        "EPRS_885S",
        "EPRS_886S"
    ],
    "EPS15": [
        "EPS15_324S",
        "EPS15_777T",
        "EPS15_796S"
    ],
    "EPS15L1": [
        "EPS15L1_229S",
        "EPS15L1_366T",
        "EPS15L1_593S",
        "EPS15L1_672S"
    ],
    "EPS8L2": [
        "EPS8L2_240S"
    ],
    "ERBIN": [
        "ERBIN_841S",
        "ERBIN_852S",
        "ERBIN_857S"
    ],
    "ERCC5": [
        "ERCC5_341S",
        "ERCC5_384S",
        "ERCC5_526S",
        "ERCC5_562S",
        "ERCC5_563S"
    ],
    "ERCC6L": [
        "ERCC6L_1069S"
    ],
    "EREG": [
        "EREG_161S"
    ],
    "ERF": [
        "ERF_20S",
        "ERF_489S"
    ],
    "ERICH1": [
        "ERICH1_238S"
    ],
    "ERRFI1": [
        "ERRFI1_251S",
        "ERRFI1_273S",
        "ERRFI1_276S",
        "ERRFI1_302S",
        "ERRFI1_326S",
        "ERRFI1_337S"
    ],
    "ESF1": [
        "ESF1_153S",
        "ESF1_198S"
    ],
    "ESS2": [
        "ESS2_292S"
    ],
    "ESYT1": [
        "ESYT1_1032T",
        "ESYT1_963S"
    ],
    "ESYT2": [
        "ESYT2_691S",
        "ESYT2_758S"
    ],
    "ETS1": [
        "ETS1_282S"
    ],
    "ETV3": [
        "ETV3_159S"
    ],
    "ETV6": [
        "ETV6_184S",
        "ETV6_203S",
        "ETV6_213S"
    ],
    "EVA1A": [
        "EVA1A_114S"
    ],
    "EVI5": [
        "EVI5_689S"
    ],
    "EVL": [
        "EVL_304S"
    ],
    "EXOC1": [
        "EXOC1_473S"
    ],
    "EXOC4": [
        "EXOC4_226S"
    ],
    "EXOSC5": [
        "EXOSC5_20S"
    ],
    "EXOSC9": [
        "EXOSC9_306S"
    ],
    "EZH2": [
        "EZH2_487T"
    ],
    "F2R": [
        "F2R_418S"
    ],
    "FABP4": [
        "FABP4_103T"
    ],
    "FAF2": [
        "FAF2_244T"
    ],
    "FAHD1": [
        "FAHD1_40S"
    ],
    "FAM117A": [
        "FAM117A_193S",
        "FAM117A_207S"
    ],
    "FAM122A": [
        "FAM122A_143S",
        "FAM122A_147S",
        "FAM122A_270S",
        "FAM122A_37S",
        "FAM122A_62S",
        "FAM122A_76S"
    ],
    "FAM122B": [
        "FAM122B_119S",
        "FAM122B_50S"
    ],
    "FAM126B": [
        "FAM126B_430S"
    ],
    "FAM160A2": [
        "FAM160A2_859S"
    ],
    "FAM234A": [
        "FAM234A_21S"
    ],
    "FAM234B": [
        "FAM234B_62S"
    ],
    "FAM53B": [
        "FAM53B_167S",
        "FAM53B_268S"
    ],
    "FAM53C": [
        "FAM53C_122S",
        "FAM53C_232S",
        "FAM53C_234S",
        "FAM53C_273S"
    ],
    "FAM76B": [
        "FAM76B_193S"
    ],
    "FAM83B": [
        "FAM83B_764S",
        "FAM83B_867T",
        "FAM83B_869S"
    ],
    "FAM83G": [
        "FAM83G_356S",
        "FAM83G_634S",
        "FAM83G_688S",
        "FAM83G_689T"
    ],
    "FAM83H": [
        "FAM83H_1003S",
        "FAM83H_516S",
        "FAM83H_523S",
        "FAM83H_5S",
        "FAM83H_647S",
        "FAM83H_870S",
        "FAM83H_881S",
        "FAM83H_892S",
        "FAM83H_8S",
        "FAM83H_914S",
        "FAM83H_924S",
        "FAM83H_925S",
        "FAM83H_9S"
    ],
    "FAM91A1": [
        "FAM91A1_671S"
    ],
    "FANCE": [
        "FANCE_247S"
    ],
    "FARP1": [
        "FARP1_24T",
        "FARP1_889S"
    ],
    "FASN": [
        "FASN_1584S",
        "FASN_207S",
        "FASN_2204T",
        "FASN_974S"
    ],
    "FAT2": [
        "FAT2_4258S"
    ],
    "FBLN1": [
        "FBLN1_147S"
    ],
    "FBN1": [
        "FBN1_2709S"
    ],
    "FBRS": [
        "FBRS_428T"
    ],
    "FBRSL1": [
        "FBRSL1_1010T"
    ],
    "FBXO38": [
        "FBXO38_792S"
    ],
    "FBXO4": [
        "FBXO4_12S",
        "FBXO4_48S"
    ],
    "FBXW11": [
        "FBXW11_65S"
    ],
    "FBXW5": [
        "FBXW5_274T"
    ],
    "FBXW9": [
        "FBXW9_18S"
    ],
    "FCHO2": [
        "FCHO2_394S",
        "FCHO2_403S",
        "FCHO2_453T",
        "FCHO2_468S",
        "FCHO2_488S",
        "FCHO2_496S",
        "FCHO2_682S"
    ],
    "FERMT1": [
        "FERMT1_361S"
    ],
    "FERMT2": [
        "FERMT2_666S"
    ],
    "FEZ1": [
        "FEZ1_58S"
    ],
    "FEZ2": [
        "FEZ2_208S"
    ],
    "FGD4": [
        "FGD4_702S"
    ],
    "FGD6": [
        "FGD6_1197S",
        "FGD6_230S",
        "FGD6_515S",
        "FGD6_554S",
        "FGD6_605S",
        "FGD6_692S",
        "FGD6_721S"
    ],
    "FGFR1OP": [
        "FGFR1OP_156S",
        "FGFR1OP_160S"
    ],
    "FHL2": [
        "FHL2_238S"
    ],
    "FHOD1": [
        "FHOD1_367S",
        "FHOD1_498S",
        "FHOD1_523S"
    ],
    "FKBP15": [
        "FKBP15_1097S",
        "FKBP15_1100S",
        "FKBP15_1114S",
        "FKBP15_1161S",
        "FKBP15_1162S",
        "FKBP15_1164S",
        "FKBP15_320S",
        "FKBP15_956S"
    ],
    "FKBP1A": [
        "FKBP1A_9S"
    ],
    "FKBP4": [
        "FKBP4_453S"
    ],
    "FKBP5": [
        "FKBP5_13S",
        "FKBP5_445S"
    ],
    "FLAD1": [
        "FLAD1_106S"
    ],
    "FLII": [
        "FLII_436S",
        "FLII_856S"
    ],
    "FLNA": [
        "FLNA_1084S",
        "FLNA_1734S",
        "FLNA_2152S",
        "FLNA_2158S",
        "FLNA_968S"
    ],
    "FLNB": [
        "FLNB_1505S",
        "FLNB_2107S",
        "FLNB_2478S"
    ],
    "FLOT1": [
        "FLOT1_19S"
    ],
    "FMNL1": [
        "FMNL1_1031S",
        "FMNL1_624S"
    ],
    "FMNL2": [
        "FMNL2_171S"
    ],
    "FN1": [
        "FN1_1489S",
        "FN1_2475S"
    ],
    "FNBP4": [
        "FNBP4_116S",
        "FNBP4_18S",
        "FNBP4_431S",
        "FNBP4_432S",
        "FNBP4_464S",
        "FNBP4_499S",
        "FNBP4_508S"
    ],
    "FNDC3A": [
        "FNDC3A_202S",
        "FNDC3A_203S",
        "FNDC3A_206S",
        "FNDC3A_207S",
        "FNDC3A_213S"
    ],
    "FNDC3B": [
        "FNDC3B_208S"
    ],
    "FOSL1": [
        "FOSL1_101S",
        "FOSL1_265S",
        "FOSL1_74S"
    ],
    "FOSL2": [
        "FOSL2_120S",
        "FOSL2_200S",
        "FOSL2_230S"
    ],
    "FOXC1": [
        "FOXC1_235S"
    ],
    "FOXC2": [
        "FOXC2_219S",
        "FOXC2_232S",
        "FOXC2_240S",
        "FOXC2_280T",
        "FOXC2_281S"
    ],
    "FOXK1": [
        "FOXK1_243S",
        "FOXK1_257S",
        "FOXK1_445S"
    ],
    "FOXK2": [
        "FOXK2_170S",
        "FOXK2_398S"
    ],
    "FOXP4": [
        "FOXP4_554S"
    ],
    "FRA10AC1": [
        "FRA10AC1_278S"
    ],
    "FRMD3": [
        "FRMD3_365S",
        "FRMD3_366S"
    ],
    "FRMD6": [
        "FRMD6_522S",
        "FRMD6_523T",
        "FRMD6_525S",
        "FRMD6_544S"
    ],
    "FRMD8": [
        "FRMD8_439S"
    ],
    "FRY": [
        "FRY_1983S",
        "FRY_2487S"
    ],
    "FTH1": [
        "FTH1_114S",
        "FTH1_179S",
        "FTH1_183S"
    ],
    "FTO": [
        "FTO_4T"
    ],
    "FTSJ1": [
        "FTSJ1_271S"
    ],
    "FTSJ3": [
        "FTSJ3_335S",
        "FTSJ3_336S",
        "FTSJ3_644S"
    ],
    "FUBP1": [
        "FUBP1_153T"
    ],
    "FUBP3": [
        "FUBP3_296S"
    ],
    "FUNDC2": [
        "FUNDC2_151S"
    ],
    "FYTTD1": [
        "FYTTD1_16S"
    ],
    "FZD6": [
        "FZD6_653S"
    ],
    "G3BP1": [
        "G3BP1_232S"
    ],
    "GALNT4": [
        "GALNT4_50S"
    ],
    "GAPDH": [
        "GAPDH_210S",
        "GAPDH_83S"
    ],
    "GAPVD1": [
        "GAPVD1_390T",
        "GAPVD1_569S",
        "GAPVD1_902S",
        "GAPVD1_914S",
        "GAPVD1_966S"
    ],
    "GAS2L1": [
        "GAS2L1_297S",
        "GAS2L1_306S",
        "GAS2L1_352S"
    ],
    "GATAD2A": [
        "GATAD2A_100S",
        "GATAD2A_107S",
        "GATAD2A_113S",
        "GATAD2A_114S",
        "GATAD2A_49T"
    ],
    "GBF1": [
        "GBF1_1318S",
        "GBF1_1773S",
        "GBF1_1780S",
        "GBF1_1781S",
        "GBF1_1784S",
        "GBF1_1788S",
        "GBF1_1789S"
    ],
    "GCFC2": [
        "GCFC2_174S",
        "GCFC2_180S",
        "GCFC2_429S",
        "GCFC2_430S"
    ],
    "GDI2": [
        "GDI2_61S"
    ],
    "GEMIN5": [
        "GEMIN5_757S",
        "GEMIN5_778S"
    ],
    "GFPT2": [
        "GFPT2_227T",
        "GFPT2_244S"
    ],
    "GIGYF1": [
        "GIGYF1_230S"
    ],
    "GIMAP7": [
        "GIMAP7_224Y",
        "GIMAP7_225T"
    ],
    "GINS2": [
        "GINS2_182S"
    ],
    "GIPC1": [
        "GIPC1_232S"
    ],
    "GIT1": [
        "GIT1_592S"
    ],
    "GJA1": [
        "GJA1_364S",
        "GJA1_365S",
        "GJA1_372S"
    ],
    "GLCE": [
        "GLCE_73S"
    ],
    "GLE1": [
        "GLE1_88S"
    ],
    "GLI3": [
        "GLI3_1006S",
        "GLI3_445S",
        "GLI3_664S",
        "GLI3_980S"
    ],
    "GLUD2": [
        "GLUD2_410T",
        "GLUD2_450S"
    ],
    "GLYR1": [
        "GLYR1_130S",
        "GLYR1_158S"
    ],
    "GMDS": [
        "GMDS_14S"
    ],
    "GMIP": [
        "GMIP_231S"
    ],
    "GNG12": [
        "GNG12_49S",
        "GNG12_7S"
    ],
    "GOLGA4": [
        "GOLGA4_266S",
        "GOLGA4_71S",
        "GOLGA4_87S"
    ],
    "GOLGB1": [
        "GOLGB1_1966S",
        "GOLGB1_2216S"
    ],
    "GOLIM4": [
        "GOLIM4_538S"
    ],
    "GOLPH3": [
        "GOLPH3_36S"
    ],
    "GORASP1": [
        "GORASP1_216T"
    ],
    "GP1BA": [
        "GP1BA_632S"
    ],
    "GPALPP1": [
        "GPALPP1_105S"
    ],
    "GPAM": [
        "GPAM_688S",
        "GPAM_695S"
    ],
    "GPAT3": [
        "GPAT3_68S"
    ],
    "GPATCH4": [
        "GPATCH4_128S",
        "GPATCH4_130S"
    ],
    "GPATCH8": [
        "GPATCH8_1009S",
        "GPATCH8_1014S",
        "GPATCH8_1081S",
        "GPATCH8_1107S",
        "GPATCH8_650S",
        "GPATCH8_653S",
        "GPATCH8_740S"
    ],
    "GPCPD1": [
        "GPCPD1_175S"
    ],
    "GPHN": [
        "GPHN_294S",
        "GPHN_295S",
        "GPHN_305S"
    ],
    "GPI": [
        "GPI_109T"
    ],
    "GPSM1": [
        "GPSM1_492S"
    ],
    "GRAMD1A": [
        "GRAMD1A_267S",
        "GRAMD1A_277T"
    ],
    "GRK6": [
        "GRK6_484S"
    ],
    "GRN": [
        "GRN_435S"
    ],
    "GRWD1": [
        "GRWD1_119S",
        "GRWD1_122S"
    ],
    "GSE1": [
        "GSE1_857S",
        "GSE1_909S"
    ],
    "GTF2F2": [
        "GTF2F2_248S"
    ],
    "GTF2I": [
        "GTF2I_210S",
        "GTF2I_412S",
        "GTF2I_784S",
        "GTF2I_823S"
    ],
    "GTF2IRD1": [
        "GTF2IRD1_448S"
    ],
    "GTF3A": [
        "GTF3A_175S"
    ],
    "GTF3C1": [
        "GTF3C1_1062S",
        "GTF3C1_1068S",
        "GTF3C1_1856S",
        "GTF3C1_1865S",
        "GTF3C1_1868S"
    ],
    "GTF3C2": [
        "GTF3C2_167S",
        "GTF3C2_220S",
        "GTF3C2_893S",
        "GTF3C2_901S"
    ],
    "GTF3C3": [
        "GTF3C3_43S"
    ],
    "GTF3C4": [
        "GTF3C4_611S"
    ],
    "GTPBP1": [
        "GTPBP1_24S",
        "GTPBP1_25S"
    ],
    "GTSE1": [
        "GTSE1_575S",
        "GTSE1_580S"
    ],
    "GYS1": [
        "GYS1_652S",
        "GYS1_653S",
        "GYS1_657S"
    ],
    "H1-4": [
        "H1-4_18T",
        "H1-4_36S"
    ],
    "H1FX": [
        "H1FX_31S",
        "H1FX_33S"
    ],
    "H2AFX": [
        "H2AFX_122S",
        "H2AFX_137T",
        "H2AFX_140S"
    ],
    "H2AFY": [
        "H2AFY_170S",
        "H2AFY_173S"
    ],
    "HACE1": [
        "HACE1_385S"
    ],
    "HADHA": [
        "HADHA_756S"
    ],
    "HARS2": [
        "HARS2_67S"
    ],
    "HAS2": [
        "HAS2_77T"
    ],
    "HAUS7": [
        "HAUS7_26S"
    ],
    "HBP1": [
        "HBP1_134S",
        "HBP1_135S"
    ],
    "HCAR2": [
        "HCAR2_328S"
    ],
    "HCFC1": [
        "HCFC1_1507S",
        "HCFC1_2020S",
        "HCFC1_666S",
        "HCFC1_6S"
    ],
    "HCK": [
        "HCK_261S",
        "HCK_6S"
    ],
    "HDAC1": [
        "HDAC1_393S",
        "HDAC1_421S",
        "HDAC1_423S"
    ],
    "HDAC2": [
        "HDAC2_394S",
        "HDAC2_422S",
        "HDAC2_424S"
    ],
    "HDAC3": [
        "HDAC3_424S"
    ],
    "HDAC4": [
        "HDAC4_246S",
        "HDAC4_467S",
        "HDAC4_565S",
        "HDAC4_632S"
    ],
    "HDAC7": [
        "HDAC7_155S",
        "HDAC7_181S",
        "HDAC7_358S",
        "HDAC7_405S",
        "HDAC7_487S"
    ],
    "HDGF": [
        "HDGF_132S",
        "HDGF_133S",
        "HDGF_165S",
        "HDGF_200T",
        "HDGF_202S"
    ],
    "HDGFL2": [
        "HDGFL2_240S",
        "HDGFL2_366S",
        "HDGFL2_369S",
        "HDGFL2_370S",
        "HDGFL2_613S",
        "HDGFL2_625S",
        "HDGFL2_652S",
        "HDGFL2_664S"
    ],
    "HDLBP": [
        "HDLBP_31S",
        "HDLBP_944S"
    ],
    "HEATR5B": [
        "HEATR5B_1739S"
    ],
    "HEATR6": [
        "HEATR6_498T",
        "HEATR6_643S"
    ],
    "HECTD1": [
        "HECTD1_1772S",
        "HECTD1_357S",
        "HECTD1_631S",
        "HECTD1_632S"
    ],
    "HECTD4": [
        "HECTD4_1075S",
        "HECTD4_2080T"
    ],
    "HECW2": [
        "HECW2_48S"
    ],
    "HELZ": [
        "HELZ_1317S"
    ],
    "HELZ2": [
        "HELZ2_2021S"
    ],
    "HERC1": [
        "HERC1_1428S",
        "HERC1_1491S",
        "HERC1_2701T",
        "HERC1_2710S"
    ],
    "HIC1": [
        "HIC1_237S",
        "HIC1_248S",
        "HIC1_366S"
    ],
    "HIRIP3": [
        "HIRIP3_125S",
        "HIRIP3_142S",
        "HIRIP3_143S",
        "HIRIP3_196S",
        "HIRIP3_199S",
        "HIRIP3_223S",
        "HIRIP3_227S",
        "HIRIP3_330S",
        "HIRIP3_332S",
        "HIRIP3_333S",
        "HIRIP3_370S",
        "HIRIP3_372S",
        "HIRIP3_530S",
        "HIRIP3_84T",
        "HIRIP3_87S"
    ],
    "HIST2H3A": [
        "HIST2H3A_58S",
        "HIST2H3A_59T",
        "HIST2H3A_81T"
    ],
    "HIVEP2": [
        "HIVEP2_296S",
        "HIVEP2_565S"
    ],
    "HIVEP3": [
        "HIVEP3_1964S",
        "HIVEP3_1970S",
        "HIVEP3_2009S",
        "HIVEP3_496S"
    ],
    "HJURP": [
        "HJURP_486S"
    ],
    "HK1": [
        "HK1_552T"
    ],
    "HLA-H": [
        "HLA-H_352S"
    ],
    "HLCS": [
        "HLCS_79S"
    ],
    "HMGA1": [
        "HMGA1_102S",
        "HMGA1_103S"
    ],
    "HMGCS1": [
        "HMGCS1_495S",
        "HMGCS1_516S"
    ],
    "HMGXB4": [
        "HMGXB4_497S",
        "HMGXB4_502S",
        "HMGXB4_512S"
    ],
    "HNRNPA2B1": [
        "HNRNPA2B1_231S",
        "HNRNPA2B1_85S"
    ],
    "HNRNPA3": [
        "HNRNPA3_14S"
    ],
    "HNRNPC": [
        "HNRNPC_233S",
        "HNRNPC_239S",
        "HNRNPC_241S",
        "HNRNPC_47S"
    ],
    "HNRNPD": [
        "HNRNPD_127T",
        "HNRNPD_190S",
        "HNRNPD_193T",
        "HNRNPD_80S",
        "HNRNPD_82S",
        "HNRNPD_83S",
        "HNRNPD_87S"
    ],
    "HNRNPH1": [
        "HNRNPH1_104S"
    ],
    "HNRNPUL2": [
        "HNRNPUL2_161S",
        "HNRNPUL2_165T",
        "HNRNPUL2_168S",
        "HNRNPUL2_185S",
        "HNRNPUL2_188S",
        "HNRNPUL2_193S",
        "HNRNPUL2_228S"
    ],
    "HOMER3": [
        "HOMER3_159S",
        "HOMER3_256S"
    ],
    "HOMEZ": [
        "HOMEZ_451T"
    ],
    "HP1BP3": [
        "HP1BP3_446S",
        "HP1BP3_51T"
    ],
    "HPS5": [
        "HPS5_695S"
    ],
    "HRH1": [
        "HRH1_230S",
        "HRH1_233S"
    ],
    "HS1BP3": [
        "HS1BP3_249S"
    ],
    "HSF1": [
        "HSF1_291S",
        "HSF1_303S",
        "HSF1_307S",
        "HSF1_363S",
        "HSF1_367T",
        "HSF1_369T"
    ],
    "HSP90AA1": [
        "HSP90AA1_231S",
        "HSP90AA1_263S"
    ],
    "HSPA4": [
        "HSPA4_429S",
        "HSPA4_76S"
    ],
    "HSPB1": [
        "HSPB1_15S",
        "HSPB1_65S",
        "HSPB1_82S",
        "HSPB1_83S"
    ],
    "HSPBP1": [
        "HSPBP1_351S"
    ],
    "HSPH1": [
        "HSPH1_809S"
    ],
    "HTATSF1": [
        "HTATSF1_453S",
        "HTATSF1_481S",
        "HTATSF1_616S",
        "HTATSF1_642S",
        "HTATSF1_676S",
        "HTATSF1_702S",
        "HTATSF1_721S"
    ],
    "HTT": [
        "HTT_1199S",
        "HTT_1862S",
        "HTT_1874S"
    ],
    "HUWE1": [
        "HUWE1_1084S",
        "HUWE1_1395S",
        "HUWE1_1907S",
        "HUWE1_2052S",
        "HUWE1_2918S",
        "HUWE1_3363S",
        "HUWE1_3662S",
        "HUWE1_3816S",
        "HUWE1_3919S"
    ],
    "HYPK": [
        "HYPK_38S"
    ],
    "IARS": [
        "IARS_1047S"
    ],
    "ICAM1": [
        "ICAM1_530T"
    ],
    "ICE1": [
        "ICE1_1642T",
        "ICE1_1712S",
        "ICE1_1854S",
        "ICE1_1903S",
        "ICE1_255S",
        "ICE1_925S"
    ],
    "ICK": [
        "ICK_157T",
        "ICK_159Y"
    ],
    "IER3": [
        "IER3_31S"
    ],
    "IFI16": [
        "IFI16_106S",
        "IFI16_153S",
        "IFI16_780S"
    ],
    "IFRD2": [
        "IFRD2_95S"
    ],
    "IFT140": [
        "IFT140_1443S"
    ],
    "IFT22": [
        "IFT22_137S"
    ],
    "IFT43": [
        "IFT43_78S"
    ],
    "IGF2BP2": [
        "IGF2BP2_162S"
    ],
    "IGF2R": [
        "IGF2R_2409S"
    ],
    "IKBKB": [
        "IKBKB_672S"
    ],
    "IKBKE": [
        "IKBKE_664S"
    ],
    "IKZF2": [
        "IKZF2_433S",
        "IKZF2_56S"
    ],
    "IKZF4": [
        "IKZF4_491S"
    ],
    "IL1RAP": [
        "IL1RAP_555S",
        "IL1RAP_556S",
        "IL1RAP_557S",
        "IL1RAP_565S",
        "IL1RAP_566S"
    ],
    "IL32": [
        "IL32_133S",
        "IL32_223T"
    ],
    "IL33": [
        "IL33_185T",
        "IL33_189T"
    ],
    "ILF3": [
        "ILF3_382S",
        "ILF3_384S",
        "ILF3_482S",
        "ILF3_592T",
        "ILF3_62S"
    ],
    "ILKAP": [
        "ILKAP_81T",
        "ILKAP_82S"
    ],
    "INCENP": [
        "INCENP_263S"
    ],
    "INF2": [
        "INF2_371S",
        "INF2_372S"
    ],
    "ING4": [
        "ING4_150S"
    ],
    "INPP5E": [
        "INPP5E_85S"
    ],
    "INPP5F": [
        "INPP5F_942S"
    ],
    "INTS1": [
        "INTS1_104S",
        "INTS1_1318S",
        "INTS1_1326S",
        "INTS1_1327S",
        "INTS1_1395S",
        "INTS1_307S",
        "INTS1_83T"
    ],
    "INTS12": [
        "INTS12_128S"
    ],
    "INTS13": [
        "INTS13_623S",
        "INTS13_626S"
    ],
    "INTS7": [
        "INTS7_809S"
    ],
    "IQGAP1": [
        "IQGAP1_330S",
        "IQGAP1_360S",
        "IQGAP1_932S"
    ],
    "IRAK2": [
        "IRAK2_144S"
    ],
    "IRF2BP1": [
        "IRF2BP1_384S",
        "IRF2BP1_436S",
        "IRF2BP1_66S"
    ],
    "IRF2BP2": [
        "IRF2BP2_406S",
        "IRF2BP2_460S"
    ],
    "IRF2BPL": [
        "IRF2BPL_215S",
        "IRF2BPL_334S",
        "IRF2BPL_337S",
        "IRF2BPL_547S",
        "IRF2BPL_611T",
        "IRF2BPL_636T",
        "IRF2BPL_639S",
        "IRF2BPL_657S",
        "IRF2BPL_659S",
        "IRF2BPL_662S",
        "IRF2BPL_69S"
    ],
    "IRF3": [
        "IRF3_173S",
        "IRF3_175S"
    ],
    "IRS1": [
        "IRS1_330S",
        "IRS1_374S",
        "IRS1_531S"
    ],
    "IRS2": [
        "IRS2_365S",
        "IRS2_560S",
        "IRS2_577S",
        "IRS2_620S",
        "IRS2_932S"
    ],
    "IRX2": [
        "IRX2_186S",
        "IRX2_252S",
        "IRX2_285S",
        "IRX2_286S",
        "IRX2_297S",
        "IRX2_316T",
        "IRX2_317S"
    ],
    "ISCU": [
        "ISCU_14S",
        "ISCU_20S",
        "ISCU_29S"
    ],
    "ITFG2": [
        "ITFG2_220S"
    ],
    "ITGA2": [
        "ITGA2_1181S"
    ],
    "ITGA3": [
        "ITGA3_1042S",
        "ITGA3_1048T"
    ],
    "ITGA5": [
        "ITGA5_127S"
    ],
    "ITGB4": [
        "ITGB4_1084S",
        "ITGB4_1530T",
        "ITGB4_1547S",
        "ITGB4_1696S",
        "ITGB4_971T"
    ],
    "ITPKB": [
        "ITPKB_204S"
    ],
    "ITPR1": [
        "ITPR1_1764S"
    ],
    "ITPR3": [
        "ITPR3_2670S"
    ],
    "ITPRID2": [
        "ITPRID2_1156T",
        "ITPRID2_641S",
        "ITPRID2_668S",
        "ITPRID2_737S",
        "ITPRID2_739S",
        "ITPRID2_742T",
        "ITPRID2_746S",
        "ITPRID2_767S"
    ],
    "ITPRIPL2": [
        "ITPRIPL2_78S"
    ],
    "ITSN1": [
        "ITSN1_1144T",
        "ITSN1_203S",
        "ITSN1_978S"
    ],
    "ITSN2": [
        "ITSN2_884S",
        "ITSN2_887S",
        "ITSN2_889S"
    ],
    "IVNS1ABP": [
        "IVNS1ABP_322S",
        "IVNS1ABP_325S",
        "IVNS1ABP_326S",
        "IVNS1ABP_338S"
    ],
    "IWS1": [
        "IWS1_196S",
        "IWS1_198S",
        "IWS1_235S",
        "IWS1_237S",
        "IWS1_248S",
        "IWS1_250S",
        "IWS1_287S",
        "IWS1_289S",
        "IWS1_300S",
        "IWS1_313S",
        "IWS1_315S",
        "IWS1_317T",
        "IWS1_333S",
        "IWS1_362S",
        "IWS1_363S",
        "IWS1_365S",
        "IWS1_377S",
        "IWS1_398S",
        "IWS1_400S",
        "IWS1_438S",
        "IWS1_440S",
        "IWS1_511S",
        "IWS1_513S",
        "IWS1_54S",
        "IWS1_720S"
    ],
    "JCAD": [
        "JCAD_885S"
    ],
    "JMJD1C": [
        "JMJD1C_1978T"
    ],
    "JMY": [
        "JMY_713S",
        "JMY_888S"
    ],
    "JPT1": [
        "JPT1_87S"
    ],
    "JPT2": [
        "JPT2_69S"
    ],
    "JUN": [
        "JUN_63S"
    ],
    "JUND": [
        "JUND_100S",
        "JUND_90S"
    ],
    "KANK1": [
        "KANK1_1342S",
        "KANK1_325S"
    ],
    "KANK2": [
        "KANK2_323S",
        "KANK2_375S",
        "KANK2_540S"
    ],
    "KANSL1": [
        "KANSL1_1045S",
        "KANSL1_268S",
        "KANSL1_991S"
    ],
    "KAT14": [
        "KAT14_416S"
    ],
    "KAT5": [
        "KAT5_90S"
    ],
    "KAT6A": [
        "KAT6A_1001S",
        "KAT6A_1113S",
        "KAT6A_974S"
    ],
    "KAT7": [
        "KAT7_124S",
        "KAT7_57S"
    ],
    "KATNA1": [
        "KATNA1_109S",
        "KATNA1_170S"
    ],
    "KATNB1": [
        "KATNB1_360S",
        "KATNB1_362S",
        "KATNB1_363S"
    ],
    "KBTBD11": [
        "KBTBD11_314S"
    ],
    "KCNAB2": [
        "KCNAB2_111S",
        "KCNAB2_112S",
        "KCNAB2_9S"
    ],
    "KCNQ5": [
        "KCNQ5_457S"
    ],
    "KCNU1": [
        "KCNU1_1100S"
    ],
    "KCTD1": [
        "KCTD1_12S",
        "KCTD1_9S"
    ],
    "KCTD12": [
        "KCTD12_185S",
        "KCTD12_187S",
        "KCTD12_196T",
        "KCTD12_200S"
    ],
    "KCTD3": [
        "KCTD3_711S"
    ],
    "KDM1A": [
        "KDM1A_166S"
    ],
    "KDM1B": [
        "KDM1B_247S"
    ],
    "KDM2A": [
        "KDM2A_692S"
    ],
    "KDM2B": [
        "KDM2B_1031S",
        "KDM2B_1049S",
        "KDM2B_445S",
        "KDM2B_497S",
        "KDM2B_795S"
    ],
    "KDM3A": [
        "KDM3A_264S"
    ],
    "KDM3B": [
        "KDM3B_278S",
        "KDM3B_289S",
        "KDM3B_314S",
        "KDM3B_798S"
    ],
    "KHNYN": [
        "KHNYN_353S",
        "KHNYN_359S"
    ],
    "KHSRP": [
        "KHSRP_181S",
        "KHSRP_480S"
    ],
    "KIAA0100": [
        "KIAA0100_2197T",
        "KIAA0100_2199S"
    ],
    "KIAA0556": [
        "KIAA0556_660S"
    ],
    "KIAA0754": [
        "KIAA0754_122T",
        "KIAA0754_666S"
    ],
    "KIAA0930": [
        "KIAA0930_324S"
    ],
    "KIAA1109": [
        "KIAA1109_2603S",
        "KIAA1109_2755S",
        "KIAA1109_3996T"
    ],
    "KIAA1143": [
        "KIAA1143_50S"
    ],
    "KIAA1217": [
        "KIAA1217_1568S",
        "KIAA1217_169S",
        "KIAA1217_361S"
    ],
    "KIAA1522": [
        "KIAA1522_447S",
        "KIAA1522_545S",
        "KIAA1522_669S",
        "KIAA1522_673S",
        "KIAA1522_929S"
    ],
    "KIAA1671": [
        "KIAA1671_128S",
        "KIAA1671_1695S",
        "KIAA1671_1701S",
        "KIAA1671_404S",
        "KIAA1671_600T"
    ],
    "KIDINS220": [
        "KIDINS220_1521S",
        "KIDINS220_1526S",
        "KIDINS220_1555S",
        "KIDINS220_918S"
    ],
    "KIF11": [
        "KIF11_926T"
    ],
    "KIF15": [
        "KIF15_568S"
    ],
    "KIF16B": [
        "KIF16B_1017S"
    ],
    "KIF1B": [
        "KIF1B_1057S",
        "KIF1B_1487S"
    ],
    "KIF1C": [
        "KIF1C_1033S",
        "KIF1C_674S",
        "KIF1C_676S",
        "KIF1C_915S"
    ],
    "KIF20A": [
        "KIF20A_532S"
    ],
    "KIF21A": [
        "KIF21A_1212S",
        "KIF21A_1239S",
        "KIF21A_853S"
    ],
    "KIF4A": [
        "KIF4A_1181T"
    ],
    "KIF5B": [
        "KIF5B_933S"
    ],
    "KIFAP3": [
        "KIFAP3_102S"
    ],
    "KLC1": [
        "KLC1_524S"
    ],
    "KLC2": [
        "KLC2_151S",
        "KLC2_582S",
        "KLC2_608S",
        "KLC2_610S"
    ],
    "KLC4": [
        "KLC4_518T",
        "KLC4_519S",
        "KLC4_565S",
        "KLC4_566S",
        "KLC4_590S",
        "KLC4_611S"
    ],
    "KLF13": [
        "KLF13_162S"
    ],
    "KLHDC9": [
        "KLHDC9_247S",
        "KLHDC9_248S"
    ],
    "KLHL22": [
        "KLHL22_605T"
    ],
    "KMT2A": [
        "KMT2A_1684S",
        "KMT2A_1685S",
        "KMT2A_1837S",
        "KMT2A_1839T",
        "KMT2A_1845T",
        "KMT2A_1858S",
        "KMT2A_2151S",
        "KMT2A_3036S",
        "KMT2A_337T",
        "KMT2A_3511S",
        "KMT2A_3527S",
        "KMT2A_3529S",
        "KMT2A_518S"
    ],
    "KMT2B": [
        "KMT2B_1032S",
        "KMT2B_1035S",
        "KMT2B_1164S",
        "KMT2B_2270S",
        "KMT2B_588T",
        "KMT2B_632S",
        "KMT2B_861S"
    ],
    "KMT2C": [
        "KMT2C_4034S",
        "KMT2C_4267S"
    ],
    "KMT2D": [
        "KMT2D_1195T",
        "KMT2D_1606S",
        "KMT2D_1671S",
        "KMT2D_2229T",
        "KMT2D_2342S",
        "KMT2D_3130S",
        "KMT2D_4359S",
        "KMT2D_4682T",
        "KMT2D_4738S",
        "KMT2D_4849S",
        "KMT2D_609S",
        "KMT2D_654S"
    ],
    "KNSTRN": [
        "KNSTRN_171S"
    ],
    "KPNB1": [
        "KPNB1_12S"
    ],
    "KRI1": [
        "KRI1_136S",
        "KRI1_171S",
        "KRI1_628S",
        "KRI1_639S"
    ],
    "KRTCAP2": [
        "KRTCAP2_124T"
    ],
    "KSR1": [
        "KSR1_288T",
        "KSR1_406S",
        "KSR1_425T",
        "KSR1_569S"
    ],
    "KTN1": [
        "KTN1_1313S",
        "KTN1_153T",
        "KTN1_75S",
        "KTN1_77S"
    ],
    "L3MBTL2": [
        "L3MBTL2_689S"
    ],
    "L3MBTL3": [
        "L3MBTL3_608S",
        "L3MBTL3_625S"
    ],
    "LAMTOR1": [
        "LAMTOR1_27S"
    ],
    "LARP1": [
        "LARP1_1040S",
        "LARP1_143S",
        "LARP1_223T",
        "LARP1_225S",
        "LARP1_228S",
        "LARP1_517S",
        "LARP1_521S",
        "LARP1_526T",
        "LARP1_627S",
        "LARP1_631S",
        "LARP1_766S",
        "LARP1_774S",
        "LARP1_90S"
    ],
    "LARP1B": [
        "LARP1B_343S",
        "LARP1B_454T"
    ],
    "LARP4": [
        "LARP4_583S",
        "LARP4_722S"
    ],
    "LARP4B": [
        "LARP4B_498S",
        "LARP4B_599S",
        "LARP4B_601S",
        "LARP4B_663S",
        "LARP4B_664S",
        "LARP4B_718S"
    ],
    "LARP7": [
        "LARP7_258S",
        "LARP7_261S",
        "LARP7_298S",
        "LARP7_337S",
        "LARP7_338T"
    ],
    "LAS1L": [
        "LAS1L_560S",
        "LAS1L_617S"
    ],
    "LASP1": [
        "LASP1_146S"
    ],
    "LBR": [
        "LBR_86S",
        "LBR_97S",
        "LBR_99S"
    ],
    "LCA5": [
        "LCA5_501S",
        "LCA5_505S"
    ],
    "LDHA": [
        "LDHA_310S"
    ],
    "LEMD2": [
        "LEMD2_134S",
        "LEMD2_138S",
        "LEMD2_139S"
    ],
    "LEMD3": [
        "LEMD3_261S",
        "LEMD3_883T"
    ],
    "LEO1": [
        "LEO1_151S",
        "LEO1_154S",
        "LEO1_162S",
        "LEO1_171S",
        "LEO1_179S",
        "LEO1_188T",
        "LEO1_197S",
        "LEO1_246S",
        "LEO1_254S",
        "LEO1_277S",
        "LEO1_279S",
        "LEO1_294S",
        "LEO1_300S",
        "LEO1_614S",
        "LEO1_630S",
        "LEO1_658S"
    ],
    "LIG1": [
        "LIG1_141S",
        "LIG1_183T",
        "LIG1_197T",
        "LIG1_66S",
        "LIG1_76S"
    ],
    "LIMA1": [
        "LIMA1_132S",
        "LIMA1_362S",
        "LIMA1_365S",
        "LIMA1_369S",
        "LIMA1_371S",
        "LIMA1_374S",
        "LIMA1_490S",
        "LIMA1_609S",
        "LIMA1_698S"
    ],
    "LIMCH1": [
        "LIMCH1_169S",
        "LIMCH1_215T",
        "LIMCH1_718S"
    ],
    "LIMD1": [
        "LIMD1_272S",
        "LIMD1_316S"
    ],
    "LIN54": [
        "LIN54_635S"
    ],
    "LLGL2": [
        "LLGL2_653S"
    ],
    "LMNA": [
        "LMNA_107S",
        "LMNA_22S",
        "LMNA_301S",
        "LMNA_390S",
        "LMNA_392S",
        "LMNA_395S",
        "LMNA_407S",
        "LMNA_423S",
        "LMNA_429S",
        "LMNA_458S",
        "LMNA_463S",
        "LMNA_51S",
        "LMNA_533S",
        "LMNA_632S",
        "LMNA_636S",
        "LMNA_94S"
    ],
    "LMNB1": [
        "LMNB1_232S",
        "LMNB1_23S",
        "LMNB1_302S",
        "LMNB1_391S",
        "LMNB1_393S",
        "LMNB1_575T"
    ],
    "LMNB2": [
        "LMNB2_318S",
        "LMNB2_37S",
        "LMNB2_421S",
        "LMNB2_5S"
    ],
    "LMO7": [
        "LMO7_1048T",
        "LMO7_1493S",
        "LMO7_1586S",
        "LMO7_246S",
        "LMO7_960S",
        "LMO7_988S",
        "LMO7_990T",
        "LMO7_991S"
    ],
    "LMOD1": [
        "LMOD1_119S",
        "LMOD1_135S"
    ],
    "LMTK2": [
        "LMTK2_886S"
    ],
    "LNPK": [
        "LNPK_384S"
    ],
    "LPIN1": [
        "LPIN1_252S",
        "LPIN1_294S",
        "LPIN1_889S"
    ],
    "LPIN3": [
        "LPIN3_411S"
    ],
    "LRBA": [
        "LRBA_10S"
    ],
    "LRCH1": [
        "LRCH1_370S",
        "LRCH1_536S"
    ],
    "LRCH3": [
        "LRCH3_415S"
    ],
    "LRFN4": [
        "LRFN4_610S"
    ],
    "LRMDA": [
        "LRMDA_153S"
    ],
    "LRP1": [
        "LRP1_4520S",
        "LRP1_4523S"
    ],
    "LRRC47": [
        "LRRC47_520S"
    ],
    "LRRFIP1": [
        "LRRFIP1_16S",
        "LRRFIP1_68S",
        "LRRFIP1_714S",
        "LRRFIP1_733S"
    ],
    "LRRFIP2": [
        "LRRFIP2_320S",
        "LRRFIP2_328S"
    ],
    "LRWD1": [
        "LRWD1_212S",
        "LRWD1_243S",
        "LRWD1_253S",
        "LRWD1_259S"
    ],
    "LSM11": [
        "LSM11_21S"
    ],
    "LSM14A": [
        "LSM14A_182S",
        "LSM14A_183S",
        "LSM14A_192S",
        "LSM14A_216S"
    ],
    "LSM7": [
        "LSM7_22T"
    ],
    "LSP1": [
        "LSP1_252S"
    ],
    "LSR": [
        "LSR_493S"
    ],
    "LTB4R2": [
        "LTB4R2_311S"
    ],
    "LUZP1": [
        "LUZP1_394S",
        "LUZP1_574S",
        "LUZP1_659S",
        "LUZP1_932S"
    ],
    "LYN": [
        "LYN_13S",
        "LYN_326S"
    ],
    "LYST": [
        "LYST_2105S"
    ],
    "LZTS2": [
        "LZTS2_301S",
        "LZTS2_570S"
    ],
    "M6PR": [
        "M6PR_267S"
    ],
    "MACF1": [
        "MACF1_1376S",
        "MACF1_2006S",
        "MACF1_280S",
        "MACF1_3927S",
        "MACF1_3929S",
        "MACF1_4496S",
        "MACF1_4521S",
        "MACF1_5592S"
    ],
    "MACO1": [
        "MACO1_332S"
    ],
    "MADD": [
        "MADD_1059S"
    ],
    "MAGED2": [
        "MAGED2_247S"
    ],
    "MAGI3": [
        "MAGI3_659S",
        "MAGI3_676S",
        "MAGI3_953S"
    ],
    "MAP11": [
        "MAP11_495S",
        "MAP11_541T"
    ],
    "MAP1A": [
        "MAP1A_2019S",
        "MAP1A_2022S",
        "MAP1A_2449S"
    ],
    "MAP1B": [
        "MAP1B_1067T",
        "MAP1B_1252S",
        "MAP1B_1256S",
        "MAP1B_1258S",
        "MAP1B_1260S",
        "MAP1B_1262S",
        "MAP1B_1265S",
        "MAP1B_1282T",
        "MAP1B_1376S",
        "MAP1B_1378S",
        "MAP1B_1389S",
        "MAP1B_1400S",
        "MAP1B_1427S",
        "MAP1B_1501S",
        "MAP1B_1631S",
        "MAP1B_1633T",
        "MAP1B_1779S",
        "MAP1B_1782S",
        "MAP1B_1785S",
        "MAP1B_1788T",
        "MAP1B_1792S",
        "MAP1B_1793S",
        "MAP1B_1797S",
        "MAP1B_1913T",
        "MAP1B_1949T",
        "MAP1B_1965S",
        "MAP1B_2271S",
        "MAP1B_541S",
        "MAP1B_561S",
        "MAP1B_614S",
        "MAP1B_831S",
        "MAP1B_832S",
        "MAP1B_891S",
        "MAP1B_970S",
        "MAP1B_992S",
        "MAP1B_995S"
    ],
    "MAP1S": [
        "MAP1S_472S",
        "MAP1S_592S",
        "MAP1S_638T",
        "MAP1S_640S",
        "MAP1S_646S",
        "MAP1S_655S",
        "MAP1S_657S",
        "MAP1S_759S"
    ],
    "MAP2K2": [
        "MAP2K2_293S",
        "MAP2K2_295S",
        "MAP2K2_394T"
    ],
    "MAP3K11": [
        "MAP3K11_705S",
        "MAP3K11_758S"
    ],
    "MAP3K2": [
        "MAP3K2_153S",
        "MAP3K2_163S",
        "MAP3K2_164S",
        "MAP3K2_331S"
    ],
    "MAP3K20": [
        "MAP3K20_637S"
    ],
    "MAP3K5": [
        "MAP3K5_1033S"
    ],
    "MAP3K6": [
        "MAP3K6_969S"
    ],
    "MAP3K8": [
        "MAP3K8_141S"
    ],
    "MAP4": [
        "MAP4_1073S",
        "MAP4_280S",
        "MAP4_358S",
        "MAP4_507S",
        "MAP4_510S",
        "MAP4_521T",
        "MAP4_580S",
        "MAP4_636S",
        "MAP4_687T",
        "MAP4_68S",
        "MAP4_696S",
        "MAP4_787S",
        "MAP4_825S",
        "MAP4_942T",
        "MAP4_94S",
        "MAP4_97T",
        "MAP4_99S"
    ],
    "MAP4K4": [
        "MAP4K4_631S",
        "MAP4K4_639S"
    ],
    "MAP7D1": [
        "MAP7D1_112S",
        "MAP7D1_113S",
        "MAP7D1_116S",
        "MAP7D1_118T",
        "MAP7D1_125S",
        "MAP7D1_254S",
        "MAP7D1_313S",
        "MAP7D1_34S",
        "MAP7D1_399S",
        "MAP7D1_460S",
        "MAP7D1_47T",
        "MAP7D1_496S",
        "MAP7D1_51T",
        "MAP7D1_544S",
        "MAP7D1_548S",
        "MAP7D1_552S",
        "MAP7D1_70S",
        "MAP7D1_86S",
        "MAP7D1_97T"
    ],
    "MAP9": [
        "MAP9_79S"
    ],
    "MAPK14": [
        "MAPK14_182Y"
    ],
    "MAPK1IP1L": [
        "MAPK1IP1L_15S"
    ],
    "MAPK8IP3": [
        "MAPK8IP3_365S",
        "MAPK8IP3_585S"
    ],
    "MAPKAP1": [
        "MAPKAP1_510S"
    ],
    "MAPKBP1": [
        "MAPKBP1_761S"
    ],
    "MAPRE1": [
        "MAPRE1_155S"
    ],
    "MARCKS": [
        "MARCKS_101S",
        "MARCKS_118S",
        "MARCKS_145S",
        "MARCKS_150T",
        "MARCKS_27S",
        "MARCKS_46S"
    ],
    "MARS": [
        "MARS_824T",
        "MARS_825S"
    ],
    "MAST4": [
        "MAST4_1391S",
        "MAST4_1419S",
        "MAST4_1467S",
        "MAST4_1523S",
        "MAST4_1779S",
        "MAST4_1822S",
        "MAST4_1860S",
        "MAST4_2518S"
    ],
    "MAT2B": [
        "MAT2B_282S"
    ],
    "MAVS": [
        "MAVS_222S"
    ],
    "MBD2": [
        "MBD2_407S"
    ],
    "MBD4": [
        "MBD4_387S"
    ],
    "MBIP": [
        "MBIP_91S"
    ],
    "MBLAC1": [
        "MBLAC1_61S"
    ],
    "MBOAT2": [
        "MBOAT2_474T"
    ],
    "MCC": [
        "MCC_294S",
        "MCC_827T"
    ],
    "MCM2": [
        "MCM2_139S",
        "MCM2_26S",
        "MCM2_27S",
        "MCM2_40S",
        "MCM2_41S"
    ],
    "MCM3": [
        "MCM3_668S",
        "MCM3_672S",
        "MCM3_674T",
        "MCM3_711S",
        "MCM3_722T"
    ],
    "MCM3AP": [
        "MCM3AP_430S",
        "MCM3AP_527S"
    ],
    "MCMBP": [
        "MCMBP_154S",
        "MCMBP_298S"
    ],
    "MCTP2": [
        "MCTP2_134S",
        "MCTP2_135S"
    ],
    "MDC1": [
        "MDC1_108S",
        "MDC1_168S",
        "MDC1_299S",
        "MDC1_329S",
        "MDC1_376S",
        "MDC1_453S",
        "MDC1_495S",
        "MDC1_498S",
        "MDC1_793S",
        "MDC1_882S",
        "MDC1_964S",
        "MDC1_995S"
    ],
    "MDH1": [
        "MDH1_241S",
        "MDH1_242S"
    ],
    "MDN1": [
        "MDN1_4538S",
        "MDN1_4752S",
        "MDN1_4754S",
        "MDN1_4898T"
    ],
    "MECP2": [
        "MECP2_216S",
        "MECP2_229S",
        "MECP2_80S"
    ],
    "MED12": [
        "MED12_635S"
    ],
    "MED13": [
        "MED13_395S",
        "MED13_474T",
        "MED13_890S"
    ],
    "MED14": [
        "MED14_617S"
    ],
    "MED15": [
        "MED15_603T"
    ],
    "MED24": [
        "MED24_862S"
    ],
    "MED26": [
        "MED26_447S"
    ],
    "MEDAG": [
        "MEDAG_250S"
    ],
    "MEF2A": [
        "MEF2A_108T",
        "MEF2A_98S"
    ],
    "MEF2C": [
        "MEF2C_222S",
        "MEF2C_396S"
    ],
    "MEIS1": [
        "MEIS1_196S"
    ],
    "MEPCE": [
        "MEPCE_152S",
        "MEPCE_213T",
        "MEPCE_216S",
        "MEPCE_254S",
        "MEPCE_330S"
    ],
    "METTL14": [
        "METTL14_399S"
    ],
    "METTL16": [
        "METTL16_329S"
    ],
    "METTL22": [
        "METTL22_132S"
    ],
    "MFSD5": [
        "MFSD5_440S"
    ],
    "MIA2": [
        "MIA2_1202S",
        "MIA2_1204S"
    ],
    "MIA3": [
        "MIA3_1678S"
    ],
    "MIB2": [
        "MIB2_309S"
    ],
    "MICAL2": [
        "MICAL2_515S"
    ],
    "MICAL3": [
        "MICAL3_1143S",
        "MICAL3_1156S",
        "MICAL3_1221S",
        "MICAL3_1310S",
        "MICAL3_1649S",
        "MICAL3_1704S",
        "MICAL3_685S",
        "MICAL3_977S"
    ],
    "MICALL1": [
        "MICALL1_390S",
        "MICALL1_414S",
        "MICALL1_578S",
        "MICALL1_621S",
        "MICALL1_640S"
    ],
    "MICALL2": [
        "MICALL2_110S",
        "MICALL2_122S",
        "MICALL2_249S",
        "MICALL2_649S",
        "MICALL2_712S"
    ],
    "MIEF1": [
        "MIEF1_55S",
        "MIEF1_59S",
        "MIEF1_94S"
    ],
    "MIER1": [
        "MIER1_377S",
        "MIER1_483S"
    ],
    "MKI67": [
        "MKI67_1131S",
        "MKI67_1376S",
        "MKI67_2528S",
        "MKI67_2708S",
        "MKI67_2828S",
        "MKI67_579S",
        "MKI67_584S"
    ],
    "MLF1": [
        "MLF1_34S"
    ],
    "MLLT1": [
        "MLLT1_267S",
        "MLLT1_292S",
        "MLLT1_440S",
        "MLLT1_475S"
    ],
    "MLLT6": [
        "MLLT6_258S",
        "MLLT6_384S"
    ],
    "MMACHC": [
        "MMACHC_275S"
    ],
    "MME": [
        "MME_4S"
    ],
    "MMP1": [
        "MMP1_57S"
    ],
    "MMTAG2": [
        "MMTAG2_177S",
        "MMTAG2_220S"
    ],
    "MOCOS": [
        "MOCOS_530S"
    ],
    "MOCS2": [
        "MOCS2_20S"
    ],
    "MOCS3": [
        "MOCS3_47S"
    ],
    "MON1B": [
        "MON1B_61S"
    ],
    "MORC2": [
        "MORC2_615S",
        "MORC2_743S",
        "MORC2_777S",
        "MORC2_779S"
    ],
    "MPDZ": [
        "MPDZ_230S",
        "MPDZ_483S"
    ],
    "MPHOSPH10": [
        "MPHOSPH10_163S",
        "MPHOSPH10_167S",
        "MPHOSPH10_171S"
    ],
    "MPHOSPH8": [
        "MPHOSPH8_164S"
    ],
    "MPRIP": [
        "MPRIP_220S",
        "MPRIP_224S",
        "MPRIP_269S",
        "MPRIP_365S",
        "MPRIP_619S",
        "MPRIP_977S",
        "MPRIP_993S"
    ],
    "MPZL1": [
        "MPZL1_221S"
    ],
    "MRC2": [
        "MRC2_1457S"
    ],
    "MRPS16": [
        "MRPS16_130T"
    ],
    "MRPS36": [
        "MRPS36_59S",
        "MRPS36_61S"
    ],
    "MRTFB": [
        "MRTFB_211S",
        "MRTFB_225S"
    ],
    "MSH6": [
        "MSH6_227S"
    ],
    "MSL1": [
        "MSL1_161S",
        "MSL1_205S",
        "MSL1_362S",
        "MSL1_442S"
    ],
    "MSL3": [
        "MSL3_311S",
        "MSL3_400S"
    ],
    "MSX1": [
        "MSX1_152S",
        "MSX1_160S"
    ],
    "MTA1": [
        "MTA1_522S",
        "MTA1_576S"
    ],
    "MTCH1": [
        "MTCH1_381S"
    ],
    "MTCL1": [
        "MTCL1_1417T",
        "MTCL1_1421S",
        "MTCL1_1514S",
        "MTCL1_263S",
        "MTCL1_306S"
    ],
    "MTDH": [
        "MTDH_298S",
        "MTDH_426S"
    ],
    "MTFR1": [
        "MTFR1_119S"
    ],
    "MTFR1L": [
        "MTFR1L_238S",
        "MTFR1L_41S"
    ],
    "MTMR12": [
        "MTMR12_564S"
    ],
    "MTMR3": [
        "MTMR3_613S",
        "MTMR3_633S",
        "MTMR3_647S"
    ],
    "MTMR6": [
        "MTMR6_561S"
    ],
    "MVD": [
        "MVD_96S"
    ],
    "MVP": [
        "MVP_445S",
        "MVP_867S",
        "MVP_873S"
    ],
    "MXRA7": [
        "MXRA7_128S"
    ],
    "MYBBP1A": [
        "MYBBP1A_1163S",
        "MYBBP1A_11S",
        "MYBBP1A_1241S",
        "MYBBP1A_1267S"
    ],
    "MYCBP2": [
        "MYCBP2_181S",
        "MYCBP2_183S",
        "MYCBP2_2838S",
        "MYCBP2_2869S",
        "MYCBP2_3505S"
    ],
    "MYCT1": [
        "MYCT1_104S",
        "MYCT1_107S",
        "MYCT1_108S"
    ],
    "MYH10": [
        "MYH10_1975S"
    ],
    "MYH9": [
        "MYH9_1326S",
        "MYH9_1408Y",
        "MYH9_1713S",
        "MYH9_1943S",
        "MYH9_541S",
        "MYH9_725T",
        "MYH9_754Y"
    ],
    "MYLK": [
        "MYLK_1772S",
        "MYLK_1773S",
        "MYLK_1774T",
        "MYLK_1776S",
        "MYLK_1778T",
        "MYLK_1779S",
        "MYLK_305S"
    ],
    "MYO18A": [
        "MYO18A_140S",
        "MYO18A_1970S",
        "MYO18A_1974S",
        "MYO18A_1998S",
        "MYO18A_2007S",
        "MYO18A_2020S",
        "MYO18A_2041S",
        "MYO18A_2043S",
        "MYO18A_234S"
    ],
    "MYO9A": [
        "MYO9A_1258S",
        "MYO9A_1301S",
        "MYO9A_1733S"
    ],
    "MYO9B": [
        "MYO9B_1115S",
        "MYO9B_1242S",
        "MYO9B_1261S",
        "MYO9B_1267S",
        "MYO9B_1271T",
        "MYO9B_1281S",
        "MYO9B_1290S",
        "MYO9B_1405S"
    ],
    "MYOF": [
        "MYOF_1781T",
        "MYOF_1915S",
        "MYOF_731S"
    ],
    "MYPN": [
        "MYPN_644S",
        "MYPN_928S"
    ],
    "N4BP1": [
        "N4BP1_288S",
        "N4BP1_300S"
    ],
    "NAA10": [
        "NAA10_182S",
        "NAA10_186S",
        "NAA10_205S"
    ],
    "NAA15": [
        "NAA15_588S"
    ],
    "NAA30": [
        "NAA30_199S",
        "NAA30_55S"
    ],
    "NAA38": [
        "NAA38_22S",
        "NAA38_29S"
    ],
    "NAB1": [
        "NAB1_328S",
        "NAB1_395S"
    ],
    "NAB2": [
        "NAB2_157S",
        "NAB2_159S",
        "NAB2_162S",
        "NAB2_171S",
        "NAB2_434T",
        "NAB2_6S"
    ],
    "NAF1": [
        "NAF1_315S"
    ],
    "NAMPT": [
        "NAMPT_472S"
    ],
    "NAP1L1": [
        "NAP1L1_62T",
        "NAP1L1_69S"
    ],
    "NASP": [
        "NASP_421S",
        "NASP_451S",
        "NASP_726S"
    ],
    "NAV1": [
        "NAV1_312S",
        "NAV1_672S",
        "NAV1_760S"
    ],
    "NAV2": [
        "NAV2_1321T",
        "NAV2_1502S",
        "NAV2_1977S",
        "NAV2_433S"
    ],
    "NBAS": [
        "NBAS_473S"
    ],
    "NBN": [
        "NBN_432S"
    ],
    "NCAPD2": [
        "NCAPD2_1389T"
    ],
    "NCAPG": [
        "NCAPG_390S",
        "NCAPG_674S",
        "NCAPG_973S",
        "NCAPG_975S"
    ],
    "NCAPH2": [
        "NCAPH2_284S"
    ],
    "NCBP1": [
        "NCBP1_21T",
        "NCBP1_22S",
        "NCBP1_674S",
        "NCBP1_7S"
    ],
    "NCBP3": [
        "NCBP3_25S"
    ],
    "NCK1": [
        "NCK1_85S"
    ],
    "NCL": [
        "NCL_580S",
        "NCL_619S",
        "NCL_67S",
        "NCL_69T"
    ],
    "NCOA1": [
        "NCOA1_22S"
    ],
    "NCOA2": [
        "NCOA2_29S",
        "NCOA2_736S"
    ],
    "NCOA3": [
        "NCOA3_1166T",
        "NCOA3_214S",
        "NCOA3_728S",
        "NCOA3_857S"
    ],
    "NCOA5": [
        "NCOA5_126S",
        "NCOA5_29S",
        "NCOA5_34S"
    ],
    "NCOA7": [
        "NCOA7_208S",
        "NCOA7_211S"
    ],
    "NCOR1": [
        "NCOR1_1111S",
        "NCOR1_1196S",
        "NCOR1_1472S",
        "NCOR1_2120S",
        "NCOR1_2184S"
    ],
    "NCOR2": [
        "NCOR2_1017S",
        "NCOR2_1023S",
        "NCOR2_1025S",
        "NCOR2_1251S",
        "NCOR2_1341S",
        "NCOR2_1383T",
        "NCOR2_1479S",
        "NCOR2_152S",
        "NCOR2_1971S",
        "NCOR2_2194S",
        "NCOR2_2197S",
        "NCOR2_2203S",
        "NCOR2_2223S",
        "NCOR2_2258S",
        "NCOR2_553T",
        "NCOR2_554S",
        "NCOR2_939S",
        "NCOR2_956S"
    ],
    "NDC1": [
        "NDC1_406S"
    ],
    "NDEL1": [
        "NDEL1_198S",
        "NDEL1_336S"
    ],
    "NDRG1": [
        "NDRG1_328T",
        "NDRG1_330S",
        "NDRG1_332S",
        "NDRG1_333S",
        "NDRG1_335T",
        "NDRG1_336S"
    ],
    "NDUFV3": [
        "NDUFV3_105S"
    ],
    "NECTIN1": [
        "NECTIN1_422S",
        "NECTIN1_434S",
        "NECTIN1_435S"
    ],
    "NEDD4": [
        "NEDD4_670S"
    ],
    "NEDD4L": [
        "NEDD4L_302T",
        "NEDD4L_303S"
    ],
    "NEK1": [
        "NEK1_837S"
    ],
    "NEK3": [
        "NEK3_354S",
        "NEK3_355S"
    ],
    "NEK9": [
        "NEK9_254T",
        "NEK9_331S",
        "NEK9_333T",
        "NEK9_868S",
        "NEK9_869S",
        "NEK9_944S"
    ],
    "NELFA": [
        "NELFA_363S",
        "NELFA_365T"
    ],
    "NELFB": [
        "NELFB_557S"
    ],
    "NELFE": [
        "NELFE_115S",
        "NELFE_179S",
        "NELFE_251S",
        "NELFE_49S"
    ],
    "NEMF": [
        "NEMF_831S"
    ],
    "NES": [
        "NES_1496S",
        "NES_1498S",
        "NES_680S",
        "NES_713S",
        "NES_768S"
    ],
    "NEURL4": [
        "NEURL4_502S"
    ],
    "NEXN": [
        "NEXN_243S",
        "NEXN_80S"
    ],
    "NF1": [
        "NF1_2523S",
        "NF1_2543S",
        "NF1_2565T",
        "NF1_864S"
    ],
    "NF2": [
        "NF2_518S"
    ],
    "NFATC2IP": [
        "NFATC2IP_204S"
    ],
    "NFATC3": [
        "NFATC3_343T",
        "NFATC3_344S"
    ],
    "NFIA": [
        "NFIA_280S"
    ],
    "NFIC": [
        "NFIC_194S",
        "NFIC_322S",
        "NFIC_323S",
        "NFIC_333S",
        "NFIC_339S"
    ],
    "NFRKB": [
        "NFRKB_1288T",
        "NFRKB_226S",
        "NFRKB_351S"
    ],
    "NGDN": [
        "NGDN_142S",
        "NGDN_143S"
    ],
    "NHSL1": [
        "NHSL1_1089S",
        "NHSL1_941S"
    ],
    "NIBAN2": [
        "NIBAN2_665S",
        "NIBAN2_681S",
        "NIBAN2_691S",
        "NIBAN2_692S",
        "NIBAN2_696S"
    ],
    "NID1": [
        "NID1_600S"
    ],
    "NIFK": [
        "NIFK_223T",
        "NIFK_238T"
    ],
    "NIPBL": [
        "NIPBL_2658S",
        "NIPBL_2672S",
        "NIPBL_305S",
        "NIPBL_318S",
        "NIPBL_713T",
        "NIPBL_757T"
    ],
    "NKTR": [
        "NKTR_463S"
    ],
    "NMBR": [
        "NMBR_374T",
        "NMBR_376S"
    ],
    "NMD3": [
        "NMD3_433T",
        "NMD3_468S",
        "NMD3_470T"
    ],
    "NME2P1": [
        "NME2P1_79T"
    ],
    "NMNAT1": [
        "NMNAT1_117S"
    ],
    "NMT2": [
        "NMT2_38S"
    ],
    "NOB1": [
        "NOB1_184S",
        "NOB1_201S"
    ],
    "NOC2L": [
        "NOC2L_49S",
        "NOC2L_56S"
    ],
    "NOL4L": [
        "NOL4L_130S",
        "NOL4L_400S"
    ],
    "NOL8": [
        "NOL8_1099S",
        "NOL8_365S",
        "NOL8_888T",
        "NOL8_890S"
    ],
    "NOLC1": [
        "NOLC1_563S"
    ],
    "NONO": [
        "NONO_428T"
    ],
    "NOP14": [
        "NOP14_146S",
        "NOP14_148S"
    ],
    "NOP2": [
        "NOP2_732S"
    ],
    "NOP56": [
        "NOP56_466S",
        "NOP56_467S",
        "NOP56_519S",
        "NOP56_520S",
        "NOP56_563S",
        "NOP56_569S",
        "NOP56_570S"
    ],
    "NOP58": [
        "NOP58_502S",
        "NOP58_514S"
    ],
    "NOSIP": [
        "NOSIP_107S"
    ],
    "NPM1": [
        "NPM1_125S",
        "NPM1_139S",
        "NPM1_227S",
        "NPM1_242S",
        "NPM1_254S",
        "NPM1_70S"
    ],
    "NR1H3": [
        "NR1H3_197S",
        "NR1H3_198S"
    ],
    "NR3C1": [
        "NR3C1_134S"
    ],
    "NRBP1": [
        "NRBP1_431T",
        "NRBP1_433T"
    ],
    "NRDC": [
        "NRDC_86S",
        "NRDC_94S"
    ],
    "NSD3": [
        "NSD3_150S"
    ],
    "NSRP1": [
        "NSRP1_248S",
        "NSRP1_254S",
        "NSRP1_33S"
    ],
    "NSUN2": [
        "NSUN2_453T",
        "NSUN2_456S",
        "NSUN2_743S",
        "NSUN2_751S"
    ],
    "NSUN5P2": [
        "NSUN5P2_143S"
    ],
    "NUCKS1": [
        "NUCKS1_181S",
        "NUCKS1_214S",
        "NUCKS1_234S",
        "NUCKS1_58S",
        "NUCKS1_73S",
        "NUCKS1_75S",
        "NUCKS1_79S"
    ],
    "NUDC": [
        "NUDC_108T",
        "NUDC_139S",
        "NUDC_145T"
    ],
    "NUDT9": [
        "NUDT9_67T",
        "NUDT9_68S"
    ],
    "NUFIP2": [
        "NUFIP2_212S",
        "NUFIP2_571T",
        "NUFIP2_572S",
        "NUFIP2_629S",
        "NUFIP2_652S",
        "NUFIP2_655S"
    ],
    "NUMA1": [
        "NUMA1_169S",
        "NUMA1_1757S",
        "NUMA1_271S"
    ],
    "NUMB": [
        "NUMB_436T",
        "NUMB_438S"
    ],
    "NUMBL": [
        "NUMBL_263S",
        "NUMBL_265T",
        "NUMBL_409T",
        "NUMBL_411S"
    ],
    "NUP107": [
        "NUP107_86S"
    ],
    "NUP153": [
        "NUP153_192S",
        "NUP153_209S",
        "NUP153_528S",
        "NUP153_588T"
    ],
    "NUP160": [
        "NUP160_1157S"
    ],
    "NUP188": [
        "NUP188_1523S",
        "NUP188_1709S",
        "NUP188_1717S"
    ],
    "NUP214": [
        "NUP214_430S",
        "NUP214_433S",
        "NUP214_437T",
        "NUP214_648S",
        "NUP214_670T",
        "NUP214_678S",
        "NUP214_940S"
    ],
    "NUP35": [
        "NUP35_259S",
        "NUP35_265T",
        "NUP35_73S"
    ],
    "NUP50": [
        "NUP50_221S"
    ],
    "NUP54": [
        "NUP54_289S"
    ],
    "NUP88": [
        "NUP88_35S",
        "NUP88_443T",
        "NUP88_50S",
        "NUP88_517S",
        "NUP88_525T"
    ],
    "NUP98": [
        "NUP98_1288S",
        "NUP98_1816S",
        "NUP98_612S",
        "NUP98_623S",
        "NUP98_670T",
        "NUP98_839S",
        "NUP98_888S",
        "NUP98_934S"
    ],
    "OCIAD1": [
        "OCIAD1_108S",
        "OCIAD1_122S",
        "OCIAD1_123S"
    ],
    "OGFR": [
        "OGFR_315S",
        "OGFR_378S",
        "OGFR_517S",
        "OGFR_577S",
        "OGFR_597S",
        "OGFR_599S"
    ],
    "OLFML2A": [
        "OLFML2A_334S"
    ],
    "OPTN": [
        "OPTN_177S",
        "OPTN_198S",
        "OPTN_342S",
        "OPTN_525T",
        "OPTN_526S"
    ],
    "OSBP": [
        "OSBP_190S",
        "OSBP_193S",
        "OSBP_240S"
    ],
    "OSBPL3": [
        "OSBPL3_249T",
        "OSBPL3_303S",
        "OSBPL3_304S",
        "OSBPL3_372S",
        "OSBPL3_437S"
    ],
    "OSBPL5": [
        "OSBPL5_325S"
    ],
    "OSBPL6": [
        "OSBPL6_190S"
    ],
    "OSBPL7": [
        "OSBPL7_272S"
    ],
    "OSBPL8": [
        "OSBPL8_342S",
        "OSBPL8_807S",
        "OSBPL8_808S",
        "OSBPL8_810S"
    ],
    "OSTF1": [
        "OSTF1_202S",
        "OSTF1_213S"
    ],
    "OSTM1": [
        "OSTM1_322S",
        "OSTM1_325S"
    ],
    "OTUD4": [
        "OTUD4_1006S",
        "OTUD4_443S",
        "OTUD4_546S"
    ],
    "OTULIN": [
        "OTULIN_350T"
    ],
    "OXSR1": [
        "OXSR1_324S",
        "OXSR1_339S",
        "OXSR1_427S"
    ],
    "PA2G4": [
        "PA2G4_361S",
        "PA2G4_363S",
        "PA2G4_383S",
        "PA2G4_386T"
    ],
    "PACS1": [
        "PACS1_430S",
        "PACS1_495S",
        "PACS1_510S"
    ],
    "PACSIN3": [
        "PACSIN3_276S",
        "PACSIN3_319S"
    ],
    "PAF1": [
        "PAF1_439S"
    ],
    "PAGR1": [
        "PAGR1_237S"
    ],
    "PAICS": [
        "PAICS_107S",
        "PAICS_238T",
        "PAICS_27S"
    ],
    "PAK1": [
        "PAK1_144S",
        "PAK1_146T",
        "PAK1_174S",
        "PAK1_212T",
        "PAK1_229T",
        "PAK1_230T",
        "PAK1_249S"
    ],
    "PAK1IP1": [
        "PAK1IP1_320S"
    ],
    "PAK2": [
        "PAK2_169T"
    ],
    "PAK4": [
        "PAK4_104S",
        "PAK4_181S",
        "PAK4_207T",
        "PAK4_474S"
    ],
    "PAK6": [
        "PAK6_616S"
    ],
    "PALLD": [
        "PALLD_1101S",
        "PALLD_1104S",
        "PALLD_1116S",
        "PALLD_1118S",
        "PALLD_1121S",
        "PALLD_1179S",
        "PALLD_893S"
    ],
    "PAM16": [
        "PAM16_69S"
    ],
    "PAN2": [
        "PAN2_1189S"
    ],
    "PANK4": [
        "PANK4_63S"
    ],
    "PAPOLA": [
        "PAPOLA_24S",
        "PAPOLA_544T",
        "PAPOLA_654S"
    ],
    "PAPOLG": [
        "PAPOLG_525S"
    ],
    "PARD3": [
        "PARD3_852S"
    ],
    "PARD3B": [
        "PARD3B_710S",
        "PARD3B_730S"
    ],
    "PARG": [
        "PARG_137S",
        "PARG_291S",
        "PARG_302S"
    ],
    "PARN": [
        "PARN_163S",
        "PARN_619S"
    ],
    "PARP4": [
        "PARP4_101T",
        "PARP4_1186S",
        "PARP4_1722S",
        "PARP4_333T"
    ],
    "PARVA": [
        "PARVA_14S",
        "PARVA_19S"
    ],
    "PATJ": [
        "PATJ_645S"
    ],
    "PATL1": [
        "PATL1_179S",
        "PATL1_194T"
    ],
    "PAXBP1": [
        "PAXBP1_16S",
        "PAXBP1_262S",
        "PAXBP1_62S"
    ],
    "PAXX": [
        "PAXX_148S"
    ],
    "PBDC1": [
        "PBDC1_181S",
        "PBDC1_197S"
    ],
    "PBK": [
        "PBK_59S"
    ],
    "PBRM1": [
        "PBRM1_1453S",
        "PBRM1_948S",
        "PBRM1_987S"
    ],
    "PBXIP1": [
        "PBXIP1_43S"
    ],
    "PCBP1": [
        "PCBP1_173S",
        "PCBP1_189S",
        "PCBP1_190S"
    ],
    "PCBP2": [
        "PCBP2_173S",
        "PCBP2_189S"
    ],
    "PCDH7": [
        "PCDH7_989S"
    ],
    "PCDHGC3": [
        "PCDHGC3_780S"
    ],
    "PCF11": [
        "PCF11_1530T",
        "PCF11_487S",
        "PCF11_489S",
        "PCF11_494S",
        "PCF11_705S"
    ],
    "PCGF6": [
        "PCGF6_115S"
    ],
    "PCIF1": [
        "PCIF1_116S",
        "PCIF1_158T"
    ],
    "PCM1": [
        "PCM1_1730S",
        "PCM1_643S",
        "PCM1_644S",
        "PCM1_65S"
    ],
    "PCNT": [
        "PCNT_1653S",
        "PCNT_2177S",
        "PCNT_2352S",
        "PCNT_3249S"
    ],
    "PCYT1A": [
        "PCYT1A_319S",
        "PCYT1A_323S",
        "PCYT1A_329S",
        "PCYT1A_331S",
        "PCYT1A_342T",
        "PCYT1A_343S",
        "PCYT1A_362S"
    ],
    "PCYT1B": [
        "PCYT1B_315S"
    ],
    "PDAP1": [
        "PDAP1_60S",
        "PDAP1_63S"
    ],
    "PDCD11": [
        "PDCD11_1360S"
    ],
    "PDCD4": [
        "PDCD4_93T"
    ],
    "PDCD5": [
        "PDCD5_119S",
        "PDCD5_125Y"
    ],
    "PDE2A": [
        "PDE2A_937S"
    ],
    "PDE3B": [
        "PDE3B_318S",
        "PDE3B_65S"
    ],
    "PDE4A": [
        "PDE4A_686S",
        "PDE4A_688S"
    ],
    "PDE4B": [
        "PDE4B_140S",
        "PDE4B_145S"
    ],
    "PDE8A": [
        "PDE8A_457S"
    ],
    "PDGFRB": [
        "PDGFRB_705S"
    ],
    "PDLIM1": [
        "PDLIM1_90S"
    ],
    "PDLIM4": [
        "PDLIM4_112S",
        "PDLIM4_120S"
    ],
    "PDLIM7": [
        "PDLIM7_217S"
    ],
    "PDPK2P": [
        "PDPK2P_214S"
    ],
    "PDS5B": [
        "PDS5B_1220T",
        "PDS5B_1257S",
        "PDS5B_1283S",
        "PDS5B_1358S"
    ],
    "PDZD8": [
        "PDZD8_538S",
        "PDZD8_767T",
        "PDZD8_769T",
        "PDZD8_975S",
        "PDZD8_980S"
    ],
    "PEAK1": [
        "PEAK1_1151T",
        "PEAK1_281S",
        "PEAK1_572S"
    ],
    "PEBP1": [
        "PEBP1_52S"
    ],
    "PEG10": [
        "PEG10_252S"
    ],
    "PELO": [
        "PELO_374S"
    ],
    "PELP1": [
        "PELP1_1033S",
        "PELP1_477S",
        "PELP1_481S",
        "PELP1_485S"
    ],
    "PEX19": [
        "PEX19_147S"
    ],
    "PFDN4": [
        "PFDN4_125S"
    ],
    "PFKFB2": [
        "PFKFB2_493S"
    ],
    "PFKFB3": [
        "PFKFB3_461S"
    ],
    "PFKL": [
        "PFKL_775S"
    ],
    "PFKP": [
        "PFKP_386S"
    ],
    "PGM2": [
        "PGM2_165S"
    ],
    "PGRMC1": [
        "PGRMC1_178T",
        "PGRMC1_181S",
        "PGRMC1_57S"
    ],
    "PGRMC2": [
        "PGRMC2_104S",
        "PGRMC2_208S",
        "PGRMC2_211T",
        "PGRMC2_90S"
    ],
    "PHACTR2": [
        "PHACTR2_25T"
    ],
    "PHACTR4": [
        "PHACTR4_118S",
        "PHACTR4_342S",
        "PHACTR4_344S",
        "PHACTR4_358T",
        "PHACTR4_464S",
        "PHACTR4_628S"
    ],
    "PHB2": [
        "PHB2_291S"
    ],
    "PHC3": [
        "PHC3_609T",
        "PHC3_616S"
    ],
    "PHF12": [
        "PHF12_131S",
        "PHF12_133S",
        "PHF12_671T",
        "PHF12_880T"
    ],
    "PHF2": [
        "PHF2_474S",
        "PHF2_539S",
        "PHF2_541T",
        "PHF2_899S",
        "PHF2_905S"
    ],
    "PHF20": [
        "PHF20_902S"
    ],
    "PHF21A": [
        "PHF21A_350T"
    ],
    "PHF3": [
        "PHF3_1133S",
        "PHF3_1642S",
        "PHF3_1898S",
        "PHF3_1925S",
        "PHF3_283S"
    ],
    "PHF6": [
        "PHF6_204S"
    ],
    "PHIP": [
        "PHIP_1281S",
        "PHIP_1283S",
        "PHIP_1457S",
        "PHIP_911S"
    ],
    "PHKA1": [
        "PHKA1_758S"
    ],
    "PHKA2": [
        "PHKA2_729S"
    ],
    "PHLDA2": [
        "PHLDA2_144S"
    ],
    "PHLDB1": [
        "PHLDB1_223S",
        "PHLDB1_324S",
        "PHLDB1_563S",
        "PHLDB1_564S",
        "PHLDB1_678S",
        "PHLDB1_971S"
    ],
    "PHLDB2": [
        "PHLDB2_415S",
        "PHLDB2_468S",
        "PHLDB2_513S",
        "PHLDB2_550T",
        "PHLDB2_574T"
    ],
    "PHRF1": [
        "PHRF1_1034S",
        "PHRF1_1124S",
        "PHRF1_1127S",
        "PHRF1_1202S",
        "PHRF1_1229S",
        "PHRF1_1360S",
        "PHRF1_1371S",
        "PHRF1_1373S",
        "PHRF1_814S",
        "PHRF1_867S",
        "PHRF1_915S",
        "PHRF1_973S",
        "PHRF1_991S",
        "PHRF1_993S"
    ],
    "PI4K2A": [
        "PI4K2A_461S",
        "PI4K2A_47S",
        "PI4K2A_51S"
    ],
    "PI4KB": [
        "PI4KB_277S",
        "PI4KB_428S",
        "PI4KB_511S"
    ],
    "PIAS1": [
        "PIAS1_485S",
        "PIAS1_503S"
    ],
    "PIEZO1": [
        "PIEZO1_1391S",
        "PIEZO1_1395S",
        "PIEZO1_1396S",
        "PIEZO1_1621S",
        "PIEZO1_1646S"
    ],
    "PIK3C2A": [
        "PIK3C2A_259S"
    ],
    "PIK3C3": [
        "PIK3C3_244S"
    ],
    "PIK3R2": [
        "PIK3R2_263S"
    ],
    "PIP4P1": [
        "PIP4P1_162S"
    ],
    "PIP5K1A": [
        "PIP5K1A_458S"
    ],
    "PITPNC1": [
        "PITPNC1_299S"
    ],
    "PITPNM2": [
        "PITPNM2_894S"
    ],
    "PITX1": [
        "PITX1_51S"
    ],
    "PJA1": [
        "PJA1_265S"
    ],
    "PKD2": [
        "PKD2_166S",
        "PKD2_812S"
    ],
    "PKM": [
        "PKM_100S",
        "PKM_249S",
        "PKM_37S",
        "PKM_437S",
        "PKM_519S"
    ],
    "PKMYT1": [
        "PKMYT1_50S"
    ],
    "PKN1": [
        "PKN1_562S"
    ],
    "PKN2": [
        "PKN2_583S",
        "PKN2_816T",
        "PKN2_958T"
    ],
    "PKP3": [
        "PKP3_313S",
        "PKP3_314S"
    ],
    "PLCB3": [
        "PLCB3_1105S",
        "PLCB3_1107S",
        "PLCB3_480S",
        "PLCB3_537S"
    ],
    "PLCD3": [
        "PLCD3_496S"
    ],
    "PLCH2": [
        "PLCH2_1202S",
        "PLCH2_1256S",
        "PLCH2_1279S",
        "PLCH2_487S",
        "PLCH2_491S",
        "PLCH2_562S",
        "PLCH2_595S",
        "PLCH2_906S",
        "PLCH2_982S"
    ],
    "PLEC": [
        "PLEC_1047S",
        "PLEC_125S",
        "PLEC_1435S",
        "PLEC_149S",
        "PLEC_1721S",
        "PLEC_1732S",
        "PLEC_2039S",
        "PLEC_2578S",
        "PLEC_2886T",
        "PLEC_4030T",
        "PLEC_4386S",
        "PLEC_4389S",
        "PLEC_4396S",
        "PLEC_4613S",
        "PLEC_720S"
    ],
    "PLEKHA2": [
        "PLEKHA2_401S"
    ],
    "PLEKHA4": [
        "PLEKHA4_575S",
        "PLEKHA4_590S"
    ],
    "PLEKHA5": [
        "PLEKHA5_855S"
    ],
    "PLEKHF1": [
        "PLEKHF1_227S"
    ],
    "PLEKHG3": [
        "PLEKHG3_1037S",
        "PLEKHG3_1081S",
        "PLEKHG3_631S",
        "PLEKHG3_643S",
        "PLEKHG3_647S",
        "PLEKHG3_741S",
        "PLEKHG3_76S"
    ],
    "PLEKHG4": [
        "PLEKHG4_677S"
    ],
    "PLEKHG5": [
        "PLEKHG5_249S",
        "PLEKHG5_907S",
        "PLEKHG5_911S"
    ],
    "PLEKHN1": [
        "PLEKHN1_559S"
    ],
    "PLEKHO2": [
        "PLEKHO2_389S",
        "PLEKHO2_390S"
    ],
    "PLIN3": [
        "PLIN3_130S"
    ],
    "PLPP3": [
        "PLPP3_19S",
        "PLPP3_297S"
    ],
    "PLXDC2": [
        "PLXDC2_506S"
    ],
    "PLXNC1": [
        "PLXNC1_978S"
    ],
    "PML": [
        "PML_36S",
        "PML_38S",
        "PML_403S",
        "PML_408S",
        "PML_40S",
        "PML_480S",
        "PML_48S",
        "PML_504S",
        "PML_505S",
        "PML_518S",
        "PML_527S",
        "PML_530S",
        "PML_8S"
    ],
    "PMS2CL": [
        "PMS2CL_59S"
    ],
    "PNISR": [
        "PNISR_211S",
        "PNISR_290S",
        "PNISR_408S",
        "PNISR_410T",
        "PNISR_601S",
        "PNISR_670S",
        "PNISR_672S"
    ],
    "PNKP": [
        "PNKP_114S",
        "PNKP_118T"
    ],
    "PNN": [
        "PNN_100S",
        "PNN_347S",
        "PNN_66S",
        "PNN_68S",
        "PNN_96S"
    ],
    "PNPLA6": [
        "PNPLA6_1339S"
    ],
    "PNPO": [
        "PNPO_241S"
    ],
    "POGZ": [
        "POGZ_1364S",
        "POGZ_425S",
        "POGZ_445S"
    ],
    "POLD3": [
        "POLD3_307S"
    ],
    "POLE": [
        "POLE_1940S"
    ],
    "POLR2A": [
        "POLR2A_1861S",
        "POLR2A_1875S",
        "POLR2A_1882S",
        "POLR2A_1919T"
    ],
    "POLR2M": [
        "POLR2M_10S"
    ],
    "POLR3C": [
        "POLR3C_204S",
        "POLR3C_205S"
    ],
    "POLR3E": [
        "POLR3E_161S",
        "POLR3E_162S"
    ],
    "POLR3G": [
        "POLR3G_157S"
    ],
    "POM121C": [
        "POM121C_2S",
        "POM121C_322S",
        "POM121C_323S",
        "POM121C_424T",
        "POM121C_95S"
    ],
    "POP1": [
        "POP1_367S",
        "POP1_730S"
    ],
    "POP5": [
        "POP5_154S"
    ],
    "POU2F1": [
        "POU2F1_448S"
    ],
    "PPA2": [
        "PPA2_298S",
        "PPA2_316S",
        "PPA2_317S"
    ],
    "PPAN": [
        "PPAN_359S"
    ],
    "PPFIA1": [
        "PPFIA1_1159T",
        "PPFIA1_238S",
        "PPFIA1_239S",
        "PPFIA1_242S",
        "PPFIA1_693S",
        "PPFIA1_708S",
        "PPFIA1_740T"
    ],
    "PPFIBP1": [
        "PPFIBP1_37S",
        "PPFIBP1_466S",
        "PPFIBP1_540S",
        "PPFIBP1_579S",
        "PPFIBP1_599S",
        "PPFIBP1_601S",
        "PPFIBP1_636S",
        "PPFIBP1_794S"
    ],
    "PPHLN1": [
        "PPHLN1_200T",
        "PPHLN1_201S",
        "PPHLN1_204T"
    ],
    "PPIG": [
        "PPIG_356S",
        "PPIG_358T",
        "PPIG_397S",
        "PPIG_585S",
        "PPIG_587S",
        "PPIG_687S",
        "PPIG_717S"
    ],
    "PPIL4": [
        "PPIL4_178S"
    ],
    "PPIP5K1": [
        "PPIP5K1_1152S",
        "PPIP5K1_964S"
    ],
    "PPIP5K2": [
        "PPIP5K2_38S",
        "PPIP5K2_491T",
        "PPIP5K2_493S",
        "PPIP5K2_498S"
    ],
    "PPM1G": [
        "PPM1G_528T",
        "PPM1G_537S"
    ],
    "PPME1": [
        "PPME1_243S"
    ],
    "PPP1R10": [
        "PPP1R10_313S",
        "PPP1R10_382S",
        "PPP1R10_545S"
    ],
    "PPP1R12A": [
        "PPP1R12A_299S",
        "PPP1R12A_422S",
        "PPP1R12A_443T",
        "PPP1R12A_507S",
        "PPP1R12A_995S"
    ],
    "PPP1R12C": [
        "PPP1R12C_498S"
    ],
    "PPP1R18": [
        "PPP1R18_125S",
        "PPP1R18_145S",
        "PPP1R18_195S",
        "PPP1R18_224S",
        "PPP1R18_368S",
        "PPP1R18_490S",
        "PPP1R18_493T"
    ],
    "PPP1R2B": [
        "PPP1R2B_121S",
        "PPP1R2B_122S"
    ],
    "PPP1R35": [
        "PPP1R35_52S"
    ],
    "PPP1R37": [
        "PPP1R37_50S"
    ],
    "PPP1R3D": [
        "PPP1R3D_74S",
        "PPP1R3D_78S"
    ],
    "PPP1R9B": [
        "PPP1R9B_100S",
        "PPP1R9B_205S"
    ],
    "PPP2CA": [
        "PPP2CA_304T"
    ],
    "PPP2R3A": [
        "PPP2R3A_181S",
        "PPP2R3A_687S",
        "PPP2R3A_692S"
    ],
    "PPP2R5D": [
        "PPP2R5D_573S"
    ],
    "PPP3CB": [
        "PPP3CB_478S"
    ],
    "PPP6R1": [
        "PPP6R1_529S",
        "PPP6R1_530S",
        "PPP6R1_531S"
    ],
    "PPP6R2": [
        "PPP6R2_771S"
    ],
    "PPP6R3": [
        "PPP6R3_617S",
        "PPP6R3_631T"
    ],
    "PRAG1": [
        "PRAG1_696S",
        "PRAG1_740S",
        "PRAG1_745S",
        "PRAG1_827S"
    ],
    "PRCC": [
        "PRCC_157S",
        "PRCC_159S",
        "PRCC_267S"
    ],
    "PRDM2": [
        "PRDM2_643S",
        "PRDM2_796S"
    ],
    "PRDX6": [
        "PRDX6_44T"
    ],
    "PRICKLE3": [
        "PRICKLE3_437S"
    ],
    "PRKAA1": [
        "PRKAA1_496S"
    ],
    "PRKAB1": [
        "PRKAB1_108S",
        "PRKAB1_181S"
    ],
    "PRKAB2": [
        "PRKAB2_39S"
    ],
    "PRKAR1B": [
        "PRKAR1B_77S",
        "PRKAR1B_83S"
    ],
    "PRKAR2A": [
        "PRKAR2A_78S",
        "PRKAR2A_80S",
        "PRKAR2A_99S"
    ],
    "PRKCA": [
        "PRKCA_226S",
        "PRKCA_497T",
        "PRKCA_501T"
    ],
    "PRKCD": [
        "PRKCD_304S",
        "PRKCD_664S"
    ],
    "PRKCE": [
        "PRKCE_729S"
    ],
    "PRKD1": [
        "PRKD1_205S",
        "PRKD1_208S"
    ],
    "PRKD3": [
        "PRKD3_213S",
        "PRKD3_216S",
        "PRKD3_252S",
        "PRKD3_27S",
        "PRKD3_30S",
        "PRKD3_31S",
        "PRKD3_364S",
        "PRKD3_391S",
        "PRKD3_731S",
        "PRKD3_735S"
    ],
    "PRKDC": [
        "PRKDC_3205S",
        "PRKDC_4026S",
        "PRKDC_893S"
    ],
    "PRKY": [
        "PRKY_201T"
    ],
    "PRMT3": [
        "PRMT3_25S",
        "PRMT3_27S"
    ],
    "PRMT6": [
        "PRMT6_21T"
    ],
    "PROM2": [
        "PROM2_815S",
        "PROM2_818S"
    ],
    "PROSER2": [
        "PROSER2_179S",
        "PROSER2_31S"
    ],
    "PROX1": [
        "PROX1_511S"
    ],
    "PRPF31": [
        "PRPF31_455T"
    ],
    "PRPF38B": [
        "PRPF38B_491S",
        "PRPF38B_527S",
        "PRPF38B_529S"
    ],
    "PRPF40A": [
        "PRPF40A_373T",
        "PRPF40A_748S",
        "PRPF40A_787S",
        "PRPF40A_883S",
        "PRPF40A_885S",
        "PRPF40A_888S",
        "PRPF40A_933S",
        "PRPF40A_935S",
        "PRPF40A_938S"
    ],
    "PRPF40B": [
        "PRPF40B_764S",
        "PRPF40B_832S"
    ],
    "PRPF4B": [
        "PRPF4B_20S",
        "PRPF4B_239S",
        "PRPF4B_241S",
        "PRPF4B_243T",
        "PRPF4B_257S",
        "PRPF4B_277S",
        "PRPF4B_292S",
        "PRPF4B_294S",
        "PRPF4B_32S",
        "PRPF4B_354S",
        "PRPF4B_356S",
        "PRPF4B_366S",
        "PRPF4B_368S",
        "PRPF4B_387S",
        "PRPF4B_394S",
        "PRPF4B_396S",
        "PRPF4B_427S",
        "PRPF4B_431S",
        "PRPF4B_437S",
        "PRPF4B_576T",
        "PRPF4B_578S",
        "PRPF4B_580S",
        "PRPF4B_849Y"
    ],
    "PRR11": [
        "PRR11_40S"
    ],
    "PRR12": [
        "PRR12_1135S",
        "PRR12_1308S",
        "PRR12_1381S",
        "PRR12_1382S",
        "PRR12_1561T",
        "PRR12_1568S",
        "PRR12_1705T",
        "PRR12_651S"
    ],
    "PRR14": [
        "PRR14_363T"
    ],
    "PRR5": [
        "PRR5_252S"
    ],
    "PRRC2A": [
        "PRRC2A_1089S",
        "PRRC2A_1219S",
        "PRRC2A_1670S",
        "PRRC2A_1671S",
        "PRRC2A_342S",
        "PRRC2A_350S",
        "PRRC2A_363S",
        "PRRC2A_380S",
        "PRRC2A_383S",
        "PRRC2A_610T",
        "PRRC2A_761S",
        "PRRC2A_782T",
        "PRRC2A_808S"
    ],
    "PRRC2B": [
        "PRRC2B_388S",
        "PRRC2B_480S",
        "PRRC2B_853S"
    ],
    "PRRC2C": [
        "PRRC2C_2105S"
    ],
    "PSD3": [
        "PSD3_1020S"
    ],
    "PSEN2": [
        "PSEN2_25S"
    ],
    "PSIP1": [
        "PSIP1_122T",
        "PSIP1_129S"
    ],
    "PSMA3": [
        "PSMA3_250S"
    ],
    "PSMB10": [
        "PSMB10_230S"
    ],
    "PSMD1": [
        "PSMD1_311T",
        "PSMD1_315S"
    ],
    "PSMD2": [
        "PSMD2_16S",
        "PSMD2_363S"
    ],
    "PSME2": [
        "PSME2_10S"
    ],
    "PSMF1": [
        "PSMF1_152S",
        "PSMF1_153S"
    ],
    "PSMG1": [
        "PSMG1_18T"
    ],
    "PSPC1": [
        "PSPC1_477S"
    ],
    "PTBP1": [
        "PTBP1_141S"
    ],
    "PTBP3": [
        "PTBP3_56S"
    ],
    "PTDSS1": [
        "PTDSS1_11S",
        "PTDSS1_442S"
    ],
    "PTDSS2": [
        "PTDSS2_16S"
    ],
    "PTEN": [
        "PTEN_294S"
    ],
    "PTGR2": [
        "PTGR2_270S"
    ],
    "PTK2": [
        "PTK2_708S",
        "PTK2_722S",
        "PTK2_843S",
        "PTK2_910S"
    ],
    "PTK2B": [
        "PTK2B_375S"
    ],
    "PTOV1": [
        "PTOV1_36S",
        "PTOV1_53S"
    ],
    "PTPN1": [
        "PTPN1_295S",
        "PTPN1_378S",
        "PTPN1_50S"
    ],
    "PTPN12": [
        "PTPN12_332S",
        "PTPN12_435S",
        "PTPN12_449S",
        "PTPN12_509T",
        "PTPN12_519T",
        "PTPN12_603S",
        "PTPN12_606S",
        "PTPN12_673S"
    ],
    "PTPN13": [
        "PTPN13_1033S",
        "PTPN13_1355T",
        "PTPN13_1359S",
        "PTPN13_2032S"
    ],
    "PTPN14": [
        "PTPN14_314S",
        "PTPN14_593S",
        "PTPN14_594S",
        "PTPN14_758S",
        "PTPN14_809S"
    ],
    "PTPN2": [
        "PTPN2_304S"
    ],
    "PTPRA": [
        "PTPRA_185S",
        "PTPRA_189S"
    ],
    "PTPRG": [
        "PTPRG_1182S"
    ],
    "PTS": [
        "PTS_19S"
    ],
    "PTTG2": [
        "PTTG2_165S"
    ],
    "PUF60": [
        "PUF60_555S"
    ],
    "PUM2": [
        "PUM2_136S",
        "PUM2_184T"
    ],
    "PURB": [
        "PURB_298S",
        "PURB_304S"
    ],
    "PUS1": [
        "PUS1_426T"
    ],
    "PUS7": [
        "PUS7_610T"
    ],
    "PVR": [
        "PVR_406S",
        "PVR_407S",
        "PVR_408S"
    ],
    "PWP1": [
        "PWP1_485S",
        "PWP1_50S"
    ],
    "PWWP2A": [
        "PWWP2A_81S"
    ],
    "PWWP2B": [
        "PWWP2B_84S"
    ],
    "PXN": [
        "PXN_126S",
        "PXN_130S",
        "PXN_258S",
        "PXN_302S",
        "PXN_303S",
        "PXN_322S",
        "PXN_84S",
        "PXN_85S"
    ],
    "PYGO2": [
        "PYGO2_302T"
    ],
    "QSER1": [
        "QSER1_1211S",
        "QSER1_1341T",
        "QSER1_1348S"
    ],
    "R3HDM1": [
        "R3HDM1_261S",
        "R3HDM1_282S",
        "R3HDM1_381S",
        "R3HDM1_973S",
        "R3HDM1_974T"
    ],
    "RAB11FIP5": [
        "RAB11FIP5_307S"
    ],
    "RAB3IL1": [
        "RAB3IL1_168S",
        "RAB3IL1_179S",
        "RAB3IL1_66S",
        "RAB3IL1_68S"
    ],
    "RAB8A": [
        "RAB8A_185S"
    ],
    "RABGAP1": [
        "RABGAP1_493S",
        "RABGAP1_996T"
    ],
    "RABGAP1L": [
        "RABGAP1L_118S",
        "RABGAP1L_119S"
    ],
    "RABGEF1": [
        "RABGEF1_132S",
        "RABGEF1_390S"
    ],
    "RABL6": [
        "RABL6_402S",
        "RABL6_640S",
        "RABL6_641S"
    ],
    "RACGAP1": [
        "RACGAP1_342T"
    ],
    "RAD18": [
        "RAD18_158S"
    ],
    "RAD21": [
        "RAD21_545S"
    ],
    "RAD23A": [
        "RAD23A_123S",
        "RAD23A_125S"
    ],
    "RAD23B": [
        "RAD23B_160S"
    ],
    "RAD9A": [
        "RAD9A_328S"
    ],
    "RAF1": [
        "RAF1_259S",
        "RAF1_621S",
        "RAF1_641T"
    ],
    "RAI1": [
        "RAI1_1374S"
    ],
    "RAI14": [
        "RAI14_300S",
        "RAI14_358S",
        "RAI14_667S"
    ],
    "RALBP1": [
        "RALBP1_30S",
        "RALBP1_645S"
    ],
    "RALGAPA2": [
        "RALGAPA2_819S",
        "RALGAPA2_820S",
        "RALGAPA2_821S"
    ],
    "RALGAPB": [
        "RALGAPB_359S",
        "RALGAPB_379T",
        "RALGAPB_734T"
    ],
    "RALGPS2": [
        "RALGPS2_329S",
        "RALGPS2_343S",
        "RALGPS2_361T",
        "RALGPS2_422S"
    ],
    "RALY": [
        "RALY_288S"
    ],
    "RAMAC": [
        "RAMAC_36S"
    ],
    "RANBP1": [
        "RANBP1_60S"
    ],
    "RANBP2": [
        "RANBP2_1160S",
        "RANBP2_1399T",
        "RANBP2_1509S",
        "RANBP2_1513T",
        "RANBP2_2276S",
        "RANBP2_2280S",
        "RANBP2_2293T",
        "RANBP2_2450T",
        "RANBP2_2454S",
        "RANBP2_2456S",
        "RANBP2_2457S",
        "RANBP2_2458T",
        "RANBP2_2510S",
        "RANBP2_2668S",
        "RANBP2_2743T",
        "RANBP2_2804S",
        "RANBP2_2805S",
        "RANBP2_3207S",
        "RANBP2_781S",
        "RANBP2_788S",
        "RANBP2_796S",
        "RANBP2_799T",
        "RANBP2_955S"
    ],
    "RANBP3": [
        "RANBP3_101S",
        "RANBP3_108S",
        "RANBP3_211S",
        "RANBP3_244S",
        "RANBP3_333S"
    ],
    "RANGAP1": [
        "RANGAP1_428S"
    ],
    "RAP1GAP2": [
        "RAP1GAP2_7S"
    ],
    "RAPGEF1": [
        "RAPGEF1_281S",
        "RAPGEF1_296S",
        "RAPGEF1_310T",
        "RAPGEF1_349S",
        "RAPGEF1_360S"
    ],
    "RAPGEF6": [
        "RAPGEF6_1093S"
    ],
    "RAPH1": [
        "RAPH1_1012S",
        "RAPH1_1154S",
        "RAPH1_996S"
    ],
    "RASA1": [
        "RASA1_831S"
    ],
    "RASAL3": [
        "RASAL3_72S"
    ],
    "RAVER1": [
        "RAVER1_14S",
        "RAVER1_463T"
    ],
    "RB1": [
        "RB1_249S",
        "RB1_356T",
        "RB1_373T",
        "RB1_807S"
    ],
    "RB1CC1": [
        "RB1CC1_222S",
        "RB1CC1_237S",
        "RB1CC1_238T"
    ],
    "RBBP6": [
        "RBBP6_1179S",
        "RBBP6_1277S",
        "RBBP6_1328S",
        "RBBP6_772S"
    ],
    "RBBP8": [
        "RBBP8_315T",
        "RBBP8_327S",
        "RBBP8_539S"
    ],
    "RBL2": [
        "RBL2_1068S",
        "RBL2_639S",
        "RBL2_952S",
        "RBL2_981S",
        "RBL2_986T"
    ],
    "RBM12B": [
        "RBM12B_250S",
        "RBM12B_254S",
        "RBM12B_575S",
        "RBM12B_591S",
        "RBM12B_638S",
        "RBM12B_710S",
        "RBM12B_718S",
        "RBM12B_839S",
        "RBM12B_874S"
    ],
    "RBM14": [
        "RBM14_206T",
        "RBM14_215S",
        "RBM14_579T",
        "RBM14_582S"
    ],
    "RBM15": [
        "RBM15_257S",
        "RBM15_259S",
        "RBM15_294S",
        "RBM15_568T",
        "RBM15_656S",
        "RBM15_670S",
        "RBM15_674S",
        "RBM15_700S",
        "RBM15_741S"
    ],
    "RBM15B": [
        "RBM15B_109S",
        "RBM15B_113S",
        "RBM15B_265S",
        "RBM15B_267S",
        "RBM15B_562S",
        "RBM15B_609S"
    ],
    "RBM23": [
        "RBM23_149S"
    ],
    "RBM26": [
        "RBM26_127S",
        "RBM26_518S"
    ],
    "RBM27": [
        "RBM27_120S"
    ],
    "RBM33": [
        "RBM33_205S",
        "RBM33_765S"
    ],
    "RBM34": [
        "RBM34_14S"
    ],
    "RBM4": [
        "RBM4_86S"
    ],
    "RBM42": [
        "RBM42_135S"
    ],
    "RBM6": [
        "RBM6_1025S",
        "RBM6_891S"
    ],
    "RBM8A": [
        "RBM8A_42S",
        "RBM8A_56S"
    ],
    "RBMS2": [
        "RBMS2_106S"
    ],
    "RBMX2": [
        "RBMX2_187S",
        "RBMX2_188S"
    ],
    "RCC1": [
        "RCC1_11S"
    ],
    "RCC2": [
        "RCC2_50S",
        "RCC2_51S"
    ],
    "RCOR1": [
        "RCOR1_260S",
        "RCOR1_460S"
    ],
    "RCOR3": [
        "RCOR3_156S",
        "RCOR3_375S",
        "RCOR3_376T"
    ],
    "REEP3": [
        "REEP3_210S"
    ],
    "REEP4": [
        "REEP4_152S"
    ],
    "RELCH": [
        "RELCH_141S",
        "RELCH_143T",
        "RELCH_193S"
    ],
    "REPS1": [
        "REPS1_170S",
        "REPS1_173T",
        "REPS1_272S",
        "REPS1_274S",
        "REPS1_537S",
        "REPS1_539T",
        "REPS1_540S",
        "REPS1_562S",
        "REPS1_709S"
    ],
    "RERE": [
        "RERE_594S",
        "RERE_599T",
        "RERE_656S"
    ],
    "REST": [
        "REST_864S"
    ],
    "RETREG2": [
        "RETREG2_138S",
        "RETREG2_385S"
    ],
    "RETREG3": [
        "RETREG3_258S",
        "RETREG3_260S",
        "RETREG3_26S",
        "RETREG3_313S",
        "RETREG3_320S"
    ],
    "RFC1": [
        "RFC1_156S",
        "RFC1_190S",
        "RFC1_368S",
        "RFC1_69S",
        "RFC1_71S"
    ],
    "RFC3": [
        "RFC3_12S"
    ],
    "RFFL": [
        "RFFL_226S",
        "RFFL_229S"
    ],
    "RFTN1": [
        "RFTN1_199S",
        "RFTN1_220S"
    ],
    "RFX5": [
        "RFX5_185S",
        "RFX5_347S"
    ],
    "RFX7": [
        "RFX7_202S"
    ],
    "RGL1": [
        "RGL1_749T"
    ],
    "RGL2": [
        "RGL2_13S",
        "RGL2_409S"
    ],
    "RGS3": [
        "RGS3_806S"
    ],
    "RHBDF1": [
        "RHBDF1_390S"
    ],
    "RHBDF2": [
        "RHBDF2_177S"
    ],
    "RIC1": [
        "RIC1_1037S"
    ],
    "RIC8A": [
        "RIC8A_436S",
        "RIC8A_441T"
    ],
    "RICTOR": [
        "RICTOR_1591S",
        "RICTOR_21S",
        "RICTOR_265S"
    ],
    "RIF1": [
        "RIF1_1688S",
        "RIF1_2161S",
        "RIF1_2348S",
        "RIF1_2393S",
        "RIF1_782S"
    ],
    "RILPL1": [
        "RILPL1_345T",
        "RILPL1_346S"
    ],
    "RIN1": [
        "RIN1_258S",
        "RIN1_333S",
        "RIN1_336T",
        "RIN1_337S",
        "RIN1_349S",
        "RIN1_351S"
    ],
    "RING1": [
        "RING1_229S",
        "RING1_232S"
    ],
    "RIOK1": [
        "RIOK1_22S"
    ],
    "RIOK2": [
        "RIOK2_350S",
        "RIOK2_380S"
    ],
    "RIOX2": [
        "RIOX2_134T"
    ],
    "RIPK2": [
        "RIPK2_531S"
    ],
    "RMDN3": [
        "RMDN3_46S"
    ],
    "RMI1": [
        "RMI1_284S"
    ],
    "RNF123": [
        "RNF123_675S"
    ],
    "RNF14": [
        "RNF14_348S"
    ],
    "RNF213": [
        "RNF213_1258S"
    ],
    "RNF31": [
        "RNF31_466S"
    ],
    "RNF34": [
        "RNF34_254S"
    ],
    "RNH1": [
        "RNH1_82T"
    ],
    "RNPC3": [
        "RNPC3_108S"
    ],
    "RNPEP": [
        "RNPEP_7S"
    ],
    "ROCK2": [
        "ROCK2_425S"
    ],
    "RPA1": [
        "RPA1_384S",
        "RPA1_38S"
    ],
    "RPAP1": [
        "RPAP1_72S"
    ],
    "RPAP3": [
        "RPAP3_481S"
    ],
    "RPGR": [
        "RPGR_518S"
    ],
    "RPL18A": [
        "RPL18A_123S",
        "RPL18A_71S"
    ],
    "RPL29": [
        "RPL29_158S"
    ],
    "RPLP0P6": [
        "RPLP0P6_304S",
        "RPLP0P6_307S"
    ],
    "RPP30": [
        "RPP30_251S"
    ],
    "RPP38": [
        "RPP38_235S"
    ],
    "RPRD1A": [
        "RPRD1A_156S"
    ],
    "RPRD1B": [
        "RPRD1B_134S"
    ],
    "RPRD2": [
        "RPRD2_374S",
        "RPRD2_485S",
        "RPRD2_665S",
        "RPRD2_723T"
    ],
    "RPS3A": [
        "RPS3A_236S"
    ],
    "RPS6KA3": [
        "RPS6KA3_415S",
        "RPS6KA3_715S"
    ],
    "RPS6KA4": [
        "RPS6KA4_343S",
        "RPS6KA4_347S",
        "RPS6KA4_681S",
        "RPS6KA4_682S",
        "RPS6KA4_687T"
    ],
    "RPS6KC1": [
        "RPS6KC1_281S",
        "RPS6KC1_423S",
        "RPS6KC1_427S",
        "RPS6KC1_664S"
    ],
    "RPTOR": [
        "RPTOR_863S"
    ],
    "RPUSD1": [
        "RPUSD1_271S",
        "RPUSD1_273S"
    ],
    "RPUSD2": [
        "RPUSD2_68S"
    ],
    "RRAD": [
        "RRAD_301S",
        "RRAD_39S"
    ],
    "RRBP1": [
        "RRBP1_1276S",
        "RRBP1_1277S",
        "RRBP1_573S",
        "RRBP1_615S",
        "RRBP1_959S"
    ],
    "RREB1": [
        "RREB1_1122S",
        "RREB1_1320S",
        "RREB1_175S"
    ],
    "RRM2": [
        "RRM2_20S"
    ],
    "RRP12": [
        "RRP12_1080S"
    ],
    "RRP36": [
        "RRP36_73S"
    ],
    "RRP7A": [
        "RRP7A_99S"
    ],
    "RRP8": [
        "RRP8_104S",
        "RRP8_106S",
        "RRP8_176S"
    ],
    "RSBN1": [
        "RSBN1_81S"
    ],
    "RSF1": [
        "RSF1_1359S",
        "RSF1_1375S",
        "RSF1_397S",
        "RSF1_604S",
        "RSF1_622S",
        "RSF1_629S"
    ],
    "RSL1D1": [
        "RSL1D1_361S",
        "RSL1D1_392S",
        "RSL1D1_396S",
        "RSL1D1_427S",
        "RSL1D1_443S",
        "RSL1D1_445S"
    ],
    "RSRC2": [
        "RSRC2_104S",
        "RSRC2_17S",
        "RSRC2_218S",
        "RSRC2_220T",
        "RSRC2_222S",
        "RSRC2_30S",
        "RSRC2_32S"
    ],
    "RTKN": [
        "RTKN_106S"
    ],
    "RTN4": [
        "RTN4_107S",
        "RTN4_111S",
        "RTN4_121S",
        "RTN4_15S",
        "RTN4_181S",
        "RTN4_182S",
        "RTN4_184S"
    ],
    "RUNX2": [
        "RUNX2_28S"
    ],
    "RUSC2": [
        "RUSC2_536S"
    ],
    "RWDD2B": [
        "RWDD2B_275S"
    ],
    "RYBP": [
        "RYBP_99S"
    ],
    "S100A11": [
        "S100A11_5S",
        "S100A11_6S"
    ],
    "S100A13": [
        "S100A13_32S"
    ],
    "S100A16": [
        "S100A16_102S"
    ],
    "S100A9": [
        "S100A9_113T"
    ],
    "S1PR3": [
        "S1PR3_326S"
    ],
    "SAAL1": [
        "SAAL1_6S"
    ],
    "SACS": [
        "SACS_1779S",
        "SACS_4264S"
    ],
    "SAFB": [
        "SAFB_383S",
        "SAFB_384S"
    ],
    "SAMD4A": [
        "SAMD4A_420S"
    ],
    "SAMHD1": [
        "SAMHD1_33S",
        "SAMHD1_592T"
    ],
    "SAP30BP": [
        "SAP30BP_113S",
        "SAP30BP_77S"
    ],
    "SAR1A": [
        "SAR1A_139T"
    ],
    "SARM1": [
        "SARM1_548S",
        "SARM1_572S"
    ],
    "SART1": [
        "SART1_448S"
    ],
    "SASH1": [
        "SASH1_1028S",
        "SASH1_248S",
        "SASH1_407S",
        "SASH1_541S",
        "SASH1_813S",
        "SASH1_90S"
    ],
    "SCAF1": [
        "SCAF1_239S",
        "SCAF1_498S",
        "SCAF1_500S",
        "SCAF1_724S",
        "SCAF1_725S",
        "SCAF1_874S",
        "SCAF1_965S",
        "SCAF1_976T",
        "SCAF1_989T"
    ],
    "SCAF11": [
        "SCAF11_338S",
        "SCAF11_608S",
        "SCAF11_771S",
        "SCAF11_776S",
        "SCAF11_796S",
        "SCAF11_802S",
        "SCAF11_816S",
        "SCAF11_818S",
        "SCAF11_878S",
        "SCAF11_880S",
        "SCAF11_882S"
    ],
    "SCAF4": [
        "SCAF4_656S"
    ],
    "SCAF8": [
        "SCAF8_617S"
    ],
    "SCAMP1": [
        "SCAMP1_45T"
    ],
    "SCAMP3": [
        "SCAMP3_76S"
    ],
    "SCAPER": [
        "SCAPER_86S"
    ],
    "SCARF2": [
        "SCARF2_653S",
        "SCARF2_718S"
    ],
    "SCFD1": [
        "SCFD1_303S"
    ],
    "SCLT1": [
        "SCLT1_656S"
    ],
    "SCLY": [
        "SCLY_129S"
    ],
    "SCRIB": [
        "SCRIB_1220S",
        "SCRIB_1225S",
        "SCRIB_1232S",
        "SCRIB_1306S",
        "SCRIB_1309S",
        "SCRIB_1348S",
        "SCRIB_1378S",
        "SCRIB_1561S",
        "SCRIB_1566S",
        "SCRIB_835S",
        "SCRIB_853S"
    ],
    "SCRN2": [
        "SCRN2_52T"
    ],
    "SDAD1": [
        "SDAD1_585S"
    ],
    "SDC1": [
        "SDC1_285S",
        "SDC1_287S"
    ],
    "SDC2": [
        "SDC2_187S",
        "SDC2_188S"
    ],
    "SDCBP": [
        "SDCBP_6S"
    ],
    "SDE2": [
        "SDE2_278S"
    ],
    "SEC14L2": [
        "SEC14L2_401T"
    ],
    "SEC16A": [
        "SEC16A_1069S",
        "SEC16A_1964S",
        "SEC16A_2081S",
        "SEC16A_2083S",
        "SEC16A_342S"
    ],
    "SEC22B": [
        "SEC22B_137S"
    ],
    "SEC23IP": [
        "SEC23IP_737S",
        "SEC23IP_926S"
    ],
    "SEC24B": [
        "SEC24B_1220S",
        "SEC24B_1224S"
    ],
    "SEC24D": [
        "SEC24D_266S"
    ],
    "SEC31A": [
        "SEC31A_799S"
    ],
    "SEC62": [
        "SEC62_335S",
        "SEC62_341S",
        "SEC62_343T",
        "SEC62_345S",
        "SEC62_375T"
    ],
    "SEC63": [
        "SEC63_597S"
    ],
    "SEH1L": [
        "SEH1L_259S"
    ],
    "SELENON": [
        "SELENON_13S"
    ],
    "SEMA4B": [
        "SEMA4B_793S"
    ],
    "SEMA6B": [
        "SEMA6B_802S"
    ],
    "SENP3": [
        "SENP3_169S",
        "SENP3_212S",
        "SENP3_232S"
    ],
    "SENP6": [
        "SENP6_352S"
    ],
    "SEPTIN10": [
        "SEPTIN10_28S"
    ],
    "SEPTIN2": [
        "SEPTIN2_218S"
    ],
    "SEPTIN9": [
        "SEPTIN9_30S",
        "SEPTIN9_327S",
        "SEPTIN9_332S"
    ],
    "SERINC1": [
        "SERINC1_364S"
    ],
    "SERTAD4": [
        "SERTAD4_6S"
    ],
    "SET": [
        "SET_7S"
    ],
    "SETD1A": [
        "SETD1A_1103S",
        "SETD1A_1153S",
        "SETD1A_458T",
        "SETD1A_464S"
    ],
    "SETD1B": [
        "SETD1B_1298S",
        "SETD1B_1663S"
    ],
    "SETD2": [
        "SETD2_131S",
        "SETD2_1415S",
        "SETD2_1417S",
        "SETD2_1844S",
        "SETD2_1845S",
        "SETD2_1853T",
        "SETD2_532S",
        "SETD2_624S",
        "SETD2_754S"
    ],
    "SETX": [
        "SETX_1017S",
        "SETX_1019S",
        "SETX_1366S",
        "SETX_947S"
    ],
    "SF1": [
        "SF1_80S",
        "SF1_82S"
    ],
    "SF3A1": [
        "SF3A1_359S"
    ],
    "SF3B2": [
        "SF3B2_343S",
        "SF3B2_435S",
        "SF3B2_436S"
    ],
    "SFMBT1": [
        "SFMBT1_775S"
    ],
    "SFN": [
        "SFN_248S",
        "SFN_45S",
        "SFN_64S"
    ],
    "SFSWAP": [
        "SFSWAP_742S",
        "SFSWAP_743S"
    ],
    "SGMS1": [
        "SGMS1_8S"
    ],
    "SGPP1": [
        "SGPP1_112S"
    ],
    "SGTA": [
        "SGTA_303T",
        "SGTA_77S",
        "SGTA_81T"
    ],
    "SGTB": [
        "SGTB_295S"
    ],
    "SH2B1": [
        "SH2B1_125S",
        "SH2B1_126S"
    ],
    "SH2D4A": [
        "SH2D4A_315S"
    ],
    "SH2D5": [
        "SH2D5_12S"
    ],
    "SH3BP1": [
        "SH3BP1_262S",
        "SH3BP1_544S",
        "SH3BP1_550S",
        "SH3BP1_585S",
        "SH3BP1_586S",
        "SH3BP1_598S"
    ],
    "SH3BP2": [
        "SH3BP2_225S",
        "SH3BP2_278S",
        "SH3BP2_416S",
        "SH3BP2_427S"
    ],
    "SH3BP5": [
        "SH3BP5_375S",
        "SH3BP5_376S"
    ],
    "SH3BP5L": [
        "SH3BP5L_30S",
        "SH3BP5L_343S",
        "SH3BP5L_350S"
    ],
    "SH3GL1": [
        "SH3GL1_288S"
    ],
    "SH3KBP1": [
        "SH3KBP1_587S",
        "SH3KBP1_589S"
    ],
    "SH3PXD2A": [
        "SH3PXD2A_1017S",
        "SH3PXD2A_1038S",
        "SH3PXD2A_1056S",
        "SH3PXD2A_420S",
        "SH3PXD2A_421S",
        "SH3PXD2A_547S",
        "SH3PXD2A_724S",
        "SH3PXD2A_797S",
        "SH3PXD2A_820S"
    ],
    "SH3PXD2B": [
        "SH3PXD2B_291S",
        "SH3PXD2B_293S",
        "SH3PXD2B_675S",
        "SH3PXD2B_720S"
    ],
    "SHARPIN": [
        "SHARPIN_129S",
        "SHARPIN_165S"
    ],
    "SHROOM2": [
        "SHROOM2_1297S",
        "SHROOM2_313S"
    ],
    "SIK1B": [
        "SIK1B_435S",
        "SIK1B_575S"
    ],
    "SIK2": [
        "SIK2_358S",
        "SIK2_359T"
    ],
    "SIK3": [
        "SIK3_730S"
    ],
    "SIN3A": [
        "SIN3A_277S",
        "SIN3A_832S",
        "SIN3A_860S",
        "SIN3A_940S"
    ],
    "SIN3B": [
        "SIN3B_262T",
        "SIN3B_740S"
    ],
    "SIPA1": [
        "SIPA1_1036S",
        "SIPA1_839S",
        "SIPA1_843S",
        "SIPA1_884S"
    ],
    "SIPA1L1": [
        "SIPA1L1_1116S",
        "SIPA1L1_1255S",
        "SIPA1L1_1270S",
        "SIPA1L1_1549S",
        "SIPA1L1_1585S",
        "SIPA1L1_1734S",
        "SIPA1L1_208S"
    ],
    "SIPA1L2": [
        "SIPA1L2_1488S",
        "SIPA1L2_1652S",
        "SIPA1L2_194S"
    ],
    "SIPA1L3": [
        "SIPA1L3_1364S",
        "SIPA1L3_146S",
        "SIPA1L3_1544S",
        "SIPA1L3_317S"
    ],
    "SIRT1": [
        "SIRT1_27S",
        "SIRT1_47S"
    ],
    "SIRT6": [
        "SIRT6_294T",
        "SIRT6_303S",
        "SIRT6_330S",
        "SIRT6_338S"
    ],
    "SKA2": [
        "SKA2_101S"
    ],
    "SKIV2L": [
        "SKIV2L_256S"
    ],
    "SLAIN2": [
        "SLAIN2_353S",
        "SLAIN2_87S"
    ],
    "SLBP": [
        "SLBP_20S",
        "SLBP_23S"
    ],
    "SLC10A6": [
        "SLC10A6_324S"
    ],
    "SLC12A4": [
        "SLC12A4_47S"
    ],
    "SLC12A6": [
        "SLC12A6_1048T",
        "SLC12A6_31T",
        "SLC12A6_32S"
    ],
    "SLC12A7": [
        "SLC12A7_30T"
    ],
    "SLC15A4": [
        "SLC15A4_298S"
    ],
    "SLC16A1": [
        "SLC16A1_213S",
        "SLC16A1_466T",
        "SLC16A1_467S"
    ],
    "SLC16A3": [
        "SLC16A3_436S"
    ],
    "SLC16A7": [
        "SLC16A7_454S"
    ],
    "SLC19A1": [
        "SLC19A1_225S"
    ],
    "SLC1A5": [
        "SLC1A5_493S",
        "SLC1A5_494T",
        "SLC1A5_9S"
    ],
    "SLC20A1": [
        "SLC20A1_265S",
        "SLC20A1_269S",
        "SLC20A1_277S",
        "SLC20A1_335S"
    ],
    "SLC20A2": [
        "SLC20A2_256S"
    ],
    "SLC26A6": [
        "SLC26A6_752S"
    ],
    "SLC2A9": [
        "SLC2A9_9S"
    ],
    "SLC30A6": [
        "SLC30A6_381S"
    ],
    "SLC33A1": [
        "SLC33A1_22S"
    ],
    "SLC35A5": [
        "SLC35A5_416S",
        "SLC35A5_419S"
    ],
    "SLC35B2": [
        "SLC35B2_427S"
    ],
    "SLC35C2": [
        "SLC35C2_335S"
    ],
    "SLC35G2": [
        "SLC35G2_409S"
    ],
    "SLC36A4": [
        "SLC36A4_35T",
        "SLC36A4_36S"
    ],
    "SLC39A10": [
        "SLC39A10_536T"
    ],
    "SLC39A6": [
        "SLC39A6_478S",
        "SLC39A6_479T"
    ],
    "SLC39A7": [
        "SLC39A7_275S",
        "SLC39A7_276S"
    ],
    "SLC39A8": [
        "SLC39A8_288S"
    ],
    "SLC4A1AP": [
        "SLC4A1AP_312S",
        "SLC4A1AP_82S"
    ],
    "SLC4A4": [
        "SLC4A4_257S"
    ],
    "SLC4A7": [
        "SLC4A7_233S",
        "SLC4A7_242S",
        "SLC4A7_403S",
        "SLC4A7_408T",
        "SLC4A7_556S",
        "SLC4A7_84S"
    ],
    "SLC66A2": [
        "SLC66A2_110S"
    ],
    "SLC7A11": [
        "SLC7A11_26S"
    ],
    "SLC7A2": [
        "SLC7A2_446S"
    ],
    "SLC7A6OS": [
        "SLC7A6OS_16S",
        "SLC7A6OS_308S"
    ],
    "SLC9A1": [
        "SLC9A1_599S",
        "SLC9A1_693S",
        "SLC9A1_703S",
        "SLC9A1_785S",
        "SLC9A1_796S"
    ],
    "SLC9A3R1": [
        "SLC9A3R1_269S",
        "SLC9A3R1_290S"
    ],
    "SLCO4A1": [
        "SLCO4A1_34S",
        "SLCO4A1_40S",
        "SLCO4A1_43S"
    ],
    "SLIRP": [
        "SLIRP_101T"
    ],
    "SLK": [
        "SLK_372S",
        "SLK_565S",
        "SLK_571S"
    ],
    "SLTM": [
        "SLTM_289S",
        "SLTM_543S"
    ],
    "SLX4": [
        "SLX4_1028S"
    ],
    "SMAD5": [
        "SMAD5_133S"
    ],
    "SMAP2": [
        "SMAP2_219S",
        "SMAP2_240S"
    ],
    "SMARCA2": [
        "SMARCA2_1377S",
        "SMARCA2_1572S",
        "SMARCA2_1587T",
        "SMARCA2_329S"
    ],
    "SMARCA4": [
        "SMARCA4_1417S",
        "SMARCA4_1423T",
        "SMARCA4_1452S",
        "SMARCA4_1570S",
        "SMARCA4_1575S",
        "SMARCA4_1586S",
        "SMARCA4_1627S",
        "SMARCA4_1631S",
        "SMARCA4_609T",
        "SMARCA4_613S",
        "SMARCA4_695S",
        "SMARCA4_699S"
    ],
    "SMARCAD1": [
        "SMARCAD1_124S",
        "SMARCAD1_127S",
        "SMARCAD1_211S",
        "SMARCAD1_212S",
        "SMARCAD1_213S",
        "SMARCAD1_214S",
        "SMARCAD1_239S",
        "SMARCAD1_242S",
        "SMARCAD1_54T",
        "SMARCAD1_57S"
    ],
    "SMARCC1": [
        "SMARCC1_328S",
        "SMARCC1_330S"
    ],
    "SMARCC2": [
        "SMARCC2_283S",
        "SMARCC2_286S",
        "SMARCC2_302S",
        "SMARCC2_304S",
        "SMARCC2_306S",
        "SMARCC2_347S",
        "SMARCC2_813S"
    ],
    "SMC3": [
        "SMC3_1067S",
        "SMC3_1074S"
    ],
    "SMC4": [
        "SMC4_22S",
        "SMC4_27S",
        "SMC4_28S",
        "SMC4_41S"
    ],
    "SMC5": [
        "SMC5_35S"
    ],
    "SMG1": [
        "SMG1_3570S",
        "SMG1_3573T"
    ],
    "SMPD4": [
        "SMPD4_169S",
        "SMPD4_792S"
    ],
    "SNAI2": [
        "SNAI2_87S"
    ],
    "SNAP23": [
        "SNAP23_110S"
    ],
    "SNAPIN": [
        "SNAPIN_133S"
    ],
    "SND1": [
        "SND1_426S"
    ],
    "SNIP1": [
        "SNIP1_35S",
        "SNIP1_396S",
        "SNIP1_52S",
        "SNIP1_54S"
    ],
    "SNRNP70": [
        "SNRNP70_226S"
    ],
    "SNTB2": [
        "SNTB2_110S",
        "SNTB2_233S",
        "SNTB2_389S",
        "SNTB2_393S",
        "SNTB2_95S"
    ],
    "SNURFL": [
        "SNURFL_101S",
        "SNURFL_103S"
    ],
    "SNX12": [
        "SNX12_73S"
    ],
    "SNX15": [
        "SNX15_148T"
    ],
    "SNX17": [
        "SNX17_336S",
        "SNX17_421S",
        "SNX17_437S"
    ],
    "SNX2": [
        "SNX2_104T",
        "SNX2_119S"
    ],
    "SNX24": [
        "SNX24_113S",
        "SNX24_116S"
    ],
    "SOGA1": [
        "SOGA1_1017S",
        "SOGA1_1303S"
    ],
    "SON": [
        "SON_1697S",
        "SON_1769S"
    ],
    "SORBS2": [
        "SORBS2_259S",
        "SORBS2_302S"
    ],
    "SORBS3": [
        "SORBS3_373S",
        "SORBS3_395S",
        "SORBS3_530S",
        "SORBS3_544S",
        "SORBS3_545S"
    ],
    "SOS1": [
        "SOS1_1082S",
        "SOS1_1134S",
        "SOS1_1178S",
        "SOS1_1210S",
        "SOS1_1275S",
        "SOS1_401S"
    ],
    "SOWAHC": [
        "SOWAHC_213S"
    ],
    "SP100": [
        "SP100_157S",
        "SP100_18S",
        "SP100_362S"
    ],
    "SP110": [
        "SP110_244S",
        "SP110_256S"
    ],
    "SPAG9": [
        "SPAG9_217T",
        "SPAG9_251S",
        "SPAG9_330T",
        "SPAG9_332S",
        "SPAG9_595T",
        "SPAG9_730S",
        "SPAG9_732S",
        "SPAG9_733S"
    ],
    "SPANXB1": [
        "SPANXB1_13S",
        "SPANXB1_55T"
    ],
    "SPARCL1": [
        "SPARCL1_414S"
    ],
    "SPATS2L": [
        "SPATS2L_338S"
    ],
    "SPCS1": [
        "SPCS1_150S"
    ],
    "SPECC1": [
        "SPECC1_361S",
        "SPECC1_810S",
        "SPECC1_847S"
    ],
    "SPECC1L": [
        "SPECC1L_384S",
        "SPECC1L_385S"
    ],
    "SPEN": [
        "SPEN_1005S",
        "SPEN_1006S",
        "SPEN_1062S",
        "SPEN_1252S",
        "SPEN_1380S",
        "SPEN_1382S",
        "SPEN_2101S",
        "SPEN_2460T",
        "SPEN_2481S",
        "SPEN_2493S",
        "SPEN_727S",
        "SPEN_736S",
        "SPEN_740S"
    ],
    "SPHK1": [
        "SPHK1_193T"
    ],
    "SPICE1": [
        "SPICE1_235T"
    ],
    "SPIN1": [
        "SPIN1_124S"
    ],
    "SPINDOC": [
        "SPINDOC_148S",
        "SPINDOC_152S",
        "SPINDOC_308S",
        "SPINDOC_310S",
        "SPINDOC_49T"
    ],
    "SPRY4": [
        "SPRY4_125S",
        "SPRY4_280S"
    ],
    "SPTAN1": [
        "SPTAN1_1031S",
        "SPTAN1_1217S",
        "SPTAN1_1323S"
    ],
    "SPTBN1": [
        "SPTBN1_2102S",
        "SPTBN1_2138S",
        "SPTBN1_2160S",
        "SPTBN1_2161S",
        "SPTBN1_2164S",
        "SPTBN1_2165S",
        "SPTBN1_2169S"
    ],
    "SPTBN2": [
        "SPTBN2_415T"
    ],
    "SQOR": [
        "SQOR_343S"
    ],
    "SQSTM1": [
        "SQSTM1_24S",
        "SQSTM1_269T",
        "SQSTM1_272S",
        "SQSTM1_277S",
        "SQSTM1_28S",
        "SQSTM1_366S"
    ],
    "SRA1": [
        "SRA1_69S"
    ],
    "SRC": [
        "SRC_17S"
    ],
    "SRCAP": [
        "SRCAP_1859S",
        "SRCAP_568S"
    ],
    "SRFBP1": [
        "SRFBP1_203S",
        "SRFBP1_281S"
    ],
    "SRGAP2B": [
        "SRGAP2B_426S"
    ],
    "SRP68": [
        "SRP68_22S"
    ],
    "SRP72": [
        "SRP72_621S",
        "SRP72_624T"
    ],
    "SRPK1": [
        "SRPK1_309S",
        "SRPK1_311S",
        "SRPK1_51S"
    ],
    "SRPRB": [
        "SRPRB_257S"
    ],
    "SRRM1": [
        "SRRM1_205T",
        "SRRM1_207S",
        "SRRM1_209S",
        "SRRM1_211S",
        "SRRM1_220T",
        "SRRM1_294S",
        "SRRM1_304S",
        "SRRM1_306S",
        "SRRM1_308S",
        "SRRM1_310S",
        "SRRM1_389S",
        "SRRM1_391S",
        "SRRM1_393S",
        "SRRM1_402S",
        "SRRM1_406T",
        "SRRM1_414S",
        "SRRM1_416T",
        "SRRM1_429S",
        "SRRM1_431S",
        "SRRM1_450S",
        "SRRM1_452S",
        "SRRM1_463S",
        "SRRM1_465S",
        "SRRM1_549S",
        "SRRM1_551S",
        "SRRM1_560S",
        "SRRM1_562S",
        "SRRM1_572T",
        "SRRM1_574T",
        "SRRM1_581T",
        "SRRM1_583S",
        "SRRM1_597S",
        "SRRM1_605S",
        "SRRM1_607S",
        "SRRM1_614T",
        "SRRM1_616S",
        "SRRM1_626S",
        "SRRM1_628S",
        "SRRM1_636S",
        "SRRM1_638S",
        "SRRM1_653S",
        "SRRM1_655S",
        "SRRM1_683S",
        "SRRM1_685S",
        "SRRM1_693T",
        "SRRM1_694S",
        "SRRM1_695S",
        "SRRM1_696S",
        "SRRM1_713S",
        "SRRM1_715S",
        "SRRM1_725S",
        "SRRM1_727T",
        "SRRM1_738S",
        "SRRM1_740S",
        "SRRM1_748S",
        "SRRM1_752S",
        "SRRM1_754S",
        "SRRM1_756S",
        "SRRM1_769S",
        "SRRM1_773S",
        "SRRM1_775S",
        "SRRM1_781S",
        "SRRM1_797S",
        "SRRM1_872T",
        "SRRM1_874S"
    ],
    "SRRM2": [
        "SRRM2_1003T",
        "SRRM2_1014S",
        "SRRM2_1043T",
        "SRRM2_1064S",
        "SRRM2_1069S",
        "SRRM2_1072S",
        "SRRM2_1073S",
        "SRRM2_1083S",
        "SRRM2_1101S",
        "SRRM2_1103S",
        "SRRM2_1112S",
        "SRRM2_1124S",
        "SRRM2_1132S",
        "SRRM2_1179S",
        "SRRM2_1208T",
        "SRRM2_1318S",
        "SRRM2_1320S",
        "SRRM2_1329S",
        "SRRM2_1403S",
        "SRRM2_1404S",
        "SRRM2_1421S",
        "SRRM2_1443S",
        "SRRM2_1444S",
        "SRRM2_1462S",
        "SRRM2_1463S",
        "SRRM2_1478S",
        "SRRM2_1482S",
        "SRRM2_1483S",
        "SRRM2_1492T",
        "SRRM2_1497S",
        "SRRM2_1499S",
        "SRRM2_1502S",
        "SRRM2_1658S",
        "SRRM2_1691S",
        "SRRM2_1693S",
        "SRRM2_1694S",
        "SRRM2_1729S",
        "SRRM2_1762S",
        "SRRM2_1764S",
        "SRRM2_1818S",
        "SRRM2_1820Y",
        "SRRM2_1822S",
        "SRRM2_1824S",
        "SRRM2_1854S",
        "SRRM2_1856T",
        "SRRM2_1857S",
        "SRRM2_1866S",
        "SRRM2_1869S",
        "SRRM2_1923S",
        "SRRM2_1925S",
        "SRRM2_1927T",
        "SRRM2_1970S",
        "SRRM2_1972S",
        "SRRM2_1974T",
        "SRRM2_1975S",
        "SRRM2_1982S",
        "SRRM2_1986T",
        "SRRM2_1987S",
        "SRRM2_2030S",
        "SRRM2_2032S",
        "SRRM2_2034T",
        "SRRM2_2044S",
        "SRRM2_2046S",
        "SRRM2_2067S",
        "SRRM2_2069T",
        "SRRM2_2071S",
        "SRRM2_2100S",
        "SRRM2_2102S",
        "SRRM2_2104T",
        "SRRM2_2121S",
        "SRRM2_2123S",
        "SRRM2_2125T",
        "SRRM2_2132S",
        "SRRM2_2397T",
        "SRRM2_248S",
        "SRRM2_250S",
        "SRRM2_2581S",
        "SRRM2_2583T",
        "SRRM2_2688S",
        "SRRM2_2694S",
        "SRRM2_2702S",
        "SRRM2_2706S",
        "SRRM2_2738T",
        "SRRM2_2740S",
        "SRRM2_323S",
        "SRRM2_333S",
        "SRRM2_351S",
        "SRRM2_353S",
        "SRRM2_377S",
        "SRRM2_398S",
        "SRRM2_404S",
        "SRRM2_408S",
        "SRRM2_449S",
        "SRRM2_455S",
        "SRRM2_456S",
        "SRRM2_474S",
        "SRRM2_508S",
        "SRRM2_510S",
        "SRRM2_745S",
        "SRRM2_778S",
        "SRRM2_780S",
        "SRRM2_782S",
        "SRRM2_783S",
        "SRRM2_790S",
        "SRRM2_792T",
        "SRRM2_857S",
        "SRRM2_864S",
        "SRRM2_866T",
        "SRRM2_876S",
        "SRRM2_895S",
        "SRRM2_903T",
        "SRRM2_908S",
        "SRRM2_912S",
        "SRRM2_913S",
        "SRRM2_914S",
        "SRRM2_950S",
        "SRRM2_952S",
        "SRRM2_954S",
        "SRRM2_973S",
        "SRRM2_974S",
        "SRRM2_983T",
        "SRRM2_994S"
    ],
    "SRRT": [
        "SRRT_544T"
    ],
    "SRSF11": [
        "SRSF11_207S",
        "SRSF11_366S",
        "SRSF11_368S",
        "SRSF11_370S",
        "SRSF11_434S",
        "SRSF11_449S",
        "SRSF11_456S"
    ],
    "SRSF4": [
        "SRSF4_113S",
        "SRSF4_402S",
        "SRSF4_431S",
        "SRSF4_458S",
        "SRSF4_460S",
        "SRSF4_78S"
    ],
    "SRSF5": [
        "SRSF5_229S",
        "SRSF5_231S",
        "SRSF5_233S",
        "SRSF5_250S",
        "SRSF5_253S"
    ],
    "SRSF6": [
        "SRSF6_265S",
        "SRSF6_272S",
        "SRSF6_301S",
        "SRSF6_303S",
        "SRSF6_314S",
        "SRSF6_316S"
    ],
    "SRSF7": [
        "SRSF7_171S",
        "SRSF7_173S",
        "SRSF7_192S",
        "SRSF7_194S",
        "SRSF7_196S",
        "SRSF7_198S",
        "SRSF7_231S",
        "SRSF7_233S"
    ],
    "SRSF8": [
        "SRSF8_273S"
    ],
    "SRSF9": [
        "SRSF9_189S",
        "SRSF9_204S",
        "SRSF9_211S",
        "SRSF9_216S"
    ],
    "SSB": [
        "SSB_362T",
        "SSB_366S"
    ],
    "SSH2": [
        "SSH2_784S"
    ],
    "SSH3": [
        "SSH3_649S",
        "SSH3_653S",
        "SSH3_87S",
        "SSH3_9S"
    ],
    "SSR3": [
        "SSR3_105S"
    ],
    "ST13": [
        "ST13_75S",
        "ST13_76S",
        "ST13_79S"
    ],
    "ST5": [
        "ST5_48S"
    ],
    "STAM": [
        "STAM_156S"
    ],
    "STARD10": [
        "STARD10_284S"
    ],
    "STARD13": [
        "STARD13_133S",
        "STARD13_389S",
        "STARD13_411S",
        "STARD13_572S"
    ],
    "STAT1": [
        "STAT1_532S",
        "STAT1_727S"
    ],
    "STAT5B": [
        "STAT5B_128S"
    ],
    "STAU2": [
        "STAU2_485S"
    ],
    "STBD1": [
        "STBD1_211S"
    ],
    "STIM1": [
        "STIM1_257S",
        "STIM1_575S"
    ],
    "STIM2": [
        "STIM2_680S"
    ],
    "STK10": [
        "STK10_185T",
        "STK10_438S"
    ],
    "STK11": [
        "STK11_31S",
        "STK11_32T"
    ],
    "STK11IP": [
        "STK11IP_387S",
        "STK11IP_599S",
        "STK11IP_761S"
    ],
    "STK26": [
        "STK26_153S"
    ],
    "STK3": [
        "STK3_316S",
        "STK3_385S"
    ],
    "STK32C": [
        "STK32C_18S"
    ],
    "STK39": [
        "STK39_370S",
        "STK39_371S",
        "STK39_385S"
    ],
    "STMN1": [
        "STMN1_139S",
        "STMN1_16S",
        "STMN1_25S",
        "STMN1_38S",
        "STMN1_46S",
        "STMN1_63S"
    ],
    "STMN3": [
        "STMN3_73S"
    ],
    "STOM": [
        "STOM_10S"
    ],
    "STOML2": [
        "STOML2_29S",
        "STOML2_327T"
    ],
    "STRADA": [
        "STRADA_387S"
    ],
    "STRIP2": [
        "STRIP2_318S"
    ],
    "STUB1": [
        "STUB1_19S",
        "STUB1_23S"
    ],
    "STX18": [
        "STX18_189S"
    ],
    "STX4": [
        "STX4_14S",
        "STX4_15S"
    ],
    "STX7": [
        "STX7_129S",
        "STX7_131S"
    ],
    "STXBP5": [
        "STXBP5_782S",
        "STXBP5_784T",
        "STXBP5_785S"
    ],
    "SUB1": [
        "SUB1_10S",
        "SUB1_11S",
        "SUB1_12S",
        "SUB1_13S",
        "SUB1_15S",
        "SUB1_17S",
        "SUB1_19S"
    ],
    "SUCO": [
        "SUCO_1072T",
        "SUCO_1103S"
    ],
    "SUDS3": [
        "SUDS3_234S",
        "SUDS3_236S",
        "SUDS3_45S",
        "SUDS3_49T",
        "SUDS3_53S"
    ],
    "SUFU": [
        "SUFU_346S",
        "SUFU_349S"
    ],
    "SUGP2": [
        "SUGP2_315S",
        "SUGP2_757S"
    ],
    "SUPT16H": [
        "SUPT16H_188S",
        "SUPT16H_982S"
    ],
    "SUPT5H": [
        "SUPT5H_666S"
    ],
    "SUPT6H": [
        "SUPT6H_125S"
    ],
    "SUPT7L": [
        "SUPT7L_108S"
    ],
    "SURF2": [
        "SURF2_190T"
    ],
    "SURF6": [
        "SURF6_138S"
    ],
    "SUSD5": [
        "SUSD5_240S",
        "SUSD5_241S"
    ],
    "SVIL": [
        "SVIL_1225S",
        "SVIL_245S",
        "SVIL_261S",
        "SVIL_263S",
        "SVIL_270S",
        "SVIL_467S",
        "SVIL_673S",
        "SVIL_914S"
    ],
    "SYAP1": [
        "SYAP1_248T"
    ],
    "SYDE1": [
        "SYDE1_645S"
    ],
    "SYMPK": [
        "SYMPK_1170S",
        "SYMPK_1171S",
        "SYMPK_1175S",
        "SYMPK_1243S"
    ],
    "SYNE2": [
        "SYNE2_6361S"
    ],
    "SYNJ1": [
        "SYNJ1_1049S",
        "SYNJ1_1053S",
        "SYNJ1_1220T",
        "SYNJ1_1565S"
    ],
    "SYNJ2": [
        "SYNJ2_1191S"
    ],
    "SYNPO": [
        "SYNPO_232S",
        "SYNPO_235S",
        "SYNPO_263S",
        "SYNPO_525S",
        "SYNPO_685S",
        "SYNPO_754S",
        "SYNPO_758S",
        "SYNPO_833S",
        "SYNPO_838S"
    ],
    "SYNPO2": [
        "SYNPO2_226S"
    ],
    "SYNRG": [
        "SYNRG_1075S",
        "SYNRG_580S",
        "SYNRG_752S",
        "SYNRG_812S",
        "SYNRG_935S"
    ],
    "SZRD1": [
        "SZRD1_107S",
        "SZRD1_39S"
    ],
    "SZT2": [
        "SZT2_2434T"
    ],
    "TAB3": [
        "TAB3_103S"
    ],
    "TACC2": [
        "TACC2_1313S",
        "TACC2_2072S",
        "TACC2_2134S",
        "TACC2_2226S",
        "TACC2_2317S",
        "TACC2_2321S",
        "TACC2_2512S"
    ],
    "TACC3": [
        "TACC3_250S"
    ],
    "TAF12": [
        "TAF12_51S"
    ],
    "TAF15": [
        "TAF15_375S"
    ],
    "TAF1D": [
        "TAF1D_40S"
    ],
    "TAF3": [
        "TAF3_183S",
        "TAF3_755S"
    ],
    "TAF6": [
        "TAF6_532S",
        "TAF6_653S",
        "TAF6_660T"
    ],
    "TAF9": [
        "TAF9_149S"
    ],
    "TAGLN2": [
        "TAGLN2_163S"
    ],
    "TANC2": [
        "TANC2_1517S",
        "TANC2_1530S",
        "TANC2_1777S",
        "TANC2_21S",
        "TANC2_400S",
        "TANC2_404S"
    ],
    "TANK": [
        "TANK_129S",
        "TANK_225S"
    ],
    "TAOK1": [
        "TAOK1_965S",
        "TAOK1_9S"
    ],
    "TAOK3": [
        "TAOK3_442S"
    ],
    "TAP1": [
        "TAP1_545T"
    ],
    "TARBP2": [
        "TARBP2_152S"
    ],
    "TASOR": [
        "TASOR_1103S",
        "TASOR_694S",
        "TASOR_699S",
        "TASOR_927S"
    ],
    "TASOR2": [
        "TASOR2_2009S",
        "TASOR2_2035S",
        "TASOR2_2037S"
    ],
    "TAX1BP1": [
        "TAX1BP1_666S"
    ],
    "TBC1D10B": [
        "TBC1D10B_132S",
        "TBC1D10B_22S",
        "TBC1D10B_678S"
    ],
    "TBC1D15": [
        "TBC1D15_675S",
        "TBC1D15_70S"
    ],
    "TBC1D17": [
        "TBC1D17_620T"
    ],
    "TBC1D2": [
        "TBC1D2_267S",
        "TBC1D2_40S",
        "TBC1D2_915S",
        "TBC1D2_920S"
    ],
    "TBC1D22B": [
        "TBC1D22B_114S",
        "TBC1D22B_132S",
        "TBC1D22B_141S",
        "TBC1D22B_154S"
    ],
    "TBC1D25": [
        "TBC1D25_506S"
    ],
    "TBC1D2B": [
        "TBC1D2B_155S",
        "TBC1D2B_473S",
        "TBC1D2B_957S"
    ],
    "TBC1D4": [
        "TBC1D4_106S",
        "TBC1D4_588S",
        "TBC1D4_591S"
    ],
    "TBC1D5": [
        "TBC1D5_43S",
        "TBC1D5_522S",
        "TBC1D5_541S",
        "TBC1D5_544S",
        "TBC1D5_554S",
        "TBC1D5_558S"
    ],
    "TBC1D9B": [
        "TBC1D9B_995S"
    ],
    "TBCK": [
        "TBCK_890S"
    ],
    "TBX2": [
        "TBX2_386S",
        "TBX2_678S"
    ],
    "TCEA1": [
        "TCEA1_100S"
    ],
    "TCEAL3": [
        "TCEAL3_121S",
        "TCEAL3_65S"
    ],
    "TCF12": [
        "TCF12_540S",
        "TCF12_559S"
    ],
    "TCF20": [
        "TCF20_1764T"
    ],
    "TCF4": [
        "TCF4_511S"
    ],
    "TCOF1": [
        "TCOF1_1227S",
        "TCOF1_1228S",
        "TCOF1_1350S",
        "TCOF1_1378S",
        "TCOF1_156S",
        "TCOF1_171S",
        "TCOF1_233S",
        "TCOF1_381S",
        "TCOF1_446S",
        "TCOF1_906S",
        "TCOF1_941S"
    ],
    "TCP11L1": [
        "TCP11L1_55S"
    ],
    "TDRD5": [
        "TDRD5_103S"
    ],
    "TECR": [
        "TECR_58S"
    ],
    "TELO2": [
        "TELO2_836S"
    ],
    "TEP1": [
        "TEP1_397S"
    ],
    "TERF2": [
        "TERF2_365S"
    ],
    "TES": [
        "TES_168S"
    ],
    "TESK1": [
        "TESK1_437S",
        "TESK1_440S"
    ],
    "TET2": [
        "TET2_75S",
        "TET2_99S"
    ],
    "TEX2": [
        "TEX2_196S",
        "TEX2_266S",
        "TEX2_269T",
        "TEX2_736S",
        "TEX2_751S",
        "TEX2_790S",
        "TEX2_794S",
        "TEX2_801S"
    ],
    "TFAP4": [
        "TFAP4_124S"
    ],
    "TFIP11": [
        "TFIP11_59S",
        "TFIP11_98S"
    ],
    "TFPT": [
        "TFPT_252S"
    ],
    "TGFB1I1": [
        "TGFB1I1_137S",
        "TGFB1I1_140S",
        "TGFB1I1_141S",
        "TGFB1I1_143S",
        "TGFB1I1_194S",
        "TGFB1I1_68S"
    ],
    "TGOLN2": [
        "TGOLN2_296T",
        "TGOLN2_298S",
        "TGOLN2_71S"
    ],
    "THOC1": [
        "THOC1_4T",
        "THOC1_560S"
    ],
    "THOC2": [
        "THOC2_1285T",
        "THOC2_1289T"
    ],
    "THRAP3": [
        "THRAP3_243S",
        "THRAP3_315S",
        "THRAP3_320S",
        "THRAP3_323S",
        "THRAP3_379S",
        "THRAP3_698S"
    ],
    "THUMPD1": [
        "THUMPD1_86S",
        "THUMPD1_88S"
    ],
    "TIMELESS": [
        "TIMELESS_1173S"
    ],
    "TJAP1": [
        "TJAP1_300S",
        "TJAP1_545S"
    ],
    "TJP1": [
        "TJP1_125S",
        "TJP1_131S",
        "TJP1_313S",
        "TJP1_315S",
        "TJP1_329S",
        "TJP1_912S"
    ],
    "TJP2": [
        "TJP2_1067S",
        "TJP2_1068S",
        "TJP2_130S",
        "TJP2_170S",
        "TJP2_174S",
        "TJP2_244S",
        "TJP2_266S",
        "TJP2_292S",
        "TJP2_294S",
        "TJP2_296S",
        "TJP2_415S",
        "TJP2_440S",
        "TJP2_441S",
        "TJP2_978S",
        "TJP2_986S"
    ],
    "TK1": [
        "TK1_13S"
    ],
    "TLE3": [
        "TLE3_203S"
    ],
    "TLE5": [
        "TLE5_196S"
    ],
    "TLN2": [
        "TLN2_1843T"
    ],
    "TMBIM1": [
        "TMBIM1_81S",
        "TMBIM1_83S"
    ],
    "TMCC3": [
        "TMCC3_216S"
    ],
    "TMEM115": [
        "TMEM115_320S",
        "TMEM115_329T"
    ],
    "TMEM132A": [
        "TMEM132A_529S",
        "TMEM132A_913S"
    ],
    "TMEM154": [
        "TMEM154_115S"
    ],
    "TMEM184B": [
        "TMEM184B_388S",
        "TMEM184B_402S",
        "TMEM184B_403S"
    ],
    "TMEM192": [
        "TMEM192_230S"
    ],
    "TMEM201": [
        "TMEM201_440T",
        "TMEM201_441S",
        "TMEM201_529S"
    ],
    "TMEM209": [
        "TMEM209_98S"
    ],
    "TMEM245": [
        "TMEM245_15S",
        "TMEM245_36T"
    ],
    "TMEM247": [
        "TMEM247_38Y",
        "TMEM247_43S"
    ],
    "TMEM259": [
        "TMEM259_29T"
    ],
    "TMEM40": [
        "TMEM40_137S"
    ],
    "TMEM45A": [
        "TMEM45A_271S"
    ],
    "TMEM63B": [
        "TMEM63B_114S",
        "TMEM63B_115S"
    ],
    "TMEM87A": [
        "TMEM87A_475S"
    ],
    "TMEM94": [
        "TMEM94_445S"
    ],
    "TMF1": [
        "TMF1_170S",
        "TMF1_340S",
        "TMF1_344S",
        "TMF1_399S",
        "TMF1_401T"
    ],
    "TMPO": [
        "TMPO_158S",
        "TMPO_160T",
        "TMPO_167S",
        "TMPO_168S",
        "TMPO_177S",
        "TMPO_180S",
        "TMPO_184S",
        "TMPO_208T",
        "TMPO_306S",
        "TMPO_424S",
        "TMPO_66S",
        "TMPO_67S",
        "TMPO_74T"
    ],
    "TMX1": [
        "TMX1_247S",
        "TMX1_270S"
    ],
    "TNC": [
        "TNC_62S",
        "TNC_70S",
        "TNC_72S"
    ],
    "TNFAIP3": [
        "TNFAIP3_575S"
    ],
    "TNFRSF19": [
        "TNFRSF19_241S"
    ],
    "TNIK": [
        "TNIK_764S",
        "TNIK_769S"
    ],
    "TNKS1BP1": [
        "TNKS1BP1_1138S",
        "TNKS1BP1_1140S",
        "TNKS1BP1_131T",
        "TNKS1BP1_1328S",
        "TNKS1BP1_1385S",
        "TNKS1BP1_1545S",
        "TNKS1BP1_1620S",
        "TNKS1BP1_1621S",
        "TNKS1BP1_1652S",
        "TNKS1BP1_1666S",
        "TNKS1BP1_178S",
        "TNKS1BP1_221S",
        "TNKS1BP1_228S",
        "TNKS1BP1_239T",
        "TNKS1BP1_369S",
        "TNKS1BP1_429S",
        "TNKS1BP1_592S",
        "TNKS1BP1_601S",
        "TNKS1BP1_672S",
        "TNKS1BP1_691S",
        "TNKS1BP1_712S",
        "TNKS1BP1_836S",
        "TNKS1BP1_851S",
        "TNKS1BP1_872S",
        "TNKS1BP1_899S",
        "TNKS1BP1_919S",
        "TNKS1BP1_920S",
        "TNKS1BP1_983S"
    ],
    "TNPO1": [
        "TNPO1_32S"
    ],
    "TNRC18": [
        "TNRC18_1127S",
        "TNRC18_1359S",
        "TNRC18_1857S",
        "TNRC18_1925S",
        "TNRC18_2146T",
        "TNRC18_991S",
        "TNRC18_999S"
    ],
    "TNRC6B": [
        "TNRC6B_1336S",
        "TNRC6B_879S"
    ],
    "TNRC6C": [
        "TNRC6C_714S"
    ],
    "TNS1": [
        "TNS1_1383T",
        "TNS1_1393S",
        "TNS1_338S",
        "TNS1_899S",
        "TNS1_907S",
        "TNS1_971S"
    ],
    "TNS2": [
        "TNS2_91T",
        "TNS2_931S"
    ],
    "TNS3": [
        "TNS3_1149S",
        "TNS3_1154S",
        "TNS3_1441S",
        "TNS3_632T",
        "TNS3_660S",
        "TNS3_953S",
        "TNS3_969S"
    ],
    "TOB1": [
        "TOB1_268S"
    ],
    "TOE1": [
        "TOE1_428S",
        "TOE1_5S"
    ],
    "TOMM34": [
        "TOMM34_186S"
    ],
    "TOMM70": [
        "TOMM70_91S"
    ],
    "TOP2A": [
        "TOP2A_1106S",
        "TOP2A_1213S",
        "TOP2A_1247S",
        "TOP2A_1377S"
    ],
    "TOP2B": [
        "TOP2B_1400S",
        "TOP2B_1413S",
        "TOP2B_1466S",
        "TOP2B_1522S",
        "TOP2B_1524S",
        "TOP2B_1550S",
        "TOP2B_1552S",
        "TOP2B_1581S"
    ],
    "TOR1AIP1": [
        "TOR1AIP1_143S",
        "TOR1AIP1_156S",
        "TOR1AIP1_157S",
        "TOR1AIP1_242S",
        "TOR1AIP1_245S",
        "TOR1AIP1_315S"
    ],
    "TOR1AIP2": [
        "TOR1AIP2_120S"
    ],
    "TOX2": [
        "TOX2_312S"
    ],
    "TP53": [
        "TP53_315S"
    ],
    "TP53BP1": [
        "TP53BP1_1028S",
        "TP53BP1_1055T",
        "TP53BP1_1056T",
        "TP53BP1_1067S",
        "TP53BP1_1068S",
        "TP53BP1_1094S",
        "TP53BP1_1101S",
        "TP53BP1_1113S",
        "TP53BP1_1114S",
        "TP53BP1_1362S",
        "TP53BP1_1430S",
        "TP53BP1_1462S",
        "TP53BP1_1656S",
        "TP53BP1_1678S",
        "TP53BP1_1758S",
        "TP53BP1_1759S",
        "TP53BP1_265S",
        "TP53BP1_294S",
        "TP53BP1_316S",
        "TP53BP1_379S",
        "TP53BP1_380S",
        "TP53BP1_500S",
        "TP53BP1_580S",
        "TP53BP1_727S",
        "TP53BP1_831S"
    ],
    "TP63": [
        "TP63_395S",
        "TP63_463S",
        "TP63_612S"
    ],
    "TP73": [
        "TP73_333S"
    ],
    "TPCN1": [
        "TPCN1_766S"
    ],
    "TPD52L2": [
        "TPD52L2_12S",
        "TPD52L2_166S",
        "TPD52L2_21S",
        "TPD52L2_23T"
    ],
    "TPGS1": [
        "TPGS1_266S"
    ],
    "TPI1": [
        "TPI1_117S",
        "TPI1_249S",
        "TPI1_58S"
    ],
    "TPM3": [
        "TPM3_88S"
    ],
    "TPRN": [
        "TPRN_418S"
    ],
    "TRAF1": [
        "TRAF1_66S"
    ],
    "TRAFD1": [
        "TRAFD1_327S",
        "TRAFD1_415S"
    ],
    "TRAM1": [
        "TRAM1_365S"
    ],
    "TRAPPC12": [
        "TRAPPC12_182S",
        "TRAPPC12_184S"
    ],
    "TRAPPC8": [
        "TRAPPC8_1090S"
    ],
    "TRERF1": [
        "TRERF1_491S",
        "TRERF1_621S",
        "TRERF1_758S"
    ],
    "TREX1": [
        "TREX1_167S"
    ],
    "TRIM11": [
        "TRIM11_85S"
    ],
    "TRIM16": [
        "TRIM16_60S"
    ],
    "TRIM21": [
        "TRIM21_266S"
    ],
    "TRIM22": [
        "TRIM22_87S"
    ],
    "TRIM24": [
        "TRIM24_1025S",
        "TRIM24_1028S",
        "TRIM24_811S"
    ],
    "TRIM25": [
        "TRIM25_100S"
    ],
    "TRIM28": [
        "TRIM28_19S",
        "TRIM28_473S",
        "TRIM28_541T",
        "TRIM28_697S",
        "TRIM28_752S"
    ],
    "TRIM33": [
        "TRIM33_862S"
    ],
    "TRIM40": [
        "TRIM40_248S"
    ],
    "TRIM42": [
        "TRIM42_336S",
        "TRIM42_339S"
    ],
    "TRIM44": [
        "TRIM44_339S"
    ],
    "TRIM47": [
        "TRIM47_588S"
    ],
    "TRIM56": [
        "TRIM56_442T",
        "TRIM56_475S"
    ],
    "TRIO": [
        "TRIO_1723S",
        "TRIO_1724S",
        "TRIO_1785S",
        "TRIO_1786S",
        "TRIO_2428S",
        "TRIO_2455S",
        "TRIO_2477S",
        "TRIO_2631S"
    ],
    "TRIP10": [
        "TRIP10_296S"
    ],
    "TRIP12": [
        "TRIP12_1016S",
        "TRIP12_163S",
        "TRIP12_312S",
        "TRIP12_515S",
        "TRIP12_516S",
        "TRIP12_77S"
    ],
    "TRIT1": [
        "TRIT1_455S"
    ],
    "TRMT1": [
        "TRMT1_625S"
    ],
    "TRMT13": [
        "TRMT13_397S"
    ],
    "TRMT61A": [
        "TRMT61A_46S"
    ],
    "TRPM6": [
        "TRPM6_1986S"
    ],
    "TRPT1": [
        "TRPT1_240S"
    ],
    "TSC2": [
        "TSC2_1132S",
        "TSC2_1254S",
        "TSC2_1411S",
        "TSC2_1452S"
    ],
    "TSC22D3": [
        "TSC22D3_122S"
    ],
    "TSC22D4": [
        "TSC22D4_279S",
        "TSC22D4_62S"
    ],
    "TSHZ1": [
        "TSHZ1_489S"
    ],
    "TSR3": [
        "TSR3_261T"
    ],
    "TSSC4": [
        "TSSC4_132S",
        "TSSC4_321S"
    ],
    "TTC28": [
        "TTC28_2108S",
        "TTC28_2224S",
        "TTC28_28S",
        "TTC28_47S"
    ],
    "TTC33": [
        "TTC33_194T",
        "TTC33_197S"
    ],
    "TTC39B": [
        "TTC39B_524S"
    ],
    "TTC7A": [
        "TTC7A_51S",
        "TTC7A_647S"
    ],
    "TTK": [
        "TTK_436S"
    ],
    "TUBA1B": [
        "TUBA1B_158S",
        "TUBA1B_340S",
        "TUBA1B_48S",
        "TUBA1B_54S"
    ],
    "TUSC1": [
        "TUSC1_153S"
    ],
    "TWF1": [
        "TWF1_142S",
        "TWF1_349T"
    ],
    "TWISTNB": [
        "TWISTNB_316S",
        "TWISTNB_322T",
        "TWISTNB_328S",
        "TWISTNB_60S"
    ],
    "TXLNA": [
        "TXLNA_18S",
        "TXLNA_19S",
        "TXLNA_515S"
    ],
    "TXLNG": [
        "TXLNG_105S"
    ],
    "TXNRD3": [
        "TXNRD3_32S",
        "TXNRD3_4S"
    ],
    "U2AF1L5": [
        "U2AF1L5_61S"
    ],
    "UBA1": [
        "UBA1_13S",
        "UBA1_28S",
        "UBA1_46S",
        "UBA1_835S"
    ],
    "UBA52": [
        "UBA52_57S"
    ],
    "UBAC1": [
        "UBAC1_98S"
    ],
    "UBAP1": [
        "UBAP1_146S"
    ],
    "UBAP2L": [
        "UBAP2L_453S",
        "UBAP2L_454S",
        "UBAP2L_467S",
        "UBAP2L_608S",
        "UBAP2L_609S"
    ],
    "UBE2E2": [
        "UBE2E2_11S",
        "UBE2E2_18S"
    ],
    "UBE2E3": [
        "UBE2E3_8S"
    ],
    "UBE2J1": [
        "UBE2J1_251S",
        "UBE2J1_266S"
    ],
    "UBE2O": [
        "UBE2O_399S",
        "UBE2O_515S",
        "UBE2O_839S",
        "UBE2O_87S",
        "UBE2O_896S"
    ],
    "UBL7": [
        "UBL7_230S"
    ],
    "UBN1": [
        "UBN1_173S",
        "UBN1_493S"
    ],
    "UBR1": [
        "UBR1_21T"
    ],
    "UBR3": [
        "UBR3_302S"
    ],
    "UBR4": [
        "UBR4_178S",
        "UBR4_181S",
        "UBR4_2719S",
        "UBR4_2724T",
        "UBR4_362S",
        "UBR4_619S",
        "UBR4_620S",
        "UBR4_905T"
    ],
    "UBR7": [
        "UBR7_264S"
    ],
    "UBTF": [
        "UBTF_484S"
    ],
    "UCKL1": [
        "UCKL1_16S",
        "UCKL1_56S"
    ],
    "UFD1": [
        "UFD1_247S"
    ],
    "UHRF1": [
        "UHRF1_91S"
    ],
    "UHRF1BP1L": [
        "UHRF1BP1L_414S",
        "UHRF1BP1L_418S",
        "UHRF1BP1L_989S"
    ],
    "UHRF2": [
        "UHRF2_667S",
        "UHRF2_673S"
    ],
    "UIMC1": [
        "UIMC1_677S"
    ],
    "ULK1": [
        "ULK1_556S"
    ],
    "UNG": [
        "UNG_23S"
    ],
    "UNK": [
        "UNK_385S"
    ],
    "UNKL": [
        "UNKL_344S"
    ],
    "UPF3B": [
        "UPF3B_310S"
    ],
    "UPP1": [
        "UPP1_61S"
    ],
    "UQCRC1": [
        "UQCRC1_107S"
    ],
    "URI1": [
        "URI1_442S",
        "URI1_492T"
    ],
    "USO1": [
        "USO1_942S"
    ],
    "USP1": [
        "USP1_313S",
        "USP1_475S",
        "USP1_67S"
    ],
    "USP10": [
        "USP10_211S",
        "USP10_365S",
        "USP10_718S"
    ],
    "USP15": [
        "USP15_229S"
    ],
    "USP16": [
        "USP16_415S"
    ],
    "USP20": [
        "USP20_132S",
        "USP20_134S"
    ],
    "USP24": [
        "USP24_1141S",
        "USP24_1143S",
        "USP24_1612S",
        "USP24_1925S",
        "USP24_1943S",
        "USP24_2047S",
        "USP24_2077S",
        "USP24_2330S",
        "USP24_2561S",
        "USP24_2604S"
    ],
    "USP33": [
        "USP33_377S"
    ],
    "USP34": [
        "USP34_3384S",
        "USP34_3386S",
        "USP34_3406S"
    ],
    "USP36": [
        "USP36_18S",
        "USP36_546S",
        "USP36_742S"
    ],
    "USP39": [
        "USP39_82S",
        "USP39_97S"
    ],
    "USP4": [
        "USP4_680S"
    ],
    "USP47": [
        "USP47_832S"
    ],
    "USP5": [
        "USP5_623T",
        "USP5_783S"
    ],
    "USP8": [
        "USP8_577T"
    ],
    "UTP14A": [
        "UTP14A_445S"
    ],
    "UTP18": [
        "UTP18_121S",
        "UTP18_124S",
        "UTP18_205S",
        "UTP18_206S",
        "UTP18_210S"
    ],
    "UTP20": [
        "UTP20_1741T",
        "UTP20_2064T",
        "UTP20_2601S"
    ],
    "VAMP3": [
        "VAMP3_44S",
        "VAMP3_63S"
    ],
    "VAMP4": [
        "VAMP4_30S"
    ],
    "VANGL2": [
        "VANGL2_517S",
        "VANGL2_520S"
    ],
    "VAPB": [
        "VAPB_158S",
        "VAPB_160S"
    ],
    "VASP": [
        "VASP_239S"
    ],
    "VCAN": [
        "VCAN_2116S"
    ],
    "VCL": [
        "VCL_272S",
        "VCL_290S",
        "VCL_345S",
        "VCL_346S",
        "VCL_378T",
        "VCL_434S",
        "VCL_442T",
        "VCL_566S",
        "VCL_604T",
        "VCL_721S",
        "VCL_795S",
        "VCL_822Y"
    ],
    "VDAC1": [
        "VDAC1_104S"
    ],
    "VDAC2": [
        "VDAC2_115S"
    ],
    "VIM": [
        "VIM_205S",
        "VIM_214S",
        "VIM_226S",
        "VIM_299S",
        "VIM_325S",
        "VIM_327T",
        "VIM_339S",
        "VIM_39S",
        "VIM_420S",
        "VIM_430S",
        "VIM_436T",
        "VIM_438S",
        "VIM_459S",
        "VIM_56S",
        "VIM_73S"
    ],
    "VIPAS39": [
        "VIPAS39_121S",
        "VIPAS39_93S"
    ],
    "VIRMA": [
        "VIRMA_133S",
        "VIRMA_138S",
        "VIRMA_1579S",
        "VIRMA_173S",
        "VIRMA_222S"
    ],
    "VPS13B": [
        "VPS13B_102S",
        "VPS13B_105S",
        "VPS13B_1262T"
    ],
    "VPS13C": [
        "VPS13C_3641S",
        "VPS13C_737S"
    ],
    "VPS13D": [
        "VPS13D_1138S",
        "VPS13D_1761T",
        "VPS13D_1765S",
        "VPS13D_2079S",
        "VPS13D_2671S",
        "VPS13D_2692S"
    ],
    "VPS4A": [
        "VPS4A_95S",
        "VPS4A_97S",
        "VPS4A_99S"
    ],
    "VPS4B": [
        "VPS4B_102S"
    ],
    "VPS50": [
        "VPS50_494S"
    ],
    "VPS8": [
        "VPS8_19S"
    ],
    "VSIG4": [
        "VSIG4_72S",
        "VSIG4_73S"
    ],
    "WAC": [
        "WAC_511S"
    ],
    "WAPL": [
        "WAPL_221S",
        "WAPL_226S"
    ],
    "WARS": [
        "WARS_467S"
    ],
    "WASHC2A": [
        "WASHC2A_1075S",
        "WASHC2A_1179S",
        "WASHC2A_1180S",
        "WASHC2A_158S",
        "WASHC2A_331T",
        "WASHC2A_333S",
        "WASHC2A_5T",
        "WASHC2A_6T"
    ],
    "WASHC4": [
        "WASHC4_1157S",
        "WASHC4_1162S"
    ],
    "WBP4": [
        "WBP4_262S"
    ],
    "WDR20": [
        "WDR20_434S"
    ],
    "WDR33": [
        "WDR33_1210S"
    ],
    "WDR4": [
        "WDR4_391S"
    ],
    "WDR43": [
        "WDR43_77S"
    ],
    "WDR44": [
        "WDR44_162S",
        "WDR44_219T",
        "WDR44_262S",
        "WDR44_403S",
        "WDR44_50S",
        "WDR44_561S",
        "WDR44_565S"
    ],
    "WDR55": [
        "WDR55_14S"
    ],
    "WDR62": [
        "WDR62_1228S",
        "WDR62_33S"
    ],
    "WDR7": [
        "WDR7_935S"
    ],
    "WDR74": [
        "WDR74_361S"
    ],
    "WDR75": [
        "WDR75_779S",
        "WDR75_782S",
        "WDR75_796S"
    ],
    "WDR77": [
        "WDR77_5T"
    ],
    "WDTC1": [
        "WDTC1_511S"
    ],
    "WEE1": [
        "WEE1_165S",
        "WEE1_67S"
    ],
    "WIPI2": [
        "WIPI2_413S"
    ],
    "WIZ": [
        "WIZ_983S"
    ],
    "WNK1": [
        "WNK1_167S",
        "WNK1_174S",
        "WNK1_2011S",
        "WNK1_2012S",
        "WNK1_2027S",
        "WNK1_2032S"
    ],
    "WRAP53": [
        "WRAP53_491S",
        "WRAP53_54S"
    ],
    "WRN": [
        "WRN_1133S"
    ],
    "WTAP": [
        "WTAP_306S"
    ],
    "WWP2": [
        "WWP2_211S"
    ],
    "XPC": [
        "XPC_398S",
        "XPC_399S",
        "XPC_94S"
    ],
    "XPNPEP1": [
        "XPNPEP1_556S"
    ],
    "XPO6": [
        "XPO6_204T",
        "XPO6_208S"
    ],
    "XRCC1": [
        "XRCC1_241S",
        "XRCC1_266S",
        "XRCC1_446S",
        "XRCC1_447S",
        "XRCC1_453T"
    ],
    "XRCC4": [
        "XRCC4_327S"
    ],
    "XRCC5": [
        "XRCC5_244S"
    ],
    "XRCC6": [
        "XRCC6_455T",
        "XRCC6_520S",
        "XRCC6_560S"
    ],
    "XRN2": [
        "XRN2_448S"
    ],
    "YAP1": [
        "YAP1_109S",
        "YAP1_110T",
        "YAP1_127S",
        "YAP1_163S",
        "YAP1_164S",
        "YAP1_61S"
    ],
    "YIPF1": [
        "YIPF1_43S"
    ],
    "YJU2": [
        "YJU2_211S",
        "YJU2_213S"
    ],
    "YRDC": [
        "YRDC_37S",
        "YRDC_60S"
    ],
    "YTHDC1": [
        "YTHDC1_146S",
        "YTHDC1_148T",
        "YTHDC1_152S",
        "YTHDC1_308S"
    ],
    "YTHDC2": [
        "YTHDC2_1090S",
        "YTHDC2_1202S"
    ],
    "YY1AP1": [
        "YY1AP1_711S"
    ],
    "ZBED4": [
        "ZBED4_623S"
    ],
    "ZBTB11": [
        "ZBTB11_1050S"
    ],
    "ZBTB17": [
        "ZBTB17_120S"
    ],
    "ZBTB21": [
        "ZBTB21_1003S",
        "ZBTB21_431T",
        "ZBTB21_435S",
        "ZBTB21_714S",
        "ZBTB21_979T",
        "ZBTB21_981S",
        "ZBTB21_983S"
    ],
    "ZBTB7A": [
        "ZBTB7A_337S",
        "ZBTB7A_525S",
        "ZBTB7A_526S",
        "ZBTB7A_549S"
    ],
    "ZC3H11A": [
        "ZC3H11A_108S",
        "ZC3H11A_132S",
        "ZC3H11A_290S",
        "ZC3H11A_758S",
        "ZC3H11A_761S"
    ],
    "ZC3H12A": [
        "ZC3H12A_99S"
    ],
    "ZC3H13": [
        "ZC3H13_1017S",
        "ZC3H13_1033T",
        "ZC3H13_109S",
        "ZC3H13_110S",
        "ZC3H13_1191S",
        "ZC3H13_1208S",
        "ZC3H13_1279S",
        "ZC3H13_1438S",
        "ZC3H13_198S",
        "ZC3H13_207S",
        "ZC3H13_209S",
        "ZC3H13_263T",
        "ZC3H13_265S",
        "ZC3H13_318S",
        "ZC3H13_325S",
        "ZC3H13_364T",
        "ZC3H13_642S",
        "ZC3H13_643S",
        "ZC3H13_77S",
        "ZC3H13_831S",
        "ZC3H13_833S",
        "ZC3H13_837S",
        "ZC3H13_877S",
        "ZC3H13_986S",
        "ZC3H13_993S"
    ],
    "ZC3H14": [
        "ZC3H14_343S",
        "ZC3H14_409S",
        "ZC3H14_515S",
        "ZC3H14_620S"
    ],
    "ZC3H15": [
        "ZC3H15_381S"
    ],
    "ZC3H18": [
        "ZC3H18_117S",
        "ZC3H18_118S",
        "ZC3H18_162T",
        "ZC3H18_34S",
        "ZC3H18_46S",
        "ZC3H18_534S",
        "ZC3H18_677T",
        "ZC3H18_67S",
        "ZC3H18_74S",
        "ZC3H18_842S",
        "ZC3H18_852S",
        "ZC3H18_868S",
        "ZC3H18_95S"
    ],
    "ZC3H8": [
        "ZC3H8_59S"
    ],
    "ZC3HAV1": [
        "ZC3HAV1_275S",
        "ZC3HAV1_284S"
    ],
    "ZC3HC1": [
        "ZC3HC1_321S",
        "ZC3HC1_335S",
        "ZC3HC1_344S",
        "ZC3HC1_354S",
        "ZC3HC1_370S",
        "ZC3HC1_372T",
        "ZC3HC1_394S",
        "ZC3HC1_395S",
        "ZC3HC1_407S",
        "ZC3HC1_410S",
        "ZC3HC1_62S"
    ],
    "ZCCHC8": [
        "ZCCHC8_479T",
        "ZCCHC8_648T",
        "ZCCHC8_658S"
    ],
    "ZDBF2": [
        "ZDBF2_283S"
    ],
    "ZDHHC5": [
        "ZDHHC5_380S",
        "ZDHHC5_593S"
    ],
    "ZFC3H1": [
        "ZFC3H1_1303S",
        "ZFC3H1_1304S",
        "ZFC3H1_655S"
    ],
    "ZFHX3": [
        "ZFHX3_1590S",
        "ZFHX3_2795S",
        "ZFHX3_426S"
    ],
    "ZFP36L1": [
        "ZFP36L1_54S",
        "ZFP36L1_92S"
    ],
    "ZFP36L2": [
        "ZFP36L2_125S",
        "ZFP36L2_426S",
        "ZFP36L2_438S",
        "ZFP36L2_448S"
    ],
    "ZFP91": [
        "ZFP91_101S",
        "ZFP91_83S"
    ],
    "ZFR": [
        "ZFR_1054S"
    ],
    "ZFYVE16": [
        "ZFYVE16_946S"
    ],
    "ZFYVE19": [
        "ZFYVE19_144S",
        "ZFYVE19_354S",
        "ZFYVE19_460S"
    ],
    "ZFYVE26": [
        "ZFYVE26_297S"
    ],
    "ZFYVE9": [
        "ZFYVE9_668S"
    ],
    "ZHX3": [
        "ZHX3_946S"
    ],
    "ZKSCAN1": [
        "ZKSCAN1_13S"
    ],
    "ZKSCAN8": [
        "ZKSCAN8_12S",
        "ZKSCAN8_193S"
    ],
    "ZMYM3": [
        "ZMYM3_462T",
        "ZMYM3_51S"
    ],
    "ZMYM4": [
        "ZMYM4_1547S"
    ],
    "ZMYND8": [
        "ZMYND8_406S",
        "ZMYND8_425S",
        "ZMYND8_490S",
        "ZMYND8_547S",
        "ZMYND8_668S",
        "ZMYND8_682S",
        "ZMYND8_756S"
    ],
    "ZNF106": [
        "ZNF106_1026S",
        "ZNF106_1279S",
        "ZNF106_1370S",
        "ZNF106_640T"
    ],
    "ZNF148": [
        "ZNF148_306S"
    ],
    "ZNF263": [
        "ZNF263_166S"
    ],
    "ZNF275": [
        "ZNF275_305S",
        "ZNF275_309T"
    ],
    "ZNF276": [
        "ZNF276_599S"
    ],
    "ZNF280C": [
        "ZNF280C_80S"
    ],
    "ZNF316": [
        "ZNF316_10S"
    ],
    "ZNF318": [
        "ZNF318_1037S",
        "ZNF318_1243S",
        "ZNF318_136S",
        "ZNF318_39S",
        "ZNF318_40S",
        "ZNF318_527S",
        "ZNF318_709S"
    ],
    "ZNF358": [
        "ZNF358_489T"
    ],
    "ZNF362": [
        "ZNF362_401S",
        "ZNF362_404S"
    ],
    "ZNF423": [
        "ZNF423_383T"
    ],
    "ZNF428": [
        "ZNF428_99S"
    ],
    "ZNF446": [
        "ZNF446_3S"
    ],
    "ZNF462": [
        "ZNF462_688S"
    ],
    "ZNF512B": [
        "ZNF512B_852T"
    ],
    "ZNF516": [
        "ZNF516_116S"
    ],
    "ZNF532": [
        "ZNF532_298S",
        "ZNF532_314S",
        "ZNF532_350S",
        "ZNF532_434S"
    ],
    "ZNF574": [
        "ZNF574_164S"
    ],
    "ZNF579": [
        "ZNF579_482T",
        "ZNF579_483S"
    ],
    "ZNF592": [
        "ZNF592_1089S",
        "ZNF592_334S",
        "ZNF592_348S",
        "ZNF592_368S",
        "ZNF592_460S",
        "ZNF592_679S",
        "ZNF592_680S",
        "ZNF592_78S"
    ],
    "ZNF609": [
        "ZNF609_1055S",
        "ZNF609_358S",
        "ZNF609_491S",
        "ZNF609_576S",
        "ZNF609_578S"
    ],
    "ZNF618": [
        "ZNF618_176S",
        "ZNF618_429S"
    ],
    "ZNF622": [
        "ZNF622_143S"
    ],
    "ZNF629": [
        "ZNF629_28S"
    ],
    "ZNF638": [
        "ZNF638_1401S",
        "ZNF638_605S"
    ],
    "ZNF687": [
        "ZNF687_1057S",
        "ZNF687_1191S",
        "ZNF687_183S",
        "ZNF687_253S",
        "ZNF687_374S",
        "ZNF687_377T",
        "ZNF687_433S"
    ],
    "ZNF692": [
        "ZNF692_231S"
    ],
    "ZNF768": [
        "ZNF768_125S",
        "ZNF768_132S",
        "ZNF768_139S",
        "ZNF768_83S",
        "ZNF768_90S",
        "ZNF768_97S"
    ],
    "ZNF770": [
        "ZNF770_636S"
    ],
    "ZNF777": [
        "ZNF777_47S"
    ],
    "ZNF787": [
        "ZNF787_46S"
    ],
    "ZNF830": [
        "ZNF830_225S"
    ],
    "ZNF91": [
        "ZNF91_251S",
        "ZNF91_254T"
    ],
    "ZNHIT3": [
        "ZNHIT3_80S"
    ],
    "ZNHIT6": [
        "ZNHIT6_25S"
    ],
    "ZNRF2": [
        "ZNRF2_135S",
        "ZNRF2_82S"
    ],
    "ZRANB1": [
        "ZRANB1_113T"
    ],
    "ZRSR2": [
        "ZRSR2_349S",
        "ZRSR2_384S",
        "ZRSR2_388S"
    ],
    "ZSCAN5B": [
        "ZSCAN5B_294S",
        "ZSCAN5B_295S"
    ],
    "ZSWIM8": [
        "ZSWIM8_1130S",
        "ZSWIM8_48S",
        "ZSWIM8_53S",
        "ZSWIM8_567S"
    ],
    "ZYX": [
        "ZYX_267S",
        "ZYX_344S"
    ],
    "ZZEF1": [
        "ZZEF1_1518S",
        "ZZEF1_2444S"
    ],
    "ZZZ3": [
        "ZZZ3_113S",
        "ZZZ3_606S"
    ]
};

export default AllGeneListMatch;